var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g24, _path130, _path131, _path132, _path133, _path134, _path135, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _g47, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _g48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 629.401,
    height: 531.874,
    viewBox: "0 0 629.401 531.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_826",
    "data-name": "Ret\\xE2ngulo 826",
    width: 629.401,
    height: 500.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_775",
    "data-name": "Ret\\xE2ngulo 775",
    width: 629.4,
    height: 500.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_774",
    "data-name": "Ret\\xE2ngulo 774",
    width: 447.453,
    height: 271.689,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_754",
    "data-name": "Ret\\xE2ngulo 754",
    width: 185.304,
    height: 119.167,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_755",
    "data-name": "Ret\\xE2ngulo 755",
    width: 185.304,
    height: 119.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_756",
    "data-name": "Ret\\xE2ngulo 756",
    width: 185.304,
    height: 119.168,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_760",
    "data-name": "Ret\\xE2ngulo 760",
    width: 185.305,
    height: 119.168,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_761",
    "data-name": "Ret\\xE2ngulo 761",
    width: 185.305,
    height: 119.167,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_763",
    "data-name": "Ret\\xE2ngulo 763",
    width: 185.304,
    height: 119.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_765",
    "data-name": "Ret\\xE2ngulo 765",
    width: 185.303,
    height: 119.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_767",
    "data-name": "Ret\\xE2ngulo 767",
    width: 185.303,
    height: 119.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_769",
    "data-name": "Ret\\xE2ngulo 769",
    width: 185.305,
    height: 119.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_770",
    "data-name": "Ret\\xE2ngulo 770",
    width: 185.305,
    height: 119.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1153",
    "data-name": "Caminho 1153",
    d: "M1300.309,1567.692a1.108,1.108,0,0,0,.654.913l14,8.085a2.421,2.421,0,0,0,.319.153c.086.034.176.064.268.091.075.021.152.04.23.056s.145.028.219.038.143.018.215.024.145.01.218.011.151,0,.227,0,.164-.008.245-.016.189-.022.282-.039a3.19,3.19,0,0,0,.419-.1,2.527,2.527,0,0,0,.486-.214l15.1-8.777.014-4.924-15.1,8.777a2.508,2.508,0,0,1-.485.214,3.24,3.24,0,0,1-.419.1c-.093.016-.187.03-.282.039s-.163.014-.245.016-.151,0-.226,0-.146-.005-.218-.011-.144-.014-.215-.024-.147-.023-.219-.038-.155-.035-.23-.056c-.092-.026-.182-.057-.269-.091a2.432,2.432,0,0,1-.319-.153l-14-8.085a1.108,1.108,0,0,1-.654-.912Z",
    transform: "translate(-1300.309 -1562.769)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -11.091,
    y1: 4.336,
    x2: -11.083,
    y2: 4.336,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#37393a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#464748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#4c4d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1154",
    "data-name": "Caminho 1154",
    d: "M1300.373,1560.2a1.029,1.029,0,0,0,.631,1.053l0-.014.006.018,14,8.085a2.176,2.176,0,0,0,.2.1l.019.01.06.024.106.042.028.011.072.023.081.026.026.008.1.025.06.015.014,0c.056.012.112.024.169.034l.032,0c.045.008.091.015.137.02l.027,0,.065.007.08.008.05,0,.074,0,.052,0h.183l.088,0,.083,0h.022l.081-.008.109-.01.022,0,.052-.008q.082-.011.163-.026l.038-.006.025-.007a3.124,3.124,0,0,0,.346-.092l.024-.006.041-.016c.043-.015.085-.032.127-.049l.075-.032c.043-.02.085-.041.126-.063.016-.008.033-.015.048-.024l.03-.017,15.1-8.777-.308-.76-14.948,8.687a3.1,3.1,0,0,1-2.816,0l-14-8.086c-.475-.274-.661-.651-.561-1.006-.072.169-.237.8-.237.8",
    transform: "translate(-1300.359 -1559.404)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -11.075,
    y1: 6.101,
    x2: -11.066,
    y2: 6.101,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#4a4b4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#4a4b4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#4c4d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#555658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#656668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#7a7b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#969799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#6f7173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#66686a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77797b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1157",
    "data-name": "Caminho 1157",
    d: "M1339.356,1564.917a2.347,2.347,0,0,1-2.129,0l-6.767-3.907a1.1,1.1,0,0,1-.284-.227l.2.225a.942.942,0,0,0,.243.193l6.767,3.907a2,2,0,0,0,1.818,0l7.438-4.323.313-.283Z",
    transform: "translate(-1330.176 -1560.504)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -22.255,
    y1: 12.794,
    x2: -22.238,
    y2: 12.794,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#4b4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#555658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696a6c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1158",
    "data-name": "Caminho 1158",
    d: "M1359.069,1501.291a.594.594,0,0,0-.073.01.582.582,0,0,0-.087.025.575.575,0,0,0-.334.374l-.1.283a.491.491,0,0,1,.285-.319.45.45,0,0,1,.074-.021.562.562,0,0,1,.062-.008.539.539,0,0,1,.056,0l.053,0,.051.008.048.011.048.014.048.018.047.02.049.023.048.027,6.769,3.908a1.412,1.412,0,0,1,.183.127,1.775,1.775,0,0,1,.171.16,2.083,2.083,0,0,1,.155.186c.038.052.072.106.1.16.012.018.024.036.035.055a2.225,2.225,0,0,1,.106.21,2.007,2.007,0,0,1,.083.225,1.8,1.8,0,0,1,.052.226,1.421,1.421,0,0,1,.017.208c0,.006,0,.011,0,.016l-.025,7.452a2,2,0,0,1-1,1.73l-.431.25.193.193a.783.783,0,0,1,.087.107l.461-.268a2.379,2.379,0,0,0,1.11-1.885l.021-7.452-.021-.012v-.168c0-.013,0-.026,0-.04s0-.044,0-.067,0-.044-.005-.067-.005-.045-.009-.067l0-.017c0-.021-.006-.036-.008-.051s-.008-.043-.013-.064-.01-.042-.015-.062-.01-.038-.015-.056l-.01-.034-.006-.018-.015-.047-.016-.046-.014-.038-.015-.039-.015-.037-.015-.035-.015-.035-.016-.035-.018-.037-.018-.037-.024-.045-.029-.053c-.02-.034-.034-.054-.048-.076-.028-.046-.056-.093-.087-.137l-.031-.044-.031-.042-.027-.035-.026-.031-.026-.031-.026-.031-.027-.03-.021-.023-.039-.04-.033-.032-.039-.036-.041-.036-.048-.04-.05-.04-.055-.04-.056-.038-.056-.034-6.767-3.907-.059-.032-.056-.027-.056-.024-.056-.02-.056-.017-.056-.013-.06-.009-.062,0h-.017l-.049,0",
    transform: "translate(-1358.48 -1501.289)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -22.472,
    y1: 4.499,
    x2: -22.456,
    y2: 4.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#737476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#828385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#808183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#797a7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#727375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#7b7c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#a0a1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#bcbdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#959799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#8c8e90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#78797b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78797b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1159",
    "data-name": "Caminho 1159",
    d: "M1385.216,1525.368l-.022,6.533a2,2,0,0,1-1,1.73l-.431.25.193.193a.769.769,0,0,1,.087.107l.461-.268a2.379,2.379,0,0,0,1.11-1.885l.019-6.814c-.14.053-.281.1-.422.153",
    transform: "translate(-1383.768 -1525.215)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -207.65,
    y1: 8.09,
    x2: -207.5,
    y2: 8.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c5054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4d5155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#53575a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#65686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7e80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1160",
    "data-name": "Caminho 1160",
    d: "M1329.777,1551.756a.554.554,0,0,0-.115.614.649.649,0,0,0,.08.133.844.844,0,0,0,.082.093.986.986,0,0,0,.083.072c.026.021.054.041.083.06l.07.043,6.767,3.907.015.009.084.044c.027.013.055.026.083.037l.049.019.034.013.082.028.082.024.068.017.087.019.069.013.067.01.056.007.056.006.046,0,.046,0,.043,0h.219l.036,0,.035,0,.036,0,.043,0,.019,0,.024,0,.051-.007.073-.012c.035-.006.07-.015.1-.022l.039-.009.024,0,.083-.023.051-.016.049-.016.043-.016.042-.017.045-.019.045-.021.052-.027.05-.028,6.6-3.834-.311-.282-6.443,3.745a1.388,1.388,0,0,1-.2.1,1.776,1.776,0,0,1-.213.065l-.033.007a2.079,2.079,0,0,1-.213.037,2.209,2.209,0,0,1-.246.014,2.144,2.144,0,0,1-.246-.014,2.015,2.015,0,0,1-.238-.041,1.777,1.777,0,0,1-.221-.067,1.425,1.425,0,0,1-.207-.1l-6.768-3.907c-.021-.011-.04-.024-.059-.036s-.049-.034-.071-.051a.89.89,0,0,1-.071-.062.691.691,0,0,1-.071-.079.58.58,0,0,1-.068-.114.473.473,0,0,1,.1-.524Z",
    transform: "translate(-1329.614 -1551.532)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -62.359,
    y1: 4.357,
    x2: -62.312,
    y2: 4.357,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#565758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#5d5e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#727375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7b7c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#a0a1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#bcbdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#959799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#8c8e90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#87898b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#717477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#606367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#54585c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#4d5155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c5054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1161",
    "data-name": "Caminho 1161",
    d: "M1361.086,1499.085a.485.485,0,0,0-.055,0c-.021,0-.042.005-.062.009a.526.526,0,0,0-.075.021.518.518,0,0,0-.086.04l-1.064.619a.554.554,0,0,1,.087-.04.565.565,0,0,1,.075-.021.583.583,0,0,1,.062-.009c.018,0,.037,0,.056,0l.05,0,.048,0,.047.008.044.01.044.012.043.014.043.016.043.018.043.021.044.023.034.019,6.767,3.907a1.662,1.662,0,0,1,.213.147,2.077,2.077,0,0,1,.2.188,2.38,2.38,0,0,1,.183.219,2.553,2.553,0,0,1,.155.237,2.715,2.715,0,0,1,.132.26,2.447,2.447,0,0,1,.1.265,2.006,2.006,0,0,1,.062.267,1.593,1.593,0,0,1,.021.26l-.025,7.631,1.065-.618.025-7.632c0-.016,0-.032,0-.048s0-.035,0-.052,0-.035,0-.052,0-.035-.006-.052,0-.036-.008-.053l-.009-.054-.012-.056c0-.019-.008-.037-.013-.056s-.01-.038-.015-.056-.009-.03-.013-.045c-.009-.03-.015-.049-.021-.067s-.012-.036-.019-.055l-.02-.052-.021-.052-.017-.04c-.012-.028-.02-.045-.028-.062l-.027-.056-.033-.064-.039-.069-.014-.025c-.026-.043-.052-.085-.08-.127s-.044-.065-.068-.1-.031-.042-.047-.062-.027-.034-.041-.051l-.041-.048-.042-.046-.044-.046-.045-.044-.047-.044-.048-.041-.024-.02-.024-.019-.047-.036-.047-.033-.046-.03-.046-.027-6.777-3.914-.034-.019-.044-.023-.043-.021-.043-.018-.043-.016-.043-.014-.044-.012-.044-.01-.047-.008-.047,0-.044,0h-.006",
    transform: "translate(-1359.743 -1499.085)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -23.208,
    y1: 4.759,
    x2: -23.191,
    y2: 4.759,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57595a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#57595a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#595b5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#626465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#6c6d6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#6e6f71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#78797b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#7e7f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e7f81"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1162",
    "data-name": "Caminho 1162",
    d: "M1329.6,1555.517a.755.755,0,0,0,.445.622l6.768,3.907a1.613,1.613,0,0,0,.218.1l.049.017c.044.016.088.032.134.045l.075.018.043.011.039.01c.049.01.1.019.15.026l.053.006.037,0,.056.006c.049,0,.1.007.149.008h.154c.056,0,.112-.006.167-.011l.019,0,.043-.006c.044-.006.087-.01.13-.018.019,0,.036-.009.054-.013.051-.011.1-.023.15-.038.026-.007.055-.011.08-.02l.061-.023.058-.022a1.584,1.584,0,0,0,.21-.1l6.6-3.834,0-1.784-6.6,3.834a1.614,1.614,0,0,1-.21.1l-.058.022c-.046.017-.094.03-.141.043s-.1.027-.15.037-.122.024-.184.031l-.044.006c-.083.009-.168.013-.253.014h-.04c-.084,0-.167-.005-.25-.014l-.037,0c-.082-.01-.163-.023-.242-.041l-.043-.011a2.118,2.118,0,0,1-.21-.064l-.036-.012a1.676,1.676,0,0,1-.23-.109l-6.767-3.907a.754.754,0,0,1-.445-.622Z",
    transform: "translate(-1329.601 -1553.733)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -23.404,
    y1: 9.826,
    x2: -23.387,
    y2: 9.826,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1163",
    "data-name": "Caminho 1163",
    d: "M1338.237,1503.156v.031l-.024,7.421a2,2,0,0,1-1,1.73l-6.443,3.744a.556.556,0,0,0,.007,1.053l6.767,3.907a2,2,0,0,0,1.818,0l6.443-3.745a2.007,2.007,0,0,0,1-1.73l.021-7.421v-.031a2,2,0,0,0-.91-1.574l-6.767-3.907a.83.83,0,0,0-.41-.125c-.3,0-.5.236-.506.646",
    transform: "translate(-1330.402 -1502.511)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -15.093,
    y1: 3.447,
    x2: -15.082,
    y2: 3.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43464d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#43464d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#474a50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#53565c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#727579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#85878a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#8c8e90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8e90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1252",
    "data-name": "Caminho 1252",
    d: "M1201.014,1554.463c-.061,0-.12,0-.179.008a1.86,1.86,0,0,0-.2.029,1.731,1.731,0,0,0-.241.066,1.669,1.669,0,0,0-.279.129l-1.552.9a1.68,1.68,0,0,1,.279-.129,1.711,1.711,0,0,1,.241-.066,1.813,1.813,0,0,1,.2-.029c.059-.006.118-.008.178-.008s.107,0,.162.005.1.009.153.016.1.015.151.025.094.02.141.031.094.025.142.039.092.029.137.045.092.033.138.052.091.038.137.058.092.042.138.065.093.047.14.072l.109.061,23.642,13.65.034.02c.049.028.1.058.145.089s.1.063.145.1.1.07.149.106.1.076.15.115.1.082.153.125.1.088.153.133.1.093.151.14.1.095.145.144.094.1.141.147.09.1.134.149.089.1.133.155.088.108.132.163.1.133.153.2c.075.1.148.206.219.311q.133.2.256.408c.059.1.116.2.171.3q.054.1.106.206c.03.06.059.12.087.181s.051.111.076.166.048.109.071.165.045.111.067.167.043.113.063.169.042.117.061.175.039.118.057.178.036.121.053.182.033.121.048.182.029.12.042.18.025.119.036.179.021.116.03.173.017.115.024.172.013.112.019.168.01.111.013.167.006.11.008.165,0,.1,0,.154l-.072,27.468,1.552-.9.072-27.468c0-.051,0-.1,0-.154s0-.11-.008-.165-.008-.111-.013-.167-.011-.112-.019-.168-.016-.115-.024-.172-.019-.115-.03-.173-.023-.119-.036-.179-.027-.12-.042-.18-.031-.121-.048-.182-.034-.121-.053-.182-.037-.118-.057-.178-.04-.117-.061-.175-.042-.113-.063-.169-.045-.111-.068-.167-.046-.11-.071-.164-.05-.111-.075-.166-.058-.121-.088-.181-.07-.137-.106-.205q-.082-.154-.171-.3-.122-.208-.256-.408-.106-.159-.219-.312c-.05-.068-.1-.135-.153-.2s-.087-.109-.132-.163-.088-.1-.133-.155-.089-.1-.134-.149-.094-.1-.141-.147-.1-.1-.145-.143-.1-.094-.151-.14-.1-.09-.153-.133-.1-.084-.153-.125-.1-.078-.15-.115-.1-.072-.149-.106-.1-.065-.145-.1-.1-.06-.145-.089l-.034-.019-23.642-13.65-.109-.061c-.047-.025-.094-.05-.14-.073s-.092-.045-.138-.065l-.137-.058c-.046-.019-.092-.036-.138-.052s-.092-.031-.137-.045-.095-.028-.142-.039-.094-.022-.141-.031-.1-.018-.151-.025-.1-.012-.153-.015-.1-.005-.151-.005h-.01",
    transform: "translate(-1198.564 -1554.463)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -6.296,
    y1: 1.197,
    x2: -6.29,
    y2: 1.197,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    stopColor: "#4c5057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#53575e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#5f6268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#696c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#75777c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#898a8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#a5a4a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#acabab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#929191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#737271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#585756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#424140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#31312f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#1e1e1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1256",
    "data-name": "Caminho 1256",
    d: "M1200.193,1673.712a3.294,3.294,0,0,1-1.688,2.876l-2.88,1.813c-7.371,4.494-20.9,12.9-19.893,13.485,1.342.775,24.936-12.521,26.266-13.271a3.293,3.293,0,0,0,1.688-2.875v-15.975l-3.494-2.027Z",
    transform: "translate(-1175.678 -1657.737)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -7.177,
    y1: 0.921,
    x2: -7.171,
    y2: 0.921,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#696c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#75777c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#898a8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#a5a4a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#acabab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#9b9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#797878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#5c5c5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#454443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#333331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#262624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#1f1f1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1259",
    "data-name": "Caminho 1259",
    d: "M1151.884,1644.443a3.294,3.294,0,0,1-1.688,2.876l-2.88,1.813c-7.371,4.495-20.9,12.9-19.894,13.485,1.342.775,24.936-12.521,26.267-13.271a3.294,3.294,0,0,0,1.688-2.876v-15.976l-3.494-2.026Z",
    transform: "translate(-1127.37 -1628.468)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -6.874,
    y1: 1.114,
    x2: -6.868,
    y2: 1.114,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1262",
    "data-name": "Caminho 1262",
    d: "M1327.173,1399.978c-.062,0-.124.006-.185.012s-.143.017-.213.03a2.4,2.4,0,0,0-.315.078,1.884,1.884,0,0,0-.364.16l-10.386,6.035-.005,1.873,10.386-6.035a1.852,1.852,0,0,1,.364-.16,2.464,2.464,0,0,1,.315-.078c.07-.013.141-.022.213-.03s.123-.01.185-.012.114,0,.171,0,.11,0,.165.009.109.01.162.018.111.018.165.029.117.027.174.043a2.087,2.087,0,0,1,.2.068,1.78,1.78,0,0,1,.24.115l20.468,11.817a1.132,1.132,0,0,1,.368.321.634.634,0,0,1,.122.366l0-1.246,0-.626a.535.535,0,0,0-.007-.093.891.891,0,0,0-.483-.594l-20.468-11.818a1.808,1.808,0,0,0-.24-.115q-.1-.039-.2-.068c-.057-.016-.115-.031-.174-.043s-.109-.021-.165-.029-.108-.014-.162-.018-.11-.007-.165-.009h-.073l-.1,0",
    transform: "translate(-1315.704 -1399.976)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -10.955,
    y1: 7.346,
    x2: -10.947,
    y2: 7.346,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#3a3938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#3b3a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#424140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#4e4d4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#5e5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#747373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#8d8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#7c7c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#616366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#515457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#4c4f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4b4e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#4a4a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4a49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1271",
    "data-name": "Caminho 1271",
    d: "M1273.429,1430.87l-.02.012c-.015.009-.029.019-.043.029s-.041.026-.06.04l-.047.037c-.017.014-.035.028-.05.042a.309.309,0,0,0-.028.027.988.988,0,0,0-.07.076l-.016.016-.011.017c-.014.019-.027.039-.039.058s-.011.016-.016.024,0,.008-.006.013-.017.034-.025.052-.01.02-.014.03c-.009.027-.013.044-.017.061s-.007.022-.01.033a.594.594,0,0,0-.007.062c0,.011,0,.022,0,.034s0,.01,0,.015l-.005,1.873a.48.48,0,0,1,0-.049.5.5,0,0,1,.006-.052c0-.014.007-.029.011-.043s.009-.033.014-.05.011-.027.017-.041.015-.035.024-.052.015-.025.022-.037.025-.039.039-.058l.027-.034c.021-.026.045-.051.071-.076l.027-.027c.016-.014.034-.028.051-.042l.047-.037.06-.04c.021-.014.041-.027.063-.04l10.385-6.035.005-1.872Z",
    transform: "translate(-1272.94 -1424.835)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -32.856,
    y1: 11.731,
    x2: -32.83,
    y2: 11.731,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#525251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#4d4d4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#3a3a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#343333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343333"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1302",
    "data-name": "Caminho 1302",
    d: "M1316.136,1445.577a1.086,1.086,0,0,1-.021.188,1.179,1.179,0,0,1-.053.185,1.316,1.316,0,0,1-.088.187,1.506,1.506,0,0,1-.132.2,1.853,1.853,0,0,1-.2.218,2.522,2.522,0,0,1-.413.306l-.04.024-21.9,12.729a3.683,3.683,0,0,1-.715.315,4.783,4.783,0,0,1-.621.154c-.137.025-.277.044-.418.058-.121.012-.242.02-.364.025s-.224,0-.337,0-.216-.008-.323-.017-.213-.021-.319-.036-.218-.034-.325-.056-.23-.052-.341-.084c-.136-.039-.269-.083-.4-.134a3.589,3.589,0,0,1-.47-.225l-20.469-11.817a1.637,1.637,0,0,1-.965-1.351l-.005,1.873a1.636,1.636,0,0,0,.965,1.35l20.468,11.817a3.542,3.542,0,0,0,.47.225q.192.075.4.134c.112.032.226.06.341.084s.215.041.325.056.212.027.318.036.215.015.324.017.224,0,.336,0,.244-.012.364-.024c.141-.014.281-.034.418-.058a4.772,4.772,0,0,0,.62-.154,3.692,3.692,0,0,0,.715-.315l21.9-12.73.04-.023a2.545,2.545,0,0,0,.413-.306,1.872,1.872,0,0,0,.2-.219,1.508,1.508,0,0,0,.132-.2,1.312,1.312,0,0,0,.088-.186,1.191,1.191,0,0,0,.053-.185,1.1,1.1,0,0,0,.021-.189c0-.01,0-.019,0-.029l.005-1.873c0,.01,0,.02,0,.029",
    transform: "translate(-1267.214 -1445.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -7.269,
    y1: 5.755,
    x2: -7.264,
    y2: 5.755,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#66696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#717479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#909193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#acabab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#858587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#5b5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#414447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#383b3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#373a3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373636"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_799",
    "data-name": "Ret\\xE2ngulo 799",
    width: 77.595,
    height: 44.985,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1321",
    "data-name": "Caminho 1321",
    d: "M835.294,1393.814l55.855,32.419L869.408,1438.8l-55.855-32.419Z",
    transform: "translate(-813.553 -1393.814)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -2.826,
    y1: 1.471,
    x2: -2.823,
    y2: 1.471,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5d3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#c5d3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#cedae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#e9eef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#f9fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1328",
    "data-name": "Caminho 1328",
    d: "M909.011,1373.719l-12.838,7.412a2.227,2.227,0,0,1-.292.14c-.079.031-.161.059-.246.083-.069.02-.14.037-.211.052s-.133.025-.2.035-.131.016-.2.022-.133.009-.2.011-.138,0-.207,0-.15-.008-.225-.015-.173-.021-.258-.036a2.9,2.9,0,0,1-.384-.1,2.282,2.282,0,0,1-.446-.2l-13.845-8.046.013,4.514,13.845,8.046a2.29,2.29,0,0,0,.445.2,2.885,2.885,0,0,0,.384.1c.085.015.171.027.258.036s.15.012.225.015.138,0,.207,0,.133-.005.2-.011.132-.013.2-.022.135-.021.2-.035.142-.032.211-.052a2.516,2.516,0,0,0,.246-.083,2.231,2.231,0,0,0,.292-.14l12.838-7.412a1.015,1.015,0,0,0,.6-.837l-.013-4.514a1.015,1.015,0,0,1-.6.836",
    transform: "translate(-879.461 -1372.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -8.183,
    y1: 8.797,
    x2: -8.174,
    y2: 8.797,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1329",
    "data-name": "Caminho 1329",
    d: "M908.865,1370.72l-12.838,7.412a2.842,2.842,0,0,1-2.581,0l-13.7-7.963-.283.7,13.845,8.046.028.016.044.022c.038.02.076.04.116.057l.069.03c.038.016.077.031.116.045l.038.015.022.006a2.931,2.931,0,0,0,.317.084l.023.006.035.005c.049.009.1.017.149.024l.048.008.021,0,.1.009.074.007h.021l.076,0,.081,0h.168l.048,0,.068,0,.045,0,.073-.008.06-.006.024,0c.042-.005.084-.012.126-.019l.029,0c.052-.009.1-.019.167-.034l.055-.014c.03-.007.06-.014.089-.023l.024-.007.074-.024c.022-.007.044-.013.066-.021l.026-.01c.033-.012.065-.025.1-.039l.055-.022.017-.009c.062-.028.122-.058.18-.091l12.845-7.416a.944.944,0,0,0,.579-.966s-.152-.578-.217-.732c.092.325-.078.671-.514.922",
    transform: "translate(-879.461 -1369.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -8.172,
    y1: 12.281,
    x2: -8.163,
    y2: 12.281,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1332",
    "data-name": "Caminho 1332",
    d: "M905.046,1371.066l6.819,3.963a1.837,1.837,0,0,0,1.666,0l6.2-3.582a.861.861,0,0,0,.222-.177l.18-.207a1.015,1.015,0,0,1-.26.208l-6.2,3.582a2.15,2.15,0,0,1-1.952,0l-6.961-4.045Z",
    transform: "translate(-904.76 -1370.807)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -16.513,
    y1: 25.821,
    x2: -16.495,
    y2: 25.821,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1333",
    "data-name": "Caminho 1333",
    d: "M911.929,1316.524l-.057,0-.054.009-.052.012-.051.015-.052.018-.051.022-.052.025-.054.03-6.2,3.582-.052.031-.052.035-.051.037-.046.037-.043.037-.037.034-.036.033-.03.03-.035.037-.02.021-.025.027-.024.028-.024.029-.023.029-.024.031-.029.038-.029.041c-.028.04-.054.083-.08.126-.012.02-.026.039-.044.069l-.027.048-.022.041-.017.034-.016.034-.015.032-.014.032-.013.032-.014.034-.013.035c0,.012-.009.024-.013.036l-.015.042c-.005.014-.009.028-.014.042l-.005.017-.009.031c0,.017-.01.034-.014.051l-.014.057c0,.019-.008.039-.012.058s0,.027-.008.046,0,.01,0,.015c0,.021-.006.041-.008.062s0,.041-.005.061,0,.041,0,.061,0,.024,0,.036v.154l-.019.011.019,6.831a2.181,2.181,0,0,0,1.017,1.728l.423.246a.717.717,0,0,1,.079-.1l.177-.177-.395-.229a1.831,1.831,0,0,1-.912-1.586l-.023-6.831s0-.01,0-.015a1.267,1.267,0,0,1,.016-.191,1.535,1.535,0,0,1,.048-.207,1.832,1.832,0,0,1,.076-.207,1.97,1.97,0,0,1,.1-.192c.01-.017.021-.033.032-.051.03-.05.061-.1.1-.147a1.836,1.836,0,0,1,.142-.171,1.554,1.554,0,0,1,.157-.147,1.294,1.294,0,0,1,.168-.116l6.205-3.582.045-.025.044-.021.044-.019.044-.016.044-.012.044-.01.046-.007.048,0a.514.514,0,0,1,.052,0,.534.534,0,0,1,.057.008.437.437,0,0,1,.068.02.449.449,0,0,1,.261.292l-.087-.26a.528.528,0,0,0-.306-.342.5.5,0,0,0-.08-.023.534.534,0,0,0-.067-.009h-.06",
    transform: "translate(-904.307 -1316.524)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -15.26,
    y1: 8.549,
    x2: -15.243,
    y2: 8.549,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1334",
    "data-name": "Caminho 1334",
    d: "M904.331,1344.7a2.181,2.181,0,0,0,1.017,1.728l.423.246a.729.729,0,0,1,.079-.1l.177-.177-.395-.229a1.832,1.832,0,0,1-.912-1.586l-.02-5.989q-.195-.067-.387-.14Z",
    transform: "translate(-904.313 -1338.457)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -148.028,
    y1: 15.202,
    x2: -147.864,
    y2: 15.202,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1335",
    "data-name": "Caminho 1335",
    d: "M922.373,1363.062a.524.524,0,0,1-.062.1.578.578,0,0,1-.065.073.776.776,0,0,1-.065.057c-.02.016-.042.032-.065.047l-.055.034-6.2,3.582a1.359,1.359,0,0,1-.19.089,1.685,1.685,0,0,1-.2.062,1.949,1.949,0,0,1-.218.037,2.05,2.05,0,0,1-.451,0,1.783,1.783,0,0,1-.2-.033l-.031-.006a1.54,1.54,0,0,1-.2-.06,1.3,1.3,0,0,1-.184-.087l-5.906-3.432-.285.258,6.048,3.516.046.026.048.024.041.019.042.018.039.016.04.014.045.015.047.015.076.021.022,0,.036.007c.032.007.063.015.1.021l.068.011.046.006.022,0,.018,0,.039,0,.033,0,.033,0,.033,0h.2l.04,0,.042,0,.043,0,.051-.005.051-.006.061-.009.063-.011.08-.017.062-.016.075-.022.076-.025.031-.013.045-.017c.026-.011.051-.022.077-.034l.077-.04.014-.008,6.2-3.582.064-.039c.027-.018.052-.036.076-.055a.984.984,0,0,0,.076-.067.723.723,0,0,0,.076-.086.605.605,0,0,0,.073-.122.508.508,0,0,0-.106-.562l-.181-.205a.434.434,0,0,1,.09.48",
    transform: "translate(-908.001 -1362.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -17.16,
    y1: 21.319,
    x2: -17.141,
    y2: 21.319,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1336",
    "data-name": "Caminho 1336",
    d: "M908.477,1314.5l-.044,0-.043.007-.04.009-.04.011-.04.013-.04.015-.039.017-.04.019-.04.021-.031.017-6.213,3.588-.042.025-.042.028-.043.03-.043.033-.021.017-.022.018-.044.038-.043.04-.042.041-.04.042-.038.043-.038.044-.038.047-.044.057c-.021.029-.042.058-.062.088s-.05.077-.073.116l-.013.023c-.012.021-.024.042-.035.063l-.03.059-.025.051c-.007.015-.015.031-.026.057l-.016.036-.019.048-.018.048c-.006.017-.012.033-.017.05l-.019.062-.012.041-.014.052-.012.051-.01.051c0,.016-.006.031-.008.05s-.005.033-.007.049l-.005.048c0,.016,0,.032,0,.048s0,.031,0,.047,0,.029,0,.044l.023,7,.976.567-.023-7a1.492,1.492,0,0,1,.019-.239,1.862,1.862,0,0,1,.057-.245,2.175,2.175,0,0,1,.089-.243,2.513,2.513,0,0,1,.121-.238,2.349,2.349,0,0,1,.142-.218,2.2,2.2,0,0,1,.168-.2,2,2,0,0,1,.184-.172,1.566,1.566,0,0,1,.2-.135l6.2-3.582.031-.017.04-.021.04-.018.04-.017.04-.015.039-.013.041-.011.04-.009.043-.007.043,0,.046,0,.051,0c.019,0,.038,0,.056.008a.494.494,0,0,1,.068.019.467.467,0,0,1,.079.036l-.976-.567a.436.436,0,0,0-.079-.037.465.465,0,0,0-.068-.019.439.439,0,0,0-.057-.008l-.051,0h-.008l-.038,0",
    transform: "translate(-900.9 -1314.503)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -15.913,
    y1: 8.88,
    x2: -15.895,
    y2: 8.88,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1337",
    "data-name": "Caminho 1337",
    d: "M922.205,1365.169l-6.2,3.582a1.487,1.487,0,0,1-.211.1l-.033.011a1.947,1.947,0,0,1-.192.059l-.039.01a2.137,2.137,0,0,1-.222.038l-.034,0c-.076.008-.152.012-.229.013H915c-.078,0-.156,0-.232-.013l-.04-.006c-.057-.007-.113-.017-.169-.029s-.092-.021-.138-.034-.088-.025-.13-.039l-.054-.02a1.573,1.573,0,0,1-.193-.091L908,1365.236l0,1.636,6.049,3.515a1.451,1.451,0,0,0,.192.092l.054.02.056.021c.023.008.049.011.073.018.045.013.091.025.138.034.017,0,.033.009.049.012.039.007.079.012.119.017l.04.006.017,0q.076.008.153.01h.141c.046,0,.091,0,.136-.007l.051-.006.034,0,.049-.005c.046-.007.092-.015.137-.024l.036-.008.039-.01.069-.017c.042-.012.083-.027.123-.042l.045-.015a1.5,1.5,0,0,0,.2-.1l6.2-3.582a.693.693,0,0,0,.408-.57l0-1.635a.691.691,0,0,1-.408.57",
    transform: "translate(-908.001 -1364.599)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -17.435,
    y1: 19.534,
    x2: -17.416,
    y2: 19.534,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1338",
    "data-name": "Caminho 1338",
    d: "M912.721,1317.759l-6.2,3.582a1.837,1.837,0,0,0-.834,1.443v.028l.02,6.8a1.841,1.841,0,0,0,.916,1.586l5.906,3.432a1.839,1.839,0,0,0,1.667,0l6.2-3.582a.51.51,0,0,0,.007-.966l-5.906-3.432a1.831,1.831,0,0,1-.913-1.586l-.022-6.8v-.028c0-.375-.189-.592-.463-.592a.765.765,0,0,0-.376.115",
    transform: "translate(-905.683 -1317.644)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -11.614,
    y1: 5.945,
    x2: -11.601,
    y2: 5.945,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1427",
    "data-name": "Caminho 1427",
    d: "M1004.813,1253.161c-.046,0-.093.008-.14.014s-.091.014-.138.023-.086.018-.129.029-.086.023-.13.036-.084.027-.126.041-.084.031-.127.048-.083.034-.125.053-.084.039-.127.06l-.129.067-.1.055L981.869,1266.1l-.031.018c-.044.026-.089.053-.133.082s-.089.058-.134.088-.091.064-.137.1-.092.069-.138.105-.094.075-.14.115-.094.08-.14.122-.093.085-.138.129-.089.086-.133.131-.086.089-.129.135-.083.09-.123.136-.082.094-.122.143-.081.1-.121.149-.094.122-.14.185c-.069.094-.136.188-.2.286-.082.122-.16.247-.234.374-.054.092-.106.185-.157.279-.034.062-.066.125-.1.188s-.054.11-.08.166-.047.1-.069.153-.044.1-.065.151-.042.1-.062.154-.04.1-.058.155-.038.107-.056.161-.036.109-.052.163-.034.111-.049.166-.03.112-.044.167-.026.11-.038.165-.023.109-.033.164-.019.106-.028.159-.016.106-.023.158-.012.1-.017.154-.009.1-.012.153-.006.1-.007.152,0,.094,0,.141l.066,25.179,1.423.827-.066-25.18c0-.047,0-.094,0-.142s0-.1.007-.152.007-.1.012-.152.011-.1.017-.154.014-.105.022-.158.017-.106.027-.159.021-.11.033-.164.025-.109.038-.165.028-.111.044-.167.032-.111.049-.167.034-.109.052-.163.037-.107.056-.161.038-.1.058-.155.04-.1.062-.154.042-.1.065-.151.046-.1.07-.152.053-.111.08-.166.064-.126.1-.188q.075-.141.157-.279.112-.19.234-.374.1-.145.2-.286c.046-.062.093-.124.141-.184s.08-.1.121-.149.081-.1.122-.142.081-.092.123-.136.086-.091.129-.135.088-.088.133-.131l.139-.129c.046-.042.093-.082.14-.122s.093-.077.14-.115.091-.071.138-.105.091-.066.137-.1.089-.059.133-.088l.133-.081.031-.018,21.673-12.513.1-.056c.043-.023.086-.045.129-.066s.085-.041.127-.06l.126-.053c.043-.017.085-.033.127-.048l.126-.041c.044-.013.087-.025.13-.036s.086-.021.129-.029.092-.017.138-.023.094-.011.14-.014.1-.005.148,0,.11,0,.163.008a1.662,1.662,0,0,1,.182.026,1.551,1.551,0,0,1,.477.179l-1.423-.827a1.5,1.5,0,0,0-.256-.118,1.592,1.592,0,0,0-.221-.061,1.636,1.636,0,0,0-.182-.026c-.054-.005-.108-.008-.164-.008h-.009c-.046,0-.092,0-.139,0",
    transform: "translate(-978.727 -1253.156)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -4.979,
    y1: 3.168,
    x2: -4.974,
    y2: 3.168,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1431",
    "data-name": "Caminho 1431",
    d: "M1009.7,1349.687v14.645a3.02,3.02,0,0,0,1.548,2.636c1.22.687,22.849,12.876,24.079,12.166.922-.533-11.479-8.241-18.236-12.362l-2.64-1.662a3.019,3.019,0,0,1-1.547-2.636v-14.645Z",
    transform: "translate(-1009.699 -1347.829)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -7.101,
    y1: 3.093,
    x2: -7.093,
    y2: 3.093,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1434",
    "data-name": "Caminho 1434",
    d: "M1053.985,1322.856V1337.5a3.019,3.019,0,0,0,1.547,2.636c1.22.687,22.849,12.876,24.079,12.166.922-.533-11.479-8.242-18.236-12.362l-2.64-1.662a3.02,3.02,0,0,1-1.547-2.636V1321Z",
    transform: "translate(-1053.985 -1320.998)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -7.419,
    y1: 3.277,
    x2: -7.412,
    y2: 3.277,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1437",
    "data-name": "Caminho 1437",
    d: "M882.949,1223.65c-.051,0-.1,0-.151.008s-.1.01-.149.017-.1.016-.152.026-.107.024-.159.039-.125.039-.185.063a1.664,1.664,0,0,0-.22.105l-18.763,10.833a.816.816,0,0,0-.443.544.512.512,0,0,0-.007.086l0,.574,0,1.143a.581.581,0,0,1,.112-.336,1.041,1.041,0,0,1,.338-.294l18.764-10.833a1.616,1.616,0,0,1,.219-.105c.06-.023.122-.044.185-.063s.105-.028.159-.039.1-.019.152-.026.1-.013.149-.017.1-.007.151-.008.1,0,.157,0,.114.005.169.011.131.015.2.027a2.213,2.213,0,0,1,.29.072,1.728,1.728,0,0,1,.333.147l9.521,5.533,0-1.716-9.521-5.533a1.745,1.745,0,0,0-.334-.147,2.215,2.215,0,0,0-.289-.072q-.1-.017-.2-.027c-.056-.005-.113-.01-.17-.011h-.157",
    transform: "translate(-862.72 -1223.649)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -7.836,
    y1: 11.696,
    x2: -7.827,
    y2: 11.696,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1446",
    "data-name": "Caminho 1446",
    d: "M986.472,1254.308h0m-9.963-6.154,9.52,5.533c.021.012.039.025.058.037s.037.024.054.036.029.023.043.034.032.025.047.038l.025.024a.948.948,0,0,1,.065.07l.024.031c.013.018.025.035.036.053s.015.023.021.034.015.031.022.047.012.025.016.037a.473.473,0,0,1,.013.046c0,.013.008.026.01.039s0,.032.006.048,0,.03,0,.044c0-.014,0-1.716-.005-1.73s0-.021,0-.031,0-.033-.007-.057-.006-.021-.009-.031-.008-.031-.016-.056c0-.009-.009-.018-.013-.027s-.014-.032-.028-.06c0-.007-.01-.015-.015-.022s-.023-.036-.036-.054l-.01-.015-.014-.015c-.02-.024-.042-.047-.065-.069a.262.262,0,0,0-.026-.025c-.015-.013-.03-.026-.046-.038l-.043-.034c-.017-.013-.036-.024-.055-.036l-.04-.027-.018-.011-9.52-5.532Z",
    transform: "translate(-976.504 -1246.438)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -27.495,
    y1: 19.159,
    x2: -27.467,
    y2: 19.159,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1477",
    "data-name": "Caminho 1477",
    d: "M857.476,1267.142c0,.009,0,.017,0,.026a1.048,1.048,0,0,0,.068.342,1.23,1.23,0,0,0,.08.171,1.441,1.441,0,0,0,.121.179,1.685,1.685,0,0,0,.186.2,2.3,2.3,0,0,0,.379.281l.036.022,20.08,11.669a3.392,3.392,0,0,0,.656.288,4.385,4.385,0,0,0,.569.142q.189.034.384.053.166.017.334.022c.1,0,.205,0,.308,0s.2-.008.3-.016.2-.019.292-.033.2-.031.3-.052.211-.047.313-.077q.188-.053.363-.123a3.2,3.2,0,0,0,.431-.206l18.763-10.833a1.5,1.5,0,0,0,.885-1.238l-.005-1.717a1.5,1.5,0,0,1-.884,1.238l-18.763,10.833a3.246,3.246,0,0,1-.431.206,3.794,3.794,0,0,1-.364.123q-.154.044-.313.077c-.1.02-.2.038-.3.052s-.194.024-.292.033-.2.013-.3.016-.206,0-.308,0-.223-.011-.334-.022q-.194-.019-.384-.053a4.349,4.349,0,0,1-.569-.142,3.35,3.35,0,0,1-.656-.288l-20.08-11.669-.036-.021a2.331,2.331,0,0,1-.379-.281,1.728,1.728,0,0,1-.186-.2,1.436,1.436,0,0,1-.121-.18,1.227,1.227,0,0,1-.08-.171,1.066,1.066,0,0,1-.049-.169,1.026,1.026,0,0,1-.02-.173c0-.009,0-.018,0-.026Z",
    transform: "translate(-857.471 -1265.426)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -5.366,
    y1: 9.622,
    x2: -5.36,
    y2: 9.622,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_824",
    "data-name": "Ret\\xE2ngulo 824",
    width: 74.031,
    height: 59.979,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1796",
    "data-name": "Caminho 1796",
    d: "M1235.928,1126.589l74.031-43.022-34.32-16.957-39.712,23.078Z",
    transform: "translate(-1235.928 -1066.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -3.807,
    y1: 2.319,
    x2: -3.804,
    y2: 2.319,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5d3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#c5d3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ecf0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_827",
    "data-name": "Ret\\xE2ngulo 827",
    width: 78.175,
    height: 82.386,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "VetorImagem",
    transform: "translate(-185.599 -354.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_517",
    "data-name": "Grupo 517",
    transform: "translate(185.599 354.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_516",
    "data-name": "Grupo 516",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1022",
    "data-name": "Caminho 1022",
    d: "M150.868,626.354,65.243,637.448V794.841L137.576,836.6l98.563,56.905V736.115Z",
    transform: "translate(-46.932 -450.564)",
    fill: "#778fac"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1023",
    "data-name": "Caminho 1023",
    d: "M1154.68,676.513V799.857l122.207-71.1V605.411Z",
    transform: "translate(-830.613 -435.499)",
    fill: "#506689"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1024",
    "data-name": "Caminho 1024",
    d: "M864.732,859.5,757.426,921.937v123.344l107.306-62.433Z",
    transform: "translate(-544.85 -618.28)",
    fill: "#506689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1025",
    "data-name": "Caminho 1025",
    d: "M674.159,606.788v157.5l19.856-11.553.013-.007V660.758l105.68-61.471v92.021l32.164-18.714V580.574l85.455-49.719v92.073l32.164-18.714v-157.5Z",
    transform: "translate(-484.952 -321.343)",
    fill: "#afbdce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1026",
    "data-name": "Caminho 1026",
    d: "M150.868,614.464,65.243,625.558V759.036l170.9,98.667V700.31Z",
    transform: "translate(-46.932 -442.011)",
    fill: "#f6f6f6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1027",
    "data-name": "Caminho 1027",
    d: "M674.159,554.805V712.3l19.856-11.553.013-.007V630.088l105.68-61.471v70.708l32.164-18.714V554.266l85.455-49.719v66.4l32.164-18.714v-139.9Z",
    transform: "translate(-484.952 -296.612)",
    fill: "#f6f6f6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1028",
    "data-name": "Caminho 1028",
    d: "M674.159,636.508,949.491,476.314v-16.7L674.159,619.81Z",
    transform: "translate(-484.953 -330.623)",
    fill: "#cedae8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1029",
    "data-name": "Caminho 1029",
    d: "M1093.912,994.845v83.045l7.743,4.471V990.34Z",
    transform: "translate(-786.9 -712.395)",
    fill: "#becddf"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1030",
    "data-name": "Caminho 1030",
    d: "M290.064,12.026,0,180.6l92.78-12.021L382.844.005Z",
    transform: "translate(0 -0.004)",
    fill: "#fcb64a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1031",
    "data-name": "Caminho 1031",
    d: "M620.646.005,330.582,168.584l92.4,118.932L712.721,118.937Z",
    transform: "translate(-237.802 -0.004)",
    fill: "#ffdc9c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1032",
    "data-name": "Caminho 1032",
    d: "M659.794,592.347v9.039L949.537,432.808v-9.04Z",
    transform: "translate(-474.619 -304.835)",
    fill: "#fcb64a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1033",
    "data-name": "Caminho 1033",
    d: "M330.582,600.665V609.7l92.4,118.932V719.6Z",
    transform: "translate(-237.802 -432.085)",
    fill: "#fc9800"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1034",
    "data-name": "Caminho 1034",
    d: "M0,612.686v9.039L92.78,609.7v-9.039Z",
    transform: "translate(0 -432.085)",
    fill: "#fc9800"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1035",
    "data-name": "Caminho 1035",
    d: "M1192.3,903.872v104.607l3.623,2.092V905.964Z",
    transform: "translate(-857.671 -650.195)",
    fill: "#778fac"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1036",
    "data-name": "Caminho 1036",
    d: "M1540.586,701.848V806.456l3.623,2.092V703.94Z",
    transform: "translate(-1108.212 -504.871)",
    fill: "#778fac"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1037",
    "data-name": "Caminho 1037",
    d: "M1192.3,745.615l106.422-61.745,3.623,2.092-106.422,61.745Z",
    transform: "translate(-857.671 -491.938)",
    fill: "#fefefe"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1038",
    "data-name": "Caminho 1038",
    d: "M1205.2,752.623V857.23l8.672-5.046V756.617l89.078-51.827v95.741l8.672-5.046V690.7Z",
    transform: "translate(-866.957 -496.854)",
    fill: "#aebccd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1039",
    "data-name": "Caminho 1039",
    d: "M744.953,1164.332v104.607l3.623,2.092V1166.423Z",
    transform: "translate(-535.878 -837.555)",
    fill: "#778fac"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1040",
    "data-name": "Caminho 1040",
    d: "M744.953,1241.6v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-535.878 -893.139)",
    fill: "#fc9800"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1041",
    "data-name": "Caminho 1041",
    d: "M744.953,1320.711v8.969l3.623,2.092V1322.8Z",
    transform: "translate(-535.878 -950.046)",
    fill: "#fc9800"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1042",
    "data-name": "Caminho 1042",
    d: "M744.953,1399.82v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-535.878 -1006.953)",
    fill: "#fc9800"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1043",
    "data-name": "Caminho 1043",
    d: "M744.953,1478.93v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-535.878 -1063.86)",
    fill: "#fc9800"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1044",
    "data-name": "Caminho 1044",
    d: "M1093.244,962.308v104.607l3.623,2.092V964.4Z",
    transform: "translate(-786.419 -692.23)",
    fill: "#778fac"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1045",
    "data-name": "Caminho 1045",
    d: "M1096.867,1282.154v-8.968l-3.623-2.092v8.969Z",
    transform: "translate(-786.419 -914.354)",
    fill: "#fc9800"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1046",
    "data-name": "Caminho 1046",
    d: "M1096.867,1203.045v-8.969l-3.623-2.092v8.969Z",
    transform: "translate(-786.419 -857.447)",
    fill: "#fc9800"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1047",
    "data-name": "Caminho 1047",
    d: "M1096.867,1123.935v-8.969l-3.623-2.092v8.969Z",
    transform: "translate(-786.419 -800.54)",
    fill: "#fc9800"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1048",
    "data-name": "Caminho 1048",
    d: "M1096.867,1035.858l-3.623-2.092v8.968l3.623,2.092Z",
    transform: "translate(-786.419 -743.634)",
    fill: "#fc9800"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1049",
    "data-name": "Caminho 1049",
    d: "M869.361,993.289,782.6,1043.768v27.526l86.761-50.479Z",
    transform: "translate(-562.959 -714.517)",
    fill: "#e6ecf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_413",
    "data-name": "Grupo 413",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_412",
    "data-name": "Grupo 412",
    clipPath: "url(#clip-path-2)"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1050",
    "data-name": "Caminho 1050",
    d: "M781.521,1120.927a.421.421,0,0,1-.212-.785l86.761-50.479a.421.421,0,1,1,.423.728l-86.761,50.479a.418.418,0,0,1-.211.057",
    transform: "translate(-561.879 -769.416)",
    fill: "#c3d1e2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1051",
    "data-name": "Caminho 1051",
    d: "M781.521,1101.359a.421.421,0,0,1-.212-.785l86.761-50.479a.421.421,0,1,1,.423.728L781.732,1101.3a.42.42,0,0,1-.211.057",
    transform: "translate(-561.879 -755.34)",
    fill: "#c3d1e2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1052",
    "data-name": "Caminho 1052",
    d: "M781.521,1081.792a.421.421,0,0,1-.212-.785l86.761-50.479a.421.421,0,1,1,.423.728l-86.761,50.479a.417.417,0,0,1-.211.057",
    transform: "translate(-561.879 -741.265)",
    fill: "#c3d1e2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1053",
    "data-name": "Caminho 1053",
    d: "M744.953,1006.074l106.422-61.745L855,946.421l-106.422,61.745Z",
    transform: "translate(-535.878 -679.299)",
    fill: "#fefefe"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1054",
    "data-name": "Caminho 1054",
    d: "M757.862,1013.082v104.607l8.672-5.046v-95.568l89.078-51.827v95.741l8.672-5.046V951.163Z",
    transform: "translate(-545.164 -684.215)",
    fill: "#aebccd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1055",
    "data-name": "Caminho 1055",
    d: "M788.923,1346.717l82.4-47.887,23.846,13.767-82.4,47.887Z",
    transform: "translate(-567.508 -934.308)",
    fill: "#becddf"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1056",
    "data-name": "Caminho 1056",
    d: "M812.653,1483.221l26.37,31.27-50.261-29.018.045-16.019Z",
    transform: "translate(-567.391 -1057.045)",
    fill: "#778fac"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1057",
    "data-name": "Caminho 1057",
    d: "M873.889,1395.771l82.4-47.887,26.37,31.27-82.4,47.887Z",
    transform: "translate(-628.627 -969.595)",
    fill: "#eaeff5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1058",
    "data-name": "Caminho 1058",
    d: "M1236.266,1086.258l82.4-47.887,23.846,13.767-82.4,47.887Z",
    transform: "translate(-889.301 -746.948)",
    fill: "#becddf"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1059",
    "data-name": "Caminho 1059",
    d: "M1260,1222.762l26.37,31.27-50.261-29.018.045-16.019Z",
    transform: "translate(-889.184 -869.685)",
    fill: "#778fac"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1060",
    "data-name": "Caminho 1060",
    d: "M1321.231,1135.313l82.4-47.887L1430,1118.7l-82.4,47.886Z",
    transform: "translate(-950.42 -782.235)",
    fill: "#eaeff5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1061",
    "data-name": "Caminho 1061",
    d: "M1577.411,1324.525l49.684-28.874,111.063,64.123-49.684,28.873Z",
    transform: "translate(-1134.702 -932.021)",
    fill: "#2e609a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1062",
    "data-name": "Caminho 1062",
    d: "M1577.411,1304.134l49.684-28.874,111.063,64.123-49.684,28.873Z",
    transform: "translate(-1134.702 -917.353)",
    fill: "#003d84"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1063",
    "data-name": "Caminho 1063",
    d: "M1813.086,1512.61l-4.878-2.843,7.5-4.33.022.013c1.716-1.039,4.11-.918,6.76.612,5.219,3.013,9.45,10.341,9.45,16.368,0,3.291-1.264,5.51-3.259,6.358v.015l-7.5,4.33v-6.11a21.49,21.49,0,0,1-8.1-14.414",
    transform: "translate(-1300.724 -1082.451)",
    fill: "#003d84"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1064",
    "data-name": "Caminho 1064",
    d: "M1877.7,1549.908l-.02,7.116,14.792,8.54.02-7.116Z",
    transform: "translate(-1350.7 -1114.919)",
    fill: "#3f6da2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1065",
    "data-name": "Caminho 1065",
    d: "M1930.387,1577.6l.02-7.116,6.617-3.845-.02,7.116Z",
    transform: "translate(-1388.613 -1126.951)",
    fill: "#003d84"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1066",
    "data-name": "Caminho 1066",
    d: "M1877.754,1540.051l6.617-3.845,14.792,8.54-6.617,3.846Z",
    transform: "translate(-1350.752 -1105.062)",
    fill: "#195090"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1067",
    "data-name": "Caminho 1067",
    d: "M1816.357,1538.49c0,6.026-4.231,8.469-9.45,5.456s-9.45-10.341-9.45-16.367,4.231-8.469,9.45-5.456,9.45,10.341,9.45,16.368",
    transform: "translate(-1292.99 -1094.003)",
    fill: "#3f6da2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1068",
    "data-name": "Caminho 1068",
    d: "M1816.718,1539.211a12.426,12.426,0,0,1,5.622,9.737c0,3.585-2.517,5.038-5.622,3.246a12.427,12.427,0,0,1-5.622-9.738c0-3.585,2.517-5.038,5.622-3.246",
    transform: "translate(-1302.802 -1106.672)",
    fill: "#bed8ff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1069",
    "data-name": "Caminho 1069",
    d: "M1827.876,1558.625c0,1.327-.932,1.865-2.081,1.2a4.6,4.6,0,0,1-2.08-3.6c0-1.327.932-1.865,2.08-1.2a4.6,4.6,0,0,1,2.081,3.6",
    transform: "translate(-1311.879 -1118.393)",
    fill: "#003d84"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1070",
    "data-name": "Caminho 1070",
    d: "M1538.857,1352.275l-4.878-2.843,7.5-4.33.022.013c1.716-1.039,4.11-.918,6.761.612,5.219,3.013,9.45,10.341,9.45,16.368,0,3.291-1.264,5.51-3.259,6.359v.015l-7.5,4.33v-6.11a21.491,21.491,0,0,1-8.1-14.414",
    transform: "translate(-1103.459 -967.115)",
    fill: "#003d84"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1071",
    "data-name": "Caminho 1071",
    d: "M1542.128,1378.155c0,6.026-4.231,8.469-9.45,5.456s-9.45-10.341-9.45-16.367,4.231-8.469,9.45-5.456,9.45,10.341,9.45,16.368",
    transform: "translate(-1095.725 -978.667)",
    fill: "#3f6da2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1072",
    "data-name": "Caminho 1072",
    d: "M1542.489,1378.876a12.427,12.427,0,0,1,5.622,9.737c0,3.585-2.517,5.038-5.622,3.246a12.426,12.426,0,0,1-5.622-9.737c0-3.585,2.517-5.038,5.622-3.246",
    transform: "translate(-1105.536 -991.336)",
    fill: "#bed8ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1073",
    "data-name": "Caminho 1073",
    d: "M1553.647,1398.29c0,1.327-.932,1.864-2.08,1.2a4.6,4.6,0,0,1-2.08-3.6c0-1.327.931-1.865,2.08-1.2a4.6,4.6,0,0,1,2.08,3.6",
    transform: "translate(-1114.614 -1003.057)",
    fill: "#003d84"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1074",
    "data-name": "Caminho 1074",
    d: "M1607.414,1392.359l-4.878-2.843,7.5-4.33.022.013c1.716-1.039,4.11-.918,6.76.612,5.219,3.013,9.45,10.341,9.45,16.368,0,3.291-1.263,5.51-3.259,6.359v.015l-7.5,4.33v-6.11a21.49,21.49,0,0,1-8.1-14.414",
    transform: "translate(-1152.775 -995.949)",
    fill: "#003d84"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1075",
    "data-name": "Caminho 1075",
    d: "M1610.685,1418.238c0,6.026-4.231,8.469-9.45,5.456s-9.45-10.341-9.45-16.367,4.231-8.469,9.45-5.456,9.45,10.341,9.45,16.368",
    transform: "translate(-1145.041 -1007.5)",
    fill: "#3f6da2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1076",
    "data-name": "Caminho 1076",
    d: "M1611.047,1418.96a12.426,12.426,0,0,1,5.622,9.737c0,3.585-2.517,5.038-5.622,3.246a12.426,12.426,0,0,1-5.622-9.737c0-3.585,2.517-5.038,5.622-3.246",
    transform: "translate(-1154.853 -1020.17)",
    fill: "#bed8ff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1077",
    "data-name": "Caminho 1077",
    d: "M1622.2,1438.373c0,1.327-.932,1.865-2.081,1.2a4.6,4.6,0,0,1-2.08-3.6c0-1.327.932-1.865,2.08-1.2a4.6,4.6,0,0,1,2.081,3.6",
    transform: "translate(-1163.93 -1031.89)",
    fill: "#003d84"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1078",
    "data-name": "Caminho 1078",
    d: "M1950.2,1592.777l-4.878-2.842,7.5-4.33.022.013c1.716-1.039,4.11-.918,6.76.612,5.219,3.013,9.45,10.341,9.45,16.368,0,3.291-1.264,5.51-3.259,6.358v.015l-7.5,4.33v-6.11a21.49,21.49,0,0,1-8.1-14.414",
    transform: "translate(-1399.357 -1140.119)",
    fill: "#003d84"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1079",
    "data-name": "Caminho 1079",
    d: "M1953.472,1618.657c0,6.026-4.231,8.469-9.45,5.456s-9.45-10.341-9.45-16.367,4.23-8.469,9.45-5.456,9.45,10.341,9.45,16.368",
    transform: "translate(-1391.623 -1151.67)",
    fill: "#3f6da2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1080",
    "data-name": "Caminho 1080",
    d: "M1953.833,1619.378a12.426,12.426,0,0,1,5.622,9.737c0,3.585-2.517,5.038-5.622,3.246a12.426,12.426,0,0,1-5.622-9.737c0-3.585,2.517-5.038,5.622-3.246",
    transform: "translate(-1401.434 -1164.339)",
    fill: "#bed8ff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1081",
    "data-name": "Caminho 1081",
    d: "M1964.991,1638.792c0,1.327-.932,1.865-2.08,1.2a4.6,4.6,0,0,1-2.08-3.6c0-1.327.931-1.865,2.08-1.2a4.6,4.6,0,0,1,2.08,3.6",
    transform: "translate(-1410.512 -1176.06)",
    fill: "#003d84"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1082",
    "data-name": "Caminho 1082",
    d: "M1524.453,1144.6l-.152,53.427,111.063,64.123.152-53.427Z",
    transform: "translate(-1096.498 -823.366)",
    fill: "#bed8ff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1083",
    "data-name": "Caminho 1083",
    d: "M1920.03,1352.5l.151-53.427,49.684-28.874-.151,53.427Z",
    transform: "translate(-1381.162 -913.711)",
    fill: "#95bfff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1084",
    "data-name": "Caminho 1084",
    d: "M1935.318,1426.913l25.279,14.595,11.2,31.707-.075,30.538a7.08,7.08,0,0,1-3.24-.7l-11.258-6.5.01-3.619c.02-6.909-4.84-15.322-10.853-18.793l-11.166-6.447Z",
    transform: "translate(-1392.085 -1026.443)",
    fill: "#ffcf77"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1085",
    "data-name": "Caminho 1085",
    d: "M1960.108,1459.8l11.857,6.846a6.392,6.392,0,0,1,2.833,3.409l7.422,21.011a1.328,1.328,0,0,1-1.916,1.592l-19.816-11.441a3.993,3.993,0,0,1-2-3.458v-17.025a1.079,1.079,0,0,1,1.618-.934",
    transform: "translate(-1408.829 -1049.995)",
    fill: "#95bfff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1086",
    "data-name": "Caminho 1086",
    d: "M1524.842,1070.6l49.684-28.874,111.063,64.123-49.684,28.873Z",
    transform: "translate(-1096.886 -749.36)",
    fill: "#deebff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1087",
    "data-name": "Caminho 1087",
    d: "M2065.382,1517.884l49.684-28.873-.075,30.543a2.409,2.409,0,0,1-1.411,1.98l-44.944,26.081a6.925,6.925,0,0,1-3.33.808Z",
    transform: "translate(-1485.667 -1071.113)",
    fill: "#fc9800"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1088",
    "data-name": "Caminho 1088",
    d: "M2065.559,1620.768l5.722-3.325v14.665l-5.722,3.325Z",
    transform: "translate(-1485.848 -1163.5)",
    fill: "#95bfff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1089",
    "data-name": "Caminho 1089",
    d: "M2222.218,1529.4l5.722-3.325v14.664l-5.722,3.325Z",
    transform: "translate(-1598.54 -1097.772)",
    fill: "#95bfff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1090",
    "data-name": "Caminho 1090",
    d: "M2025.657,1404.911l49.684-28.874,11.2,31.707-49.685,28.873Z",
    transform: "translate(-1457.145 -989.846)",
    fill: "#fcb64a"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1091",
    "data-name": "Caminho 1091",
    d: "M2050.731,1444.419l-6.792-19.23a3.012,3.012,0,0,1,1.327-3.607l38.675-22.475a2.323,2.323,0,0,1,3.358,1.235l6.736,19.071a3.6,3.6,0,0,1-1.584,4.307l-37.983,22.073a2.585,2.585,0,0,1-3.736-1.374",
    transform: "translate(-1470.172 -1006.214)",
    fill: "#95bfff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1092",
    "data-name": "Caminho 1092",
    d: "M1985.27,1324.035l25.279,14.595-49.684,28.874-25.279-14.595Z",
    transform: "translate(-1392.352 -952.438)",
    fill: "#ffdc9c"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1093",
    "data-name": "Caminho 1093",
    d: "M2101.861,1578.4l28.35-16.475v2.683l-28.35,16.475Z",
    transform: "translate(-1511.961 -1123.565)",
    fill: "#924c00"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1094",
    "data-name": "Caminho 1094",
    d: "M2101.861,1597.195l28.35-16.475v2.682l-28.35,16.475Z",
    transform: "translate(-1511.961 -1137.083)",
    fill: "#924c00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1095",
    "data-name": "Caminho 1095",
    d: "M2142.809,1628.138l11.267-6.547v4.691l-11.267,6.548Z",
    transform: "translate(-1541.418 -1166.484)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_411",
    "data-name": "Grupo 411",
    transform: "translate(13.779 7.879)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_410",
    "data-name": "Grupo 410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_409",
    "data-name": "Grupo 409",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_351",
    "data-name": "Grupo 351",
    transform: "translate(0 152.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1096",
    "data-name": "Caminho 1096",
    d: "M234.178,690.7,141.833,571.829l-92.7,12.01-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-49.096 -571.53)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_354",
    "data-name": "Grupo 354",
    transform: "translate(13.797 144.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353",
    "data-name": "Grupo 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_352",
    "data-name": "Grupo 352",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1097",
    "data-name": "Caminho 1097",
    d: "M283.34,662.094,190.994,543.225l-92.7,12.011-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-98.258 -542.928)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_357",
    "data-name": "Grupo 357",
    transform: "translate(27.595 136.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_355",
    "data-name": "Grupo 355",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1098",
    "data-name": "Caminho 1098",
    d: "M332.5,633.491,240.155,514.623l-92.7,12.01-.036-.278,92.859-12.031.049.064,92.4,118.932Z",
    transform: "translate(-147.419 -514.323)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_360",
    "data-name": "Grupo 360",
    transform: "translate(41.392 128.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_359",
    "data-name": "Grupo 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_358",
    "data-name": "Grupo 358",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1099",
    "data-name": "Caminho 1099",
    d: "M381.662,604.888,289.316,486.02l-92.7,12.011-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-196.58 -485.721)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_363",
    "data-name": "Grupo 363",
    transform: "translate(55.189 120.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_362",
    "data-name": "Grupo 362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_361",
    "data-name": "Grupo 361",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1100",
    "data-name": "Caminho 1100",
    d: "M430.823,576.285,338.477,457.417l-92.7,12.01-.036-.278L338.6,457.118l.049.063,92.4,118.932Z",
    transform: "translate(-245.741 -457.119)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_366",
    "data-name": "Grupo 366",
    transform: "translate(68.987 112.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_365",
    "data-name": "Grupo 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_364",
    "data-name": "Grupo 364",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1101",
    "data-name": "Caminho 1101",
    d: "M479.984,547.682,387.638,428.814l-92.7,12.01-.036-.278,92.859-12.031.049.064,92.4,118.931Z",
    transform: "translate(-294.902 -428.516)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_369",
    "data-name": "Grupo 369",
    transform: "translate(82.784 104.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_368",
    "data-name": "Grupo 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_367",
    "data-name": "Grupo 367",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1102",
    "data-name": "Caminho 1102",
    d: "M529.145,519.08,436.8,400.211l-92.7,12.011-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-344.063 -399.912)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_372",
    "data-name": "Grupo 372",
    transform: "translate(96.581 96.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_371",
    "data-name": "Grupo 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_370",
    "data-name": "Grupo 370",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1103",
    "data-name": "Caminho 1103",
    d: "M578.306,490.477,485.96,371.609l-92.7,12.01-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-393.224 -371.31)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(110.379 88.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_374",
    "data-name": "Grupo 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_373",
    "data-name": "Grupo 373",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1104",
    "data-name": "Caminho 1104",
    d: "M627.468,461.874,535.121,343.006l-92.7,12.01-.036-.278,92.859-12.031.049.064L627.689,461.7Z",
    transform: "translate(-442.385 -342.707)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_378",
    "data-name": "Grupo 378",
    transform: "translate(124.176 80.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_377",
    "data-name": "Grupo 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_376",
    "data-name": "Grupo 376",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1105",
    "data-name": "Caminho 1105",
    d: "M676.629,433.271,584.283,314.4l-92.7,12.011-.036-.278L584.406,314.1l.049.063L676.85,433.1Z",
    transform: "translate(-491.546 -314.103)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_381",
    "data-name": "Grupo 381",
    transform: "translate(137.973 72.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_380",
    "data-name": "Grupo 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_379",
    "data-name": "Grupo 379",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1106",
    "data-name": "Caminho 1106",
    d: "M725.79,404.668,633.444,285.8l-92.7,12.01-.036-.278L633.567,285.5l.049.064L726.011,404.5Z",
    transform: "translate(-540.708 -285.501)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_384",
    "data-name": "Grupo 384",
    transform: "translate(151.771 64.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_383",
    "data-name": "Grupo 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_382",
    "data-name": "Grupo 382",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1107",
    "data-name": "Caminho 1107",
    d: "M774.951,376.065,682.6,257.2l-92.7,12.011-.036-.278L682.728,256.9l.049.064,92.395,118.932Z",
    transform: "translate(-589.869 -256.898)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    "data-name": "Grupo 387",
    transform: "translate(165.568 56.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_386",
    "data-name": "Grupo 386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_385",
    "data-name": "Grupo 385",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1108",
    "data-name": "Caminho 1108",
    d: "M824.112,347.463,731.766,228.6l-92.7,12.01-.036-.278L731.889,228.3l.049.063,92.395,118.931Z",
    transform: "translate(-639.03 -228.297)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_390",
    "data-name": "Grupo 390",
    transform: "translate(179.365 48.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    "data-name": "Grupo 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1109",
    "data-name": "Caminho 1109",
    d: "M873.273,318.859,780.926,199.991,688.226,212l-.036-.278,92.859-12.031.049.064,92.4,118.932Z",
    transform: "translate(-688.19 -199.692)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_393",
    "data-name": "Grupo 393",
    transform: "translate(193.163 40.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_392",
    "data-name": "Grupo 392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    "data-name": "Grupo 391",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1110",
    "data-name": "Caminho 1110",
    d: "M922.434,290.257,830.088,171.389l-92.7,12.011-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-737.351 -171.09)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_396",
    "data-name": "Grupo 396",
    transform: "translate(206.96 32.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_395",
    "data-name": "Grupo 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_394",
    "data-name": "Grupo 394",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1111",
    "data-name": "Caminho 1111",
    d: "M971.6,261.655,879.249,142.787l-92.7,12.01-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-786.513 -142.488)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_399",
    "data-name": "Grupo 399",
    transform: "translate(220.757 24.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_398",
    "data-name": "Grupo 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_397",
    "data-name": "Grupo 397",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1112",
    "data-name": "Caminho 1112",
    d: "M1020.756,233.051,928.409,114.183l-92.7,12.01-.036-.278,92.859-12.031.049.064,92.4,118.932Z",
    transform: "translate(-835.674 -113.883)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_402",
    "data-name": "Grupo 402",
    transform: "translate(234.555 16.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_401",
    "data-name": "Grupo 401",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_400",
    "data-name": "Grupo 400",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1113",
    "data-name": "Caminho 1113",
    d: "M1069.917,204.448,977.571,85.58l-92.7,12.011-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-884.835 -85.281)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_405",
    "data-name": "Grupo 405",
    transform: "translate(248.352 8.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_404",
    "data-name": "Grupo 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_403",
    "data-name": "Grupo 403",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1114",
    "data-name": "Caminho 1114",
    d: "M1119.078,175.846,1026.732,56.978l-92.7,12.01L934,68.71l92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-933.996 -56.679)",
    fill: "#f4ae3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_408",
    "data-name": "Grupo 408",
    transform: "translate(262.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_407",
    "data-name": "Grupo 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_406",
    "data-name": "Grupo 406",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1115",
    "data-name": "Caminho 1115",
    d: "M1168.239,147.243,1075.893,28.375l-92.7,12.011-.036-.278,92.859-12.031.049.063,92.4,118.932Z",
    transform: "translate(-983.157 -28.077)",
    fill: "#f4ae3d"
  })))))))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1116",
    "data-name": "Caminho 1116",
    d: "M207.361,1077.4l-31.145-17.982v64.966l31.145,17.982Z",
    transform: "translate(-126.76 -762.088)",
    fill: "#506689"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1117",
    "data-name": "Caminho 1117",
    d: "M210.763,1105.412l-22.988-13.272V1113.5l22.988,13.272Z",
    transform: "translate(-135.075 -785.626)",
    fill: "#95bfff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1118",
    "data-name": "Caminho 1118",
    d: "M210.763,1129.491l-6.716-3.877-16.272,9.272v2.69l8.357,4.825,14.631-8.337Z",
    transform: "translate(-135.075 -809.705)",
    fill: "#b4d2ff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1119",
    "data-name": "Caminho 1119",
    d: "M304.067,1110.888V1182.9l-2.005,1.157v-72.009Z",
    transform: "translate(-217.287 -799.112)",
    fill: "#fefefe"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1120",
    "data-name": "Caminho 1120",
    d: "M171.077,1034.325v72.009l-2.005,1.157v-72.008Z",
    transform: "translate(-121.621 -744.037)",
    fill: "#aebccd"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1121",
    "data-name": "Caminho 1121",
    d: "M196.1,1048.41l-42.124-24.376-2.005,1.157,42.124,24.376Z",
    transform: "translate(-109.32 -736.635)",
    fill: "#fefefe"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1122",
    "data-name": "Caminho 1122",
    d: "M194.1,1052.535v72.009l-4.8-2.792v-67.006l-32.525-18.792v67.1l-4.8-2.792v-72.1Z",
    transform: "translate(-109.321 -739.602)",
    fill: "#778fac"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1123",
    "data-name": "Caminho 1123",
    d: "M757.862,1215.634v8.969l8.672-13.039V1202.6Z",
    transform: "translate(-545.164 -865.082)",
    fill: "#fcb64a"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1124",
    "data-name": "Caminho 1124",
    d: "M757.862,1294.744v8.969l8.672-13.039V1281.7Z",
    transform: "translate(-545.164 -921.989)",
    fill: "#fcb64a"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1125",
    "data-name": "Caminho 1125",
    d: "M757.862,1373.853v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-545.164 -978.895)",
    fill: "#fcb64a"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1126",
    "data-name": "Caminho 1126",
    d: "M757.862,1452.963v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-545.164 -1035.802)",
    fill: "#fcb64a"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1127",
    "data-name": "Caminho 1127",
    d: "M1106.153,1007.8v8.969l8.672-13.039V994.76Z",
    transform: "translate(-795.705 -715.576)",
    fill: "#fcb64a"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1128",
    "data-name": "Caminho 1128",
    d: "M1106.153,1086.908v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-795.705 -772.483)",
    fill: "#fcb64a"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1129",
    "data-name": "Caminho 1129",
    d: "M1106.153,1166.018v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-795.705 -829.39)",
    fill: "#fcb64a"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1130",
    "data-name": "Caminho 1130",
    d: "M1106.153,1245.127v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-795.705 -886.297)",
    fill: "#fcb64a"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1131",
    "data-name": "Caminho 1131",
    d: "M1192.3,981.142v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-857.671 -705.78)",
    fill: "#fc9800"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1132",
    "data-name": "Caminho 1132",
    d: "M1192.3,1060.251v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-857.671 -762.687)",
    fill: "#fc9800"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1133",
    "data-name": "Caminho 1133",
    d: "M1192.3,1139.361v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-857.671 -819.594)",
    fill: "#fc9800"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1134",
    "data-name": "Caminho 1134",
    d: "M1192.3,1218.471v8.969l3.623,2.092v-8.969Z",
    transform: "translate(-857.671 -876.501)",
    fill: "#fc9800"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1135",
    "data-name": "Caminho 1135",
    d: "M1544.209,1021.695v-8.969l-3.623-2.092v8.969Z",
    transform: "translate(-1108.212 -726.996)",
    fill: "#fc9800"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1136",
    "data-name": "Caminho 1136",
    d: "M1544.209,942.586v-8.969l-3.623-2.092v8.969Z",
    transform: "translate(-1108.212 -670.089)",
    fill: "#fc9800"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1137",
    "data-name": "Caminho 1137",
    d: "M1544.209,863.476v-8.969l-3.623-2.092v8.969Z",
    transform: "translate(-1108.212 -613.182)",
    fill: "#fc9800"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1138",
    "data-name": "Caminho 1138",
    d: "M1544.209,775.4l-3.623-2.092v8.968l3.623,2.092Z",
    transform: "translate(-1108.212 -556.275)",
    fill: "#fc9800"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1139",
    "data-name": "Caminho 1139",
    d: "M1205.2,955.175v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-866.957 -677.722)",
    fill: "#fcb64a"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1140",
    "data-name": "Caminho 1140",
    d: "M1205.2,1034.285v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-866.957 -734.629)",
    fill: "#fcb64a"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1141",
    "data-name": "Caminho 1141",
    d: "M1205.2,1113.394v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-866.957 -791.536)",
    fill: "#fcb64a"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1142",
    "data-name": "Caminho 1142",
    d: "M1205.2,1192.5v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-866.957 -848.443)",
    fill: "#fcb64a"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1143",
    "data-name": "Caminho 1143",
    d: "M1553.5,747.34v8.969l8.672-13.039V734.3Z",
    transform: "translate(-1117.498 -528.216)",
    fill: "#fcb64a"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1144",
    "data-name": "Caminho 1144",
    d: "M1553.5,826.449v8.969l8.672-13.039V813.41Z",
    transform: "translate(-1117.498 -585.123)",
    fill: "#fcb64a"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1145",
    "data-name": "Caminho 1145",
    d: "M1553.5,905.559v8.969l8.672-13.039V892.52Z",
    transform: "translate(-1117.498 -642.03)",
    fill: "#fcb64a"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1146",
    "data-name": "Caminho 1146",
    d: "M1553.5,984.668v8.969l8.672-13.039v-8.969Z",
    transform: "translate(-1117.498 -698.937)",
    fill: "#fcb64a"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1147",
    "data-name": "Caminho 1147",
    d: "M1312.826,1490.9l-1.661-.965-1.509-.877-17.686-10.28-5.7-3.311a3.357,3.357,0,0,0-3.17.392l-5.695,3.288a9.85,9.85,0,0,0-4.03,4.427l-8.044,17.551a10.155,10.155,0,0,1-3.855,4.5l-7.528,4.346c.08.478.132,4.54.132,4.54l13.093-5.575,3.137-.591,9.391-13.955,18.745,10.9,12.894-8.107-4.42-2.569Z",
    transform: "translate(-902.022 -1061.196)",
    fill: "#ffd554"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1148",
    "data-name": "Caminho 1148",
    d: "M1306.908,1487.462l-1.661-.965-1.509-.877-17.686-10.28-5.7-3.311a3.356,3.356,0,0,0-3.169.392l-5.7,3.288a9.85,9.85,0,0,0-4.03,4.427l-8.044,17.55a10.155,10.155,0,0,1-3.855,4.5l-7.528,4.346c.079.478.132,4.54.132,4.54l13.094-5.575,3.137-.591,9.391-13.955,18.745,10.9,12.894-8.107-4.42-2.569Z",
    transform: "translate(-897.765 -1058.721)",
    fill: "#f4ae3d"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1149",
    "data-name": "Caminho 1149",
    d: "M1366.73,1515.4l-23.2-13.48-23.243,13.507,23.2,13.48Z",
    transform: "translate(-949.743 -1080.4)",
    fill: "#ffde54"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1150",
    "data-name": "Caminho 1150",
    d: "M1320.234,1501.237a9.852,9.852,0,0,0-2.572,3.4l-7.632,19.589a2.076,2.076,0,0,0-.13.385l8.39-12.466,5.7,3.312,13.047,7.583,9.949-6.255Z",
    transform: "translate(-942.269 -1079.908)",
    fill: "#ffc533"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1151",
    "data-name": "Caminho 1151",
    d: "M1272.9,1553.174l-23.242,13.507-3.848-2.236,1.51,3.595,19.349,11.244,25.58-14.866Z",
    transform: "translate(-896.163 -1117.268)",
    fill: "#1c1f29"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1152",
    "data-name": "Caminho 1152",
    d: "M1271.591,1547.187l-23.243,13.507-2.542-1.477.2,2.836,20.655,12,25.58-14.866Z",
    transform: "translate(-896.163 -1112.962)",
    fill: "#3f424a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_415",
    "data-name": "Grupo 415",
    transform: "translate(364.939 438.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_414",
    "data-name": "Grupo 414",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_776",
    "data-name": "Ret\\xE2ngulo 776",
    width: 32.903,
    height: 14.297,
    transform: "translate(-0.001)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_417",
    "data-name": "Grupo 417",
    transform: "translate(364.953 437.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_416",
    "data-name": "Grupo 416",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_777",
    "data-name": "Ret\\xE2ngulo 777",
    width: 32.948,
    height: 10.317,
    transform: "translate(-0.06)",
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_418",
    "data-name": "Grupo 418",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1155",
    "data-name": "Caminho 1155",
    d: "M1333.511,1535.94l-14.947,8.687a3.1,3.1,0,0,1-2.816,0l-14-8.085a.862.862,0,0,1-.009-1.632l14.947-8.686Z",
    transform: "translate(-935.979 -1097.882)",
    fill: "#66686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1156",
    "data-name": "Caminho 1156",
    d: "M1351.212,1503.481l-6.767-3.907a.983.983,0,0,0-.223-.093c-.433-.167-.764.07-.766.589v.031l-.024,9.153a2,2,0,0,1-1,1.73l-6.443,3.744a.556.556,0,0,0,.007,1.053l6.767,3.907a1.435,1.435,0,0,0,.263.114,2.029,2.029,0,0,0,1.628-.089l5.919-2.887a3.063,3.063,0,0,0,1.524-2.64l.019-9.1v-.031a2,2,0,0,0-.91-1.574",
    transform: "translate(-960.771 -1078.606)",
    fill: "#57595a"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    transform: "translate(373.322 437.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_779",
    "data-name": "Ret\\xE2ngulo 779",
    width: 16.775,
    height: 4.895,
    fill: "url(#linear-gradient-3)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_423",
    "data-name": "Grupo 423",
    transform: "translate(381.265 421.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_780",
    "data-name": "Ret\\xE2ngulo 780",
    width: 16.792,
    height: 17.852,
    transform: "translate(-7.645 6.1) rotate(-38.585)",
    fill: "url(#linear-gradient-4)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(388.362 428.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_424",
    "data-name": "Grupo 424",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_781",
    "data-name": "Ret\\xE2ngulo 781",
    width: 1.87,
    height: 8.967,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_427",
    "data-name": "Grupo 427",
    transform: "translate(373.164 435.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426",
    "data-name": "Grupo 426",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_782",
    "data-name": "Ret\\xE2ngulo 782",
    width: 6.063,
    height: 16.194,
    transform: "translate(-0.268 5.393) rotate(-87.614)",
    fill: "url(#linear-gradient-6)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    transform: "translate(381.62 420.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_783",
    "data-name": "Ret\\xE2ngulo 783",
    width: 16.3,
    height: 17.099,
    transform: "matrix(0.79, -0.612, 0.612, 0.79, -6.85, 5.307)",
    fill: "url(#linear-gradient-7)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_431",
    "data-name": "Grupo 431",
    transform: "translate(373.16 436.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_430",
    "data-name": "Grupo 430",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_784",
    "data-name": "Ret\\xE2ngulo 784",
    width: 15.944,
    height: 6.568,
    transform: "translate(-0.001)",
    fill: "url(#linear-gradient-8)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_433",
    "data-name": "Grupo 433",
    transform: "translate(373.385 421.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_432",
    "data-name": "Grupo 432",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_785",
    "data-name": "Ret\\xE2ngulo 785",
    width: 24.468,
    height: 23.572,
    transform: "matrix(0.481, -0.877, 0.877, 0.481, -8.068, 14.463)",
    fill: "url(#linear-gradient-9)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    "data-name": "Grupo 435",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_434",
    "data-name": "Grupo 434",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1164",
    "data-name": "Caminho 1164",
    d: "M1261.478,1583.557l5.7,3.312-7.528,4.346-5.7-3.312Z",
    transform: "translate(-902.022 -1139.124)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1165",
    "data-name": "Caminho 1165",
    d: "M1217.982,1594.007l-5.7-3.311c-1.23-.663-2.907-.541-4.752.525-.157.091-.313.187-.467.288a15.066,15.066,0,0,0-6.319,11.467c.006,2.106.736,3.6,1.919,4.326l5.7,3.311,9.62-9.74Z",
    transform: "translate(-863.749 -1143.965)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1166",
    "data-name": "Caminho 1166",
    d: "M1227.834,1603.02q-.235.136-.467.288a15.066,15.066,0,0,0-6.319,11.467c.006,2.106.736,3.6,1.919,4.325,1.243.763,2.985.677,4.912-.435a15.2,15.2,0,0,0,6.532-9.46,10.876,10.876,0,0,0,.253-2.292c-.012-4.322-3.07-6.064-6.829-3.894",
    transform: "translate(-878.354 -1152.453)",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1167",
    "data-name": "Caminho 1167",
    d: "M1320.128,1600v6.865l31.019-18.026v-6.865Z",
    transform: "translate(-949.626 -1137.986)",
    fill: "#ffbe17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1168",
    "data-name": "Caminho 1168",
    d: "M1466.13,1573.833l5.7,3.312v-6.865c0-3.812-5.7-3.312-5.7-3.312Z",
    transform: "translate(-1054.652 -1127.175)",
    fill: "#d28800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1169",
    "data-name": "Caminho 1169",
    d: "M1431.229,1580.508l-5.7-3.312c-1.23-.663-2.906-.541-4.752.525-.156.091-.312.187-.467.288a15.065,15.065,0,0,0-6.32,11.467c.006,2.106.736,3.6,1.919,4.325l5.7,3.312,9.62-9.74Z",
    transform: "translate(-1017.147 -1134.255)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1170",
    "data-name": "Caminho 1170",
    d: "M1441.082,1589.521q-.235.136-.467.288a15.066,15.066,0,0,0-6.32,11.467c.006,2.106.736,3.6,1.919,4.326,1.243.762,2.985.677,4.912-.435a15.2,15.2,0,0,0,6.532-9.46,10.851,10.851,0,0,0,.253-2.292c-.012-4.322-3.07-6.064-6.829-3.894",
    transform: "translate(-1031.752 -1142.743)",
    fill: "#33363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1171",
    "data-name": "Caminho 1171",
    d: "M1450.5,1613.027c-1.74,1-3.153.2-3.159-1.8a6.913,6.913,0,0,1,3.139-5.436c1.738-1,3.153-.2,3.159,1.8a6.92,6.92,0,0,1-3.139,5.437",
    transform: "translate(-1041.133 -1154.807)",
    fill: "#8d8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1172",
    "data-name": "Caminho 1172",
    d: "M1451.82,1614.8a.954.954,0,0,1-1.569-.894,3.433,3.433,0,0,1,1.559-2.7,1.147,1.147,0,0,1,1.049-.143,1.056,1.056,0,0,1,.521,1.037,3.438,3.438,0,0,1-1.559,2.7",
    transform: "translate(-1043.23 -1158.862)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1173",
    "data-name": "Caminho 1173",
    d: "M1451.879,1615.1l1.039.18,1.758-3.23-.646-.8Z",
    transform: "translate(-1044.401 -1159.046)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1174",
    "data-name": "Caminho 1174",
    d: "M1455.2,1616.978c-.724.418-1.312.082-1.314-.749a2.875,2.875,0,0,1,1.306-2.261.928.928,0,0,1,.927-.094.914.914,0,0,1,.387.843,2.877,2.877,0,0,1-1.305,2.261",
    transform: "translate(-1045.847 -1160.871)",
    fill: "#c8c9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1175",
    "data-name": "Caminho 1175",
    d: "M1453.73,1605.557a2.523,2.523,0,0,1,.552,1.72,6.92,6.92,0,0,1-3.139,5.437,2.5,2.5,0,0,1-1.841.377,2,2,0,0,0,2.607.08,6.92,6.92,0,0,0,3.139-5.437c0-1.209-.524-1.977-1.318-2.177",
    transform: "translate(-1042.547 -1154.95)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1176",
    "data-name": "Caminho 1176",
    d: "M1410.6,1530.461a3.356,3.356,0,0,0-3.169.392l-5.7,3.288a9.853,9.853,0,0,0-4.03,4.427l-7.632,19.59c-.89,1.944,1.43,5.775,1.43,5.775l3.137-.591s14.107-20.964,14.11-20.962l.054.027.015.008.05.026.019.01.045.025.022.012.041.023.026.015.036.022.03.018.032.02.033.021.028.018.037.025.025.017.038.027.023.017.04.029.019.015.043.032.016.013.044.035.014.012.046.038.011.01.048.041.058.052.058.054.057.055.055.056.055.058.054.059.049.056c.71-.709,6.325-9.554,6.325-9.554Z",
    transform: "translate(-999.795 -1100.755)",
    fill: "#f4ae3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1177",
    "data-name": "Caminho 1177",
    d: "M1366.059,1633.083l-5.7-3.311-11.8,6.81,5.7,3.312Z",
    transform: "translate(-970.083 -1172.368)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1178",
    "data-name": "Caminho 1178",
    d: "M1346.032,1659.648l5.7,3.311v-6.865c0-3.812-5.7-3.312-5.7-3.312Z",
    transform: "translate(-968.26 -1188.905)",
    fill: "#d28800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1179",
    "data-name": "Caminho 1179",
    d: "M1312.6,1649l-5.7-3.311c-1.23-.663-2.906-.541-4.752.525-.157.091-.313.187-.467.288a15.066,15.066,0,0,0-6.32,11.467c.006,2.106.737,3.6,1.919,4.325l5.7,3.312,9.62-9.74Z",
    transform: "translate(-931.81 -1183.525)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1180",
    "data-name": "Caminho 1180",
    d: "M1322.45,1658.013q-.235.136-.467.288a15.065,15.065,0,0,0-6.32,11.467c.006,2.106.736,3.6,1.919,4.325,1.243.763,2.985.677,4.912-.435a15.2,15.2,0,0,0,6.532-9.46,10.852,10.852,0,0,0,.252-2.292c-.012-4.322-3.07-6.064-6.829-3.894",
    transform: "translate(-946.415 -1192.012)",
    fill: "#33363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1181",
    "data-name": "Caminho 1181",
    d: "M1331.863,1681.52c-1.74,1-3.153.2-3.159-1.8a6.913,6.913,0,0,1,3.139-5.436c1.738-1,3.153-.2,3.159,1.8a6.919,6.919,0,0,1-3.139,5.436",
    transform: "translate(-955.796 -1204.077)",
    fill: "#8d8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1182",
    "data-name": "Caminho 1182",
    d: "M1333.188,1683.3a.954.954,0,0,1-1.569-.894,3.434,3.434,0,0,1,1.559-2.7,1.147,1.147,0,0,1,1.049-.142,1.056,1.056,0,0,1,.521,1.037,3.438,3.438,0,0,1-1.559,2.7",
    transform: "translate(-957.892 -1208.131)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1183",
    "data-name": "Caminho 1183",
    d: "M1333.247,1683.591l1.039.18,1.758-3.23-.646-.8Z",
    transform: "translate(-959.063 -1208.315)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1184",
    "data-name": "Caminho 1184",
    d: "M1336.571,1685.47c-.724.418-1.312.082-1.314-.749a2.876,2.876,0,0,1,1.306-2.261.928.928,0,0,1,.927-.094.914.914,0,0,1,.387.843,2.878,2.878,0,0,1-1.305,2.261",
    transform: "translate(-960.509 -1210.14)",
    fill: "#c8c9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1185",
    "data-name": "Caminho 1185",
    d: "M1335.1,1674.049a2.523,2.523,0,0,1,.552,1.72,6.921,6.921,0,0,1-3.139,5.437,2.5,2.5,0,0,1-1.841.376,2,2,0,0,0,2.607.08,6.92,6.92,0,0,0,3.139-5.437c0-1.209-.524-1.977-1.318-2.177",
    transform: "translate(-957.21 -1204.219)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1186",
    "data-name": "Caminho 1186",
    d: "M1246.153,1599.485l-.024-.009c-.664-.387-26.25-15.3-26.531-15.425-1.456-.626-3.368-.418-5.447.782l-4.2,2.424L1242.208,1606l3.561-1.683a12.623,12.623,0,0,1,3.208-1.019l2.867-.5s-5.408-3.188-5.692-3.311",
    transform: "translate(-870.374 -1139.231)",
    fill: "#f4ae3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1187",
    "data-name": "Caminho 1187",
    d: "M1329.074,1651.625c2.079-1.2,3.984-1.409,5.441-.782a4.894,4.894,0,0,1,2.709,3.96,9.524,9.524,0,0,1,.123,1.539l.008,3,0,1.5-.846.489-.007-2.359-.006-2.142c-.013-4.689-3.345-6.588-7.424-4.233l-.467.27-3.732,2.154v-.972Z",
    transform: "translate(-953.043 -1187.277)",
    fill: "#ffcc49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1188",
    "data-name": "Caminho 1188",
    d: "M1402.667,1545.3c-.008-2.941-2.089-4.127-4.649-2.649l-5.7,3.288a9.852,9.852,0,0,0-4.03,4.427l-7.632,19.59-11.8,6.81c.08.478.132,4.54.132,4.54l17.226-9.945-.008-2.774c-.014-4.838,3.312-10.928,7.41-13.5.19-.119.362-.222.539-.32,1.989-1.1,3.8-1.251,5.164-.593l.063.031.016.008.049.026.019.01.045.025.023.012.04.023.026.015.036.022.03.018.032.02.033.021.028.018.037.024.025.018.038.027.023.017.04.029.019.015.043.033.017.013.044.035.015.012.046.038.011.01.048.041.058.052.058.054.057.055.055.056.055.057.054.059.053.06.052.062c.035.042.068.083.1.126a5.009,5.009,0,0,1,.726,1.36l.031.088.029.088.028.09.027.089c.01.035.019.064.027.094l.025.09c.009.036.017.065.024.1s.015.063.022.093.015.064.021.093.015.069.02.1.014.07.02.1.013.069.018.1l0,.015c0,.027.009.054.013.082l0,.021c0,.027.008.053.012.08l0,.022c0,.026.007.052.011.078l0,.026q.005.04.01.08l0,.024c0,.026.006.054.009.081,0,.009,0,.017,0,.025l.008.078c0,.01,0,.019,0,.03,0,.026,0,.052.007.079l0,.029c0,.024,0,.05.006.074s0,.023,0,.035,0,.043,0,.064,0,.031,0,.047,0,.043,0,.064,0,.03,0,.045,0,.05,0,.074l0,.038c0,.025,0,.049,0,.074s0,.026,0,.039,0,.053,0,.079,0,.023,0,.035c0,.038,0,.077,0,.115l.843-.486Z",
    transform: "translate(-984.686 -1109.242)",
    fill: "#ffbe17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1189",
    "data-name": "Caminho 1189",
    d: "M1209.963,1596.356v.973l32.252,18.746v-.973Z",
    transform: "translate(-870.38 -1148.331)",
    fill: "#ffd554"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1190",
    "data-name": "Caminho 1190",
    d: "M1329.259,1628.815l2.446-1.421.877-5.512-1.8,1.043Z",
    transform: "translate(-956.195 -1166.692)",
    fill: "#ffbe17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1191",
    "data-name": "Caminho 1191",
    d: "M1241.464,1573.694l-1.527,5.89,25.069,14.568,1.526-5.89Z",
    transform: "translate(-891.942 -1132.029)",
    fill: "#f4ae3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1192",
    "data-name": "Caminho 1192",
    d: "M1244.9,1570.079l25.8,14.991-1.848,1.074-25.8-14.991Z",
    transform: "translate(-894.183 -1129.428)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1193",
    "data-name": "Caminho 1193",
    d: "M1275.118,1581.229l1.8-1.044-23.867-13.869-1.8,1.044Z",
    transform: "translate(-900.08 -1126.722)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1194",
    "data-name": "Caminho 1194",
    d: "M1434.491,1483.77l-1.2-.7-.063-22.285,1.2.7Z",
    transform: "translate(-1030.983 -1050.81)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1195",
    "data-name": "Caminho 1195",
    d: "M1344.775,1469.231l18.777-10.841.063,22.285,1.1-.637-.067-23.554-20.751,11.98-9.2,35.483,1.8-1.044Z",
    transform: "translate(-960.108 -1047.715)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1196",
    "data-name": "Caminho 1196",
    d: "M1332.115,1532.35l-1.2-.7,9.063-34.968,1.2.7Z",
    transform: "translate(-957.385 -1076.633)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1197",
    "data-name": "Caminho 1197",
    d: "M1364.408,1466.676l-1.2-.7,20.751-11.98,1.2.7Z",
    transform: "translate(-980.615 -1045.926)",
    fill: "#1a1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1198",
    "data-name": "Caminho 1198",
    d: "M1349.432,1434.342l-1.2-.7-.063-22.285,1.2.7Z",
    transform: "translate(-969.797 -1015.255)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1199",
    "data-name": "Caminho 1199",
    d: "M1280.751,1407.056l-20.75,11.98-8.75,33.761,1.8-1.044,7.828-31.95,18.777-10.841.063,22.285,1.1-.636Z",
    transform: "translate(-900.08 -1012.159)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1200",
    "data-name": "Caminho 1200",
    d: "M1247.057,1482.922l-.918-.533-.283-.165,9.063-34.968,1.2.7Z",
    transform: "translate(-896.199 -1041.077)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1201",
    "data-name": "Caminho 1201",
    d: "M1279.35,1417.248l-1.2-.7,20.75-11.98,1.2.7Z",
    transform: "translate(-919.429 -1010.37)",
    fill: "#1a1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1202",
    "data-name": "Caminho 1202",
    d: "M1245.825,1567.548l-.447,1.725,25.068,14.567.447-1.725Z",
    transform: "translate(-895.855 -1127.608)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1203",
    "data-name": "Caminho 1203",
    d: "M1298.285,1492.882l-6.714,3.876.1,51.721,3.357-1.938-.1-49.957,3.353-1.949Z",
    transform: "translate(-929.085 -1073.897)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1204",
    "data-name": "Caminho 1204",
    d: "M1286.278,1555.28l-2.1-1.223-.1-51.722,2.1,1.223Z",
    transform: "translate(-923.692 -1080.698)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1205",
    "data-name": "Caminho 1205",
    d: "M1251.051,1471.042l12.625,7.337v-1.754l-12.625-7.337Z",
    transform: "translate(-899.936 -1056.925)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1206",
    "data-name": "Caminho 1206",
    d: "M1242.447,1469.288l.1,51.721-3.357,1.938-.1-51.721Z",
    transform: "translate(-891.333 -1056.925)",
    fill: "#33363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1207",
    "data-name": "Caminho 1207",
    d: "M1233.8,1524.781l-2.1-1.223-.1-51.721,2.1,1.223Z",
    transform: "translate(-885.939 -1058.758)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1208",
    "data-name": "Caminho 1208",
    d: "M1255.14,1467.808l-16.833-9.782-6.714,3.876,2.1,1.223,3.357-1.938,12.625,7.337-3.357,1.938,2.1,1.223,3.357-1.938Z",
    transform: "translate(-885.939 -1048.824)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1209",
    "data-name": "Caminho 1209",
    d: "M1197.8,1563.2l-.776.451a.843.843,0,0,0-.145.111l-.032.031a.94.94,0,0,0-.119.147,1,1,0,0,0-.067.12l-.006.016c-.012.027-.024.054-.035.082s-.009.028-.014.042l-.008.026c0,.008-.006.015-.008.023-.008.029-.016.058-.023.088,0,.01,0,.021-.006.031l0,.021c0,.011,0,.021-.006.032,0,.027-.009.054-.012.082s0,.031,0,.046l0,.017c0,.007,0,.013,0,.02,0,.026,0,.053-.005.081s0,.055,0,.083c0,.005-1.143,19.988-1.143,19.988l-.649,6.491,1.72.993,1.553-.9.044-15.668c.012-.007.027-11.8.027-11.8,0-.065,0-.128.009-.188,0-.005,0-.011,0-.016.006-.056.014-.109.024-.16l0-.021q.016-.074.037-.142l.009-.026a1.16,1.16,0,0,1,.048-.123,1.057,1.057,0,0,1,.073-.136.937.937,0,0,1,.119-.147l.032-.031a.829.829,0,0,1,.146-.111Z",
    transform: "translate(-859.424 -1124.157)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1210",
    "data-name": "Caminho 1210",
    d: "M1202.737,1607.247l.927-.539,26.678,15.393-.927.539Z",
    transform: "translate(-865.182 -1155.778)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1211",
    "data-name": "Caminho 1211",
    d: "M1287.3,1640.937l.676-.4v4.191l-.592.344-.084.061Z",
    transform: "translate(-926.015 -1180.109)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1212",
    "data-name": "Caminho 1212",
    d: "M1284.451,1643.909l0,3.2.8.451v-3.2Z",
    transform: "translate(-923.961 -1182.538)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1213",
    "data-name": "Caminho 1213",
    d: "M1272.743,1632.54l.676-.405v4.191l-.592.344-.084.061Z",
    transform: "translate(-915.54 -1174.068)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1214",
    "data-name": "Caminho 1214",
    d: "M1269.889,1635.511l0,3.2.8.451v-3.2Z",
    transform: "translate(-913.486 -1176.497)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1215",
    "data-name": "Caminho 1215",
    d: "M1258.181,1624.142l.676-.4v4.191l-.592.344-.084.061Z",
    transform: "translate(-905.065 -1168.027)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1216",
    "data-name": "Caminho 1216",
    d: "M1255.327,1627.113l0,3.2.8.451v-3.2Z",
    transform: "translate(-903.011 -1170.456)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1217",
    "data-name": "Caminho 1217",
    d: "M1243.619,1615.744l.676-.405v4.191l-.592.344-.084.061Z",
    transform: "translate(-894.59 -1161.986)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1218",
    "data-name": "Caminho 1218",
    d: "M1240.765,1618.715l0,3.2.8.451v-3.2Z",
    transform: "translate(-892.536 -1164.415)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1219",
    "data-name": "Caminho 1219",
    d: "M1229.057,1607.346l.676-.405v4.191l-.592.344-.084.061Z",
    transform: "translate(-884.115 -1155.945)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1220",
    "data-name": "Caminho 1220",
    d: "M1226.2,1610.317l0,3.2.8.451v-3.2Z",
    transform: "translate(-882.061 -1158.374)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1221",
    "data-name": "Caminho 1221",
    d: "M1214.5,1598.948l.676-.405v4.191l-.592.344-.084.061Z",
    transform: "translate(-873.64 -1149.904)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1222",
    "data-name": "Caminho 1222",
    d: "M1211.641,1601.92l0,3.2.8.451v-3.2Z",
    transform: "translate(-871.586 -1152.333)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1223",
    "data-name": "Caminho 1223",
    d: "M1202.737,1592.558l.927-.539,26.678,15.393-.927.538Z",
    transform: "translate(-865.182 -1145.212)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1224",
    "data-name": "Caminho 1224",
    d: "M1284.451,1610.214l0,8.507.8.451v-8.507Z",
    transform: "translate(-923.961 -1158.3)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1225",
    "data-name": "Caminho 1225",
    d: "M1287.3,1607.243l.7-.4-.021,9.5-.592.344-.084.061Z",
    transform: "translate(-926.015 -1155.871)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1226",
    "data-name": "Caminho 1226",
    d: "M1214.5,1565.254l.7-.405-.021,9.5-.592.344-.084.061Z",
    transform: "translate(-873.64 -1125.667)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1227",
    "data-name": "Caminho 1227",
    d: "M1211.641,1568.225l0,8.507.8.451v-8.507Z",
    transform: "translate(-871.586 -1128.095)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1228",
    "data-name": "Caminho 1228",
    d: "M1229.057,1573.652l.7-.4-.021,9.5-.592.344-.084.061Z",
    transform: "translate(-884.115 -1131.708)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1229",
    "data-name": "Caminho 1229",
    d: "M1226.2,1576.623l0,8.507.8.451v-8.507Z",
    transform: "translate(-882.061 -1134.136)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1230",
    "data-name": "Caminho 1230",
    d: "M1243.619,1582.05l.7-.405-.021,9.5-.592.344-.084.061Z",
    transform: "translate(-894.59 -1137.748)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1231",
    "data-name": "Caminho 1231",
    d: "M1240.765,1585.021l0,8.507.8.451v-8.507Z",
    transform: "translate(-892.536 -1140.177)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1232",
    "data-name": "Caminho 1232",
    d: "M1258.181,1590.447l.7-.4-.021,9.5-.592.344-.084.061Z",
    transform: "translate(-905.065 -1143.789)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1233",
    "data-name": "Caminho 1233",
    d: "M1255.327,1593.419l0,8.507.8.451v-8.507Z",
    transform: "translate(-903.011 -1146.218)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1234",
    "data-name": "Caminho 1234",
    d: "M1272.743,1598.845l.7-.405-.021,9.5-.592.344-.084.061Z",
    transform: "translate(-915.54 -1149.83)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1235",
    "data-name": "Caminho 1235",
    d: "M1269.889,1601.816l0,8.507.8.451v-8.507Z",
    transform: "translate(-913.486 -1152.259)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1236",
    "data-name": "Caminho 1236",
    d: "M1202.737,1647.2l.927-.539,26.588,15.35-.926.539Z",
    transform: "translate(-865.182 -1184.517)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1237",
    "data-name": "Caminho 1237",
    d: "M1297.375,1703.244l1.552-.9-.006,2.333-1.552.9Z",
    transform: "translate(-933.254 -1224.571)",
    fill: "#4f5156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1238",
    "data-name": "Caminho 1238",
    d: "M1226,1572.223l1.552-.9.782.452-1.553.9Z",
    transform: "translate(-881.919 -1130.322)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1239",
    "data-name": "Caminho 1239",
    d: "M1228.784,1573.832l1.553-.9,0,.75-1.552.9Z",
    transform: "translate(-883.917 -1131.479)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1240",
    "data-name": "Caminho 1240",
    d: "M1202.737,1622.228l.927-.539,26.588,15.351-.926.538Z",
    transform: "translate(-865.182 -1166.555)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1241",
    "data-name": "Caminho 1241",
    d: "M1240.661,1580.686l1.552-.9.782.452-1.553.9Z",
    transform: "translate(-892.462 -1136.409)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1242",
    "data-name": "Caminho 1242",
    d: "M1243.441,1582.294l1.553-.9,0,.75-1.552.9Z",
    transform: "translate(-894.461 -1137.567)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1243",
    "data-name": "Caminho 1243",
    d: "M1297.454,1675.386l1.552-.9-.006,2.334-1.552.9Z",
    transform: "translate(-933.311 -1204.532)",
    fill: "#4f5156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1244",
    "data-name": "Caminho 1244",
    d: "M1202.737,1623.609v2.337l26.581,15.347.007-2.334Z",
    transform: "translate(-865.182 -1167.935)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1245",
    "data-name": "Caminho 1245",
    d: "M1255.323,1589.151l1.552-.9.781.451-1.553.9Z",
    transform: "translate(-903.009 -1142.499)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1246",
    "data-name": "Caminho 1246",
    d: "M1258.1,1590.756l1.552-.9,0,.75-1.552.9Z",
    transform: "translate(-905.004 -1143.654)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1247",
    "data-name": "Caminho 1247",
    d: "M1272.76,1599.221l1.552-.9,0,.75-1.552.9Z",
    transform: "translate(-915.551 -1149.743)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1248",
    "data-name": "Caminho 1248",
    d: "M1269.98,1597.613l1.552-.9.782.451-1.553.9Z",
    transform: "translate(-913.553 -1148.586)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1249",
    "data-name": "Caminho 1249",
    d: "M1287.417,1607.684l1.553-.9,0,.75-1.552.9Z",
    transform: "translate(-926.095 -1155.83)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1250",
    "data-name": "Caminho 1250",
    d: "M1284.637,1606.075l1.552-.9.782.452-1.553.9Z",
    transform: "translate(-924.096 -1154.673)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1251",
    "data-name": "Caminho 1251",
    d: "M1221.894,1571.8a7.562,7.562,0,0,1,3.427,5.935l-.072,27.468-1.72-.993.008-2.692.007-2.334.016-5.485.007-2.334.008-2.831,0-.9.007-2.471,0-.9.015-7.526a3.779,3.779,0,0,0-1.713-2.967l-23.642-13.65c-.946-.546-1.72-.106-1.723.983l-.072,27.468-1.72-.993.072-27.468c.006-2.178,1.554-3.059,3.448-1.965Z",
    transform: "translate(-859.423 -1120.507)",
    fill: "#323436"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    "data-name": "Grupo 437",
    transform: "translate(336.384 436.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    "data-name": "Grupo 436",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_787",
    "data-name": "Ret\\xE2ngulo 787",
    width: 51.784,
    height: 57.521,
    transform: "matrix(0.853, -0.522, 0.522, 0.853, -21.567, 13.208)",
    fill: "url(#linear-gradient-10)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    "data-name": "Grupo 439",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    "data-name": "Grupo 438",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1253",
    "data-name": "Caminho 1253",
    d: "M1202.737,1648.58v2.337l26.581,15.347.007-2.334Z",
    transform: "translate(-865.182 -1185.898)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1254",
    "data-name": "Caminho 1254",
    d: "M1263.024,1655.424l1.552-.9,3.51,2.027-1.569.9Z",
    transform: "translate(-908.549 -1190.172)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1255",
    "data-name": "Caminho 1255",
    d: "M1203.673,1662.646l-2.223.844.231,14.061a3.293,3.293,0,0,1-1.688,2.876s-20.094,13.108-23.267,14.174a4.782,4.782,0,0,1-.634.175l-.059.01-.055.007-.051,0h-.089l-.038,0-.033-.007-.029-.009-.021-.01a.1.1,0,0,1-.053-.092l-.005,1.167a.1.1,0,0,0,.053.091l.021.01.029.009.033.006.038,0h.042l.047,0,.051,0,.055-.007.059-.01a4.756,4.756,0,0,0,.634-.175c3.093-1.039,12.764-6.217,19.633-9.985,3.756-2.06,6.688-3.708,7.133-3.958a3.358,3.358,0,0,0,1.755-2.876v-17.206Z",
    transform: "translate(-845.705 -1195.367)",
    fill: "#383b3f"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(329.961 465.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440",
    "data-name": "Grupo 440",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_789",
    "data-name": "Ret\\xE2ngulo 789",
    width: 44.741,
    height: 42.577,
    transform: "matrix(0.502, -0.865, 0.865, 0.502, -16.113, 26.127)",
    fill: "url(#linear-gradient-11)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    "data-name": "Grupo 442",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1257",
    "data-name": "Caminho 1257",
    d: "M1214.715,1626.155l1.552-.9,3.51,2.027-1.569.9Z",
    transform: "translate(-873.798 -1169.118)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1258",
    "data-name": "Caminho 1258",
    d: "M1156.933,1632.474l-1.569.9-2.223.844.231,14.061a3.294,3.294,0,0,1-1.688,2.876s-20.094,13.108-23.267,14.174a4.73,4.73,0,0,1-.634.175l-.059.01-.055.007-.051,0-.047,0h-.042l-.038,0-.033-.006-.029-.01-.021-.01a.1.1,0,0,1-.04-.038.1.1,0,0,1-.013-.053l-.005,1.167a.1.1,0,0,0,.053.091l.02.01.029.009.033.007.038,0h.042l.046,0,.051,0,.055-.007.059-.01a4.7,4.7,0,0,0,.634-.175c3.093-1.039,12.764-6.22,19.633-9.988,3.756-2.052,6.688-3.7,7.132-3.954a3.358,3.358,0,0,0,1.755-2.876Z",
    transform: "translate(-810.953 -1174.312)",
    fill: "#383b3f"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_445",
    "data-name": "Grupo 445",
    transform: "translate(316.403 457.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_444",
    "data-name": "Grupo 444",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_791",
    "data-name": "Ret\\xE2ngulo 791",
    width: 44.742,
    height: 42.577,
    transform: "matrix(0.502, -0.865, 0.865, 0.502, -16.113, 26.127)",
    fill: "url(#linear-gradient-12)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_447",
    "data-name": "Grupo 447",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_446",
    "data-name": "Grupo 446",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1260",
    "data-name": "Caminho 1260",
    d: "M1202.737,1593.938v.953l26.671,15.389.007-.949Z",
    transform: "translate(-865.182 -1146.592)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1261",
    "data-name": "Caminho 1261",
    d: "M1202.737,1608.627v.953l26.671,15.389.007-.949Z",
    transform: "translate(-865.182 -1157.158)",
    fill: "#37383c"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_449",
    "data-name": "Grupo 449",
    transform: "translate(369.26 392.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_448",
    "data-name": "Grupo 448",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_793",
    "data-name": "Ret\\xE2ngulo 793",
    width: 33.707,
    height: 14.659,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_451",
    "data-name": "Grupo 451",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_450",
    "data-name": "Grupo 450",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1263",
    "data-name": "Caminho 1263",
    d: "M1325.115,1427.919l-.005,1.872-.977-.564.005-1.872Z",
    transform: "translate(-952.507 -1026.761)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1264",
    "data-name": "Caminho 1264",
    d: "M1336.689,1405.783l-11.561,6.718-.977-.564,11.561-6.718Z",
    transform: "translate(-952.521 -1010.838)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1265",
    "data-name": "Caminho 1265",
    d: "M1339.179,1407.228l-.005.954-11.56,6.718.005-.954Z",
    transform: "translate(-955.011 -1012.283)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1266",
    "data-name": "Caminho 1266",
    d: "M1351.381,1414.273l-.005.954-11.56,6.718.005-.954Z",
    transform: "translate(-963.789 -1017.35)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1267",
    "data-name": "Caminho 1267",
    d: "M1337.317,1434.963l-.005,1.873-.977-.564.005-1.873Z",
    transform: "translate(-961.285 -1031.828)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1268",
    "data-name": "Caminho 1268",
    d: "M1348.891,1412.828l-11.561,6.718-.977-.564,11.561-6.718Z",
    transform: "translate(-961.298 -1015.905)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1269",
    "data-name": "Caminho 1269",
    d: "M1363.589,1421.321l-.005.954-11.561,6.718.005-.954Z",
    transform: "translate(-972.57 -1022.42)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1270",
    "data-name": "Caminho 1270",
    d: "M1349.52,1442.009l-.005,1.873-.978-.565.005-1.873Z",
    transform: "translate(-970.062 -1036.896)",
    fill: "#333132"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_453",
    "data-name": "Grupo 453",
    transform: "translate(357.258 399.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_795",
    "data-name": "Ret\\xE2ngulo 795",
    width: 10.873,
    height: 8.585,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_455",
    "data-name": "Grupo 455",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_454",
    "data-name": "Grupo 454",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1272",
    "data-name": "Caminho 1272",
    d: "M1361.723,1449.054l-.005,1.873-.978-.565.005-1.872Z",
    transform: "translate(-978.84 -1041.964)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1273",
    "data-name": "Caminho 1273",
    d: "M1373.3,1426.918l-11.56,6.718-.978-.565,11.561-6.718Z",
    transform: "translate(-978.853 -1026.041)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1274",
    "data-name": "Caminho 1274",
    d: "M1375.79,1428.366l-.005.954-11.561,6.718.005-.954Z",
    transform: "translate(-981.347 -1027.488)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1275",
    "data-name": "Caminho 1275",
    d: "M1279.889,1454.2l-.005,1.873-.977-.564.005-1.873Z",
    transform: "translate(-919.975 -1045.667)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1276",
    "data-name": "Caminho 1276",
    d: "M1387.993,1435.41l-.005.954-11.561,6.718.005-.954Z",
    transform: "translate(-990.125 -1032.556)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1277",
    "data-name": "Caminho 1277",
    d: "M1373.925,1456.1l-.005,1.873-.978-.565.005-1.873Z",
    transform: "translate(-987.617 -1047.032)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1278",
    "data-name": "Caminho 1278",
    d: "M1400.195,1442.455l-.005.954-11.56,6.718.005-.954Z",
    transform: "translate(-998.902 -1037.623)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1279",
    "data-name": "Caminho 1279",
    d: "M1386.126,1463.144l-.005,1.873-.978-.565.005-1.873Z",
    transform: "translate(-996.394 -1052.099)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1280",
    "data-name": "Caminho 1280",
    d: "M1334.5,1438.017l-.005,1.872-22.833-13.182.005-1.873Z",
    transform: "translate(-943.538 -1024.948)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1281",
    "data-name": "Caminho 1281",
    d: "M1293.952,1433.513l-.005.954-11.559,6.718.005-.954Z",
    transform: "translate(-922.478 -1031.191)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1282",
    "data-name": "Caminho 1282",
    d: "M1291.462,1432.068l-11.559,6.718-.977-.564,11.559-6.717Z",
    transform: "translate(-919.988 -1029.746)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1283",
    "data-name": "Caminho 1283",
    d: "M1385.5,1433.963l-11.561,6.718-.978-.565,11.561-6.718Z",
    transform: "translate(-987.631 -1031.108)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1284",
    "data-name": "Caminho 1284",
    d: "M1292.091,1461.246l-.005,1.873-.977-.564.005-1.873Z",
    transform: "translate(-928.752 -1050.734)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1285",
    "data-name": "Caminho 1285",
    d: "M1303.664,1439.113l-11.559,6.718-.977-.564,11.559-6.717Z",
    transform: "translate(-928.765 -1034.813)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1286",
    "data-name": "Caminho 1286",
    d: "M1306.154,1440.558l-.005.953-11.559,6.718.005-.954Z",
    transform: "translate(-931.256 -1036.259)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1287",
    "data-name": "Caminho 1287",
    d: "M1315.867,1446.159l-11.559,6.718-.978-.565,11.559-6.718Z",
    transform: "translate(-937.543 -1039.881)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1288",
    "data-name": "Caminho 1288",
    d: "M1318.361,1447.606l-.005.954-11.559,6.718.005-.954Z",
    transform: "translate(-940.037 -1041.328)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1289",
    "data-name": "Caminho 1289",
    d: "M1304.294,1468.291l-.005,1.873-.978-.565.005-1.872Z",
    transform: "translate(-937.529 -1055.802)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1290",
    "data-name": "Caminho 1290",
    d: "M1316.5,1475.335l-.005,1.873-.978-.565.005-1.873Z",
    transform: "translate(-946.307 -1060.869)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1291",
    "data-name": "Caminho 1291",
    d: "M1328.069,1453.2l-11.559,6.718-.978-.565,11.559-6.717Z",
    transform: "translate(-946.32 -1044.949)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1292",
    "data-name": "Caminho 1292",
    d: "M1330.563,1454.651l-.005.954L1319,1462.322l.005-.954Z",
    transform: "translate(-948.814 -1046.396)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1293",
    "data-name": "Caminho 1293",
    d: "M1328.7,1482.381l-.005,1.873-.978-.565.005-1.872Z",
    transform: "translate(-955.085 -1065.938)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1294",
    "data-name": "Caminho 1294",
    d: "M1342.765,1461.7l-.005.954-11.559,6.718.005-.954Z",
    transform: "translate(-957.592 -1051.464)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1295",
    "data-name": "Caminho 1295",
    d: "M1340.271,1460.248l-11.559,6.718-.978-.565,11.559-6.717Z",
    transform: "translate(-955.098 -1050.016)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1296",
    "data-name": "Caminho 1296",
    d: "M1340.9,1489.426l-.005,1.873-.978-.565.005-1.872Z",
    transform: "translate(-963.862 -1071.005)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1297",
    "data-name": "Caminho 1297",
    d: "M1354.968,1468.74l-.005.954-11.559,6.717.005-.954Z",
    transform: "translate(-966.369 -1056.531)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1298",
    "data-name": "Caminho 1298",
    d: "M1352.474,1467.293l-11.559,6.717-.978-.565,11.559-6.717Z",
    transform: "translate(-963.875 -1055.084)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1299",
    "data-name": "Caminho 1299",
    d: "M1361.094,1419.873l-11.561,6.718-.978-.565,11.56-6.718Z",
    transform: "translate(-970.076 -1020.973)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1300",
    "data-name": "Caminho 1300",
    d: "M1397.7,1441.008l-11.561,6.718-.978-.565,11.56-6.718Z",
    transform: "translate(-996.408 -1036.176)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1301",
    "data-name": "Caminho 1301",
    d: "M1315.185,1409.031l-20.468-11.817a5.113,5.113,0,0,0-4.631,0l-21.9,12.729c-1.272.739-1.266,1.944.015,2.683l20.469,11.817a5.109,5.109,0,0,0,4.63,0l21.9-12.73c1.272-.739,1.267-1.942-.014-2.682m-23.031,14.753a2.6,2.6,0,0,1-2.356,0l-20.468-11.817a.721.721,0,0,1-.008-1.365l10.385-6.035,22.833,13.182Zm21.9-12.729-10.386,6.036-22.833-13.182,10.386-6.036a2.6,2.6,0,0,1,2.357,0l20.468,11.817a.722.722,0,0,1,.008,1.365",
    transform: "translate(-911.576 -1004.68)",
    fill: "#898b8f"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(355.651 405.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_456",
    "data-name": "Grupo 456",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_797",
    "data-name": "Ret\\xE2ngulo 797",
    width: 48.924,
    height: 16.49,
    transform: "translate(-0.002 0)",
    fill: "url(#linear-gradient-15)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_464",
    "data-name": "Grupo 464",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_463",
    "data-name": "Grupo 463",
    clipPath: "url(#clip-path-2)"
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1303",
    "data-name": "Caminho 1303",
    d: "M1242.447,1486.956v.728l-3.357,1.938v-.728Z",
    transform: "translate(-891.333 -1069.635)",
    fill: "#11141e"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1304",
    "data-name": "Caminho 1304",
    d: "M1233.7,1491.455l-2.1-1.223v-.728l2.1,1.223Z",
    transform: "translate(-885.939 -1071.468)",
    fill: "#33363f"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1305",
    "data-name": "Caminho 1305",
    d: "M1294.929,1517.455v.728l-3.357,1.938v-.728Z",
    transform: "translate(-929.085 -1091.574)",
    fill: "#11141e"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1306",
    "data-name": "Caminho 1306",
    d: "M1286.179,1521.954l-2.1-1.223V1520l2.1,1.223Z",
    transform: "translate(-923.692 -1093.407)",
    fill: "#33363f"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1307",
    "data-name": "Caminho 1307",
    d: "M1144.38,1648.81l18.911-10.918-18.911-10.918-18.911,10.918Z",
    transform: "translate(-809.6 -1170.355)",
    fill: "#e8d6a2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1308",
    "data-name": "Caminho 1308",
    d: "M1171.916,1655.785l3.455-1.995-18.911-10.918-3.455,1.995Z",
    transform: "translate(-829.408 -1181.792)",
    fill: "#b58850"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1309",
    "data-name": "Caminho 1309",
    d: "M1211.36,1687.713l-18.911,10.918v-21.837l18.911-10.918Z",
    transform: "translate(-857.781 -1198.34)",
    fill: "#b58850"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1310",
    "data-name": "Caminho 1310",
    d: "M1223.44,1751.768l-3.455,1.995v-3.048l3.455-1.995Z",
    transform: "translate(-877.589 -1257.933)",
    fill: "#815300"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1311",
    "data-name": "Caminho 1311",
    d: "M1223.44,1684.823l-3.455,1.995v-3.048l3.455-1.995Z",
    transform: "translate(-877.589 -1209.777)",
    fill: "#815300"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1312",
    "data-name": "Caminho 1312",
    d: "M1144.379,1698.631l-18.911-10.918v-21.837l18.911,10.918Z",
    transform: "translate(-809.599 -1198.34)",
    fill: "#d6b477"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1313",
    "data-name": "Caminho 1313",
    d: "M1141.79,1730.685v4.326l3.747,2.163v-4.326Zm3.572,6.187-3.4-1.962v-3.923l3.4,1.962Z",
    transform: "translate(-821.34 -1244.96)",
    fill: "#815300"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1314",
    "data-name": "Caminho 1314",
    d: "M1144.577,1737.861l.48.277v-1.826l.273.157-.513-1.127-.513.535.273.157Z",
    transform: "translate(-823.149 -1248.31)",
    fill: "#815300"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1315",
    "data-name": "Caminho 1315",
    d: "M1149.244,1740.555l.48.277v-1.826l.273.157-.513-1.127-.513.535.273.157Z",
    transform: "translate(-826.506 -1250.248)",
    fill: "#815300"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1316",
    "data-name": "Caminho 1316",
    d: "M1146.331,1745.675l-2.731-1.577v.357l2.731,1.577Z",
    transform: "translate(-822.642 -1254.608)",
    fill: "#815300"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1317",
    "data-name": "Caminho 1317",
    d: "M1157.346,1739.666v4.326l3.747,2.163v-4.326Zm3.572,6.187-3.4-1.961v-3.923l3.4,1.961Z",
    transform: "translate(-832.53 -1251.42)",
    fill: "#815300"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1318",
    "data-name": "Caminho 1318",
    d: "M1161.644,1746.59v.86l-.4-.229c-.068-.039-.123-.007-.123.071v.106l1.3.749v-.106a.272.272,0,0,0-.123-.214l-.4-.229v-.86c.423.172.748-.06.748-.569v-.9l-.49-.283-.177.35.41.237-.739.57.24-.592-.38-.22.254-.571-.872-.5v.9a1.963,1.963,0,0,0,.748,1.433",
    transform: "translate(-835.084 -1254.726)",
    fill: "#815300"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1319",
    "data-name": "Caminho 1319",
    d: "M1172.967,1748.685v4.326l3.746,2.163v-4.326Zm3.572,6.187-3.4-1.961v-3.923l3.4,1.961Z",
    transform: "translate(-843.767 -1257.908)",
    fill: "#815300"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1320",
    "data-name": "Caminho 1320",
    d: "M1175.576,1755.786a1.173,1.173,0,0,1,.459.084.082.082,0,0,0-.007.035v1.223c0,.117-.083.165-.184.106a.407.407,0,0,1-.184-.319.183.183,0,0,0-.083-.143c-.046-.026-.083-.005-.083.048a.774.774,0,0,0,.35.606c.193.111.35.021.35-.2V1756a.136.136,0,0,0-.007-.043,2.981,2.981,0,0,1,.46.447.827.827,0,0,1,.479.091,3.321,3.321,0,0,1,.362.3,2.979,2.979,0,0,0-1.294-1.971s0-.3,0-.3a.183.183,0,0,0-.083-.143c-.045-.026-.083-.005-.083.048v.295c-.683-.351-1.232-.119-1.294.478a1.738,1.738,0,0,1,.363.115,2.105,2.105,0,0,1,.479.463",
    transform: "translate(-845.038 -1262.001)",
    fill: "#815300"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462",
    transform: "translate(228.328 391.18)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_461",
    "data-name": "Grupo 461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_460",
    "data-name": "Grupo 460",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_459",
    "data-name": "Grupo 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_458",
    "data-name": "Grupo 458",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_798",
    "data-name": "Ret\\xE2ngulo 798",
    width: 80.308,
    height: 89.539,
    transform: "translate(-20.69 31.315) rotate(-56.547)",
    fill: "url(#linear-gradient-16)"
  }))))))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1322",
    "data-name": "Caminho 1322",
    d: "M842.531,1310.4l-4.052,2.355,11.82,7.432,17.183-9.988L876.092,1323l2.875.542,12,5.11s.048-3.724.121-4.162l-6.9-3.984a9.311,9.311,0,0,1-3.534-4.128l-7.374-16.089a9.03,9.03,0,0,0-3.694-4.058l-5.22-3.014a3.077,3.077,0,0,0-2.906-.36l-5.223,3.036-16.214,9.424-1.383.8-1.523.885Z",
    transform: "translate(-602.177 -929.847)",
    fill: "#ffd554"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1323",
    "data-name": "Caminho 1323",
    d: "M847.957,1307.252l-4.052,2.355,11.82,7.432,17.183-9.988,8.609,12.792,2.876.542,12,5.11s.048-3.724.121-4.162l-6.9-3.984a9.311,9.311,0,0,1-3.534-4.128l-7.374-16.089a9.027,9.027,0,0,0-3.694-4.058l-5.22-3.014a3.078,3.078,0,0,0-2.906-.359l-5.223,3.036-16.214,9.424-1.383.8-1.523.885Z",
    transform: "translate(-606.08 -927.579)",
    fill: "#ffde54"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1324",
    "data-name": "Caminho 1324",
    d: "M816.928,1329.46l21.265-12.357,21.307,12.382-21.265,12.357Z",
    transform: "translate(-587.652 -947.452)",
    fill: "#ffde54"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1325",
    "data-name": "Caminho 1325",
    d: "M881.534,1316.476a9.027,9.027,0,0,1,2.357,3.113l7,17.958a1.885,1.885,0,0,1,.12.353l-7.691-11.428-5.223,3.036-11.96,6.952-9.12-5.734Z",
    transform: "translate(-616.487 -947.001)",
    fill: "#ffc533"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1326",
    "data-name": "Caminho 1326",
    d: "M902.946,1364.087l21.307,12.382,3.527-2.05-1.384,3.3-17.737,10.307-23.45-13.627Z",
    transform: "translate(-636.77 -981.249)",
    fill: "#1c1f29"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1327",
    "data-name": "Caminho 1327",
    d: "M904.142,1358.6l21.307,12.382,2.331-1.354-.187,2.6-18.934,11-23.45-13.627Z",
    transform: "translate(-636.769 -977.302)",
    fill: "#3f424a"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466",
    transform: "translate(246.826 385.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_465",
    "data-name": "Grupo 465",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_801",
    "data-name": "Ret\\xE2ngulo 801",
    width: 30.163,
    height: 13.107,
    fill: "url(#linear-gradient-17)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468",
    transform: "translate(246.826 384.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_802",
    "data-name": "Ret\\xE2ngulo 802",
    width: 30.204,
    height: 9.458,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1330",
    "data-name": "Caminho 1330",
    d: "M880.468,1348.29l13.7,7.963a2.842,2.842,0,0,0,2.581,0l12.838-7.412a.79.79,0,0,0,.008-1.5l-13.7-7.963Z",
    transform: "translate(-633.36 -963.479)",
    fill: "#66686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1331",
    "data-name": "Caminho 1331",
    d: "M901.5,1318.533l6.2-3.582a.894.894,0,0,1,.2-.086c.4-.153.7.065.7.54v.028l.022,8.391a1.833,1.833,0,0,0,.913,1.586l5.906,3.432a.51.51,0,0,1-.007.965l-6.2,3.582a1.361,1.361,0,0,1-.241.1,1.862,1.862,0,0,1-1.493-.081l-5.426-2.647a2.809,2.809,0,0,1-1.4-2.42l-.018-8.343v-.028a1.836,1.836,0,0,1,.834-1.443",
    transform: "translate(-647.886 -945.808)",
    fill: "#57595a"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_472",
    "data-name": "Grupo 472",
    transform: "translate(253.926 384.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_804",
    "data-name": "Ret\\xE2ngulo 804",
    width: 15.377,
    height: 4.488,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-19)"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_474",
    "data-name": "Grupo 474",
    transform: "translate(253.799 369.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_473",
    "data-name": "Grupo 473",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_805",
    "data-name": "Ret\\xE2ngulo 805",
    width: 16.365,
    height: 15.393,
    transform: "matrix(0.624, -0.782, 0.782, 0.624, -7.008, 8.784)",
    fill: "url(#linear-gradient-20)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_476",
    "data-name": "Grupo 476",
    transform: "translate(253.801 375.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_475",
    "data-name": "Grupo 475",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_806",
    "data-name": "Ret\\xE2ngulo 806",
    width: 1.715,
    height: 8.22,
    transform: "translate(0)",
    fill: "url(#linear-gradient-21)"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_478",
    "data-name": "Grupo 478",
    transform: "translate(254.836 382.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_477",
    "data-name": "Grupo 477",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_807",
    "data-name": "Ret\\xE2ngulo 807",
    width: 14.845,
    height: 5.558,
    transform: "translate(-0.206 0.009) rotate(-2.386)",
    fill: "url(#linear-gradient-22)"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_480",
    "data-name": "Grupo 480",
    transform: "translate(252.843 368.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_479",
    "data-name": "Grupo 479",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_808",
    "data-name": "Ret\\xE2ngulo 808",
    width: 15.675,
    height: 14.942,
    transform: "translate(-6.279 8.104) rotate(-52.23)",
    fill: "url(#linear-gradient-23)"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_482",
    "data-name": "Grupo 482",
    transform: "translate(254.836 382.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_481",
    "data-name": "Grupo 481",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_809",
    "data-name": "Ret\\xE2ngulo 809",
    width: 14.616,
    height: 6.021,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-24)"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_484",
    "data-name": "Grupo 484",
    transform: "translate(254.185 369.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_483",
    "data-name": "Grupo 483",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_810",
    "data-name": "Ret\\xE2ngulo 810",
    width: 21.609,
    height: 22.43,
    transform: "matrix(0.877, -0.481, 0.481, 0.877, -7.281, 3.997)",
    fill: "url(#linear-gradient-25)"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_486",
    "data-name": "Grupo 486",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_485",
    "data-name": "Grupo 485",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1339",
    "data-name": "Caminho 1339",
    d: "M991.453,1391.94l-5.223,3.036,6.9,3.984,5.223-3.036Z",
    transform: "translate(-709.439 -1001.285)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1340",
    "data-name": "Caminho 1340",
    d: "M1021.9,1401.52l5.224-3.036c1.127-.608,2.665-.5,4.356.481q.216.125.428.264a13.812,13.812,0,0,1,5.793,10.512c-.006,1.931-.675,3.3-1.759,3.965l-5.224,3.036-8.819-8.929Z",
    transform: "translate(-735.098 -1005.723)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1341",
    "data-name": "Caminho 1341",
    d: "M1021.377,1409.782c-3.446-1.99-6.249-.392-6.26,3.57a9.927,9.927,0,0,0,.231,2.1,13.931,13.931,0,0,0,5.988,8.672c1.766,1.02,3.364,1.1,4.5.4,1.084-.665,1.754-2.035,1.759-3.965a13.81,13.81,0,0,0-5.793-10.512q-.212-.139-.428-.264",
    transform: "translate(-730.219 -1013.504)",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1342",
    "data-name": "Caminho 1342",
    d: "M895.88,1407.014v6.293l-28.435-16.525v-6.293Z",
    transform: "translate(-623.991 -1000.242)",
    fill: "#ffbe17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1343",
    "data-name": "Caminho 1343",
    d: "M821.532,1383.025l-5.224,3.036v-6.293c0-3.495,5.224-3.036,5.224-3.036Z",
    transform: "translate(-587.206 -990.331)",
    fill: "#d28800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1344",
    "data-name": "Caminho 1344",
    d: "M826.413,1389.146l5.224-3.036c1.128-.608,2.665-.5,4.357.481q.216.125.428.264a13.812,13.812,0,0,1,5.793,10.512c-.006,1.931-.675,3.3-1.759,3.965l-5.224,3.036-8.819-8.929Z",
    transform: "translate(-594.475 -996.822)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1345",
    "data-name": "Caminho 1345",
    d: "M825.89,1397.406c-3.446-1.99-6.249-.392-6.26,3.57a9.942,9.942,0,0,0,.232,2.1,13.931,13.931,0,0,0,5.988,8.672c1.766,1.02,3.364,1.1,4.5.4,1.084-.665,1.754-2.034,1.759-3.965a13.811,13.811,0,0,0-5.793-10.512q-.212-.139-.428-.264",
    transform: "translate(-589.596 -1004.602)",
    fill: "#33363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1346",
    "data-name": "Caminho 1346",
    d: "M834.455,1418.955c1.6.921,2.891.181,2.9-1.651a6.337,6.337,0,0,0-2.877-4.984c-1.594-.92-2.891-.183-2.9,1.651a6.343,6.343,0,0,0,2.877,4.984",
    transform: "translate(-598.191 -1015.662)",
    fill: "#8d8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1347",
    "data-name": "Caminho 1347",
    d: "M840.686,1420.585a.875.875,0,0,0,1.439-.82,3.148,3.148,0,0,0-1.43-2.476,1.052,1.052,0,0,0-.961-.131.968.968,0,0,0-.477.951,3.152,3.152,0,0,0,1.429,2.476",
    transform: "translate(-603.715 -1019.379)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1348",
    "data-name": "Caminho 1348",
    d: "M841.413,1420.854l-.953.165-1.612-2.961.592-.731Z",
    transform: "translate(-603.421 -1019.548)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1349",
    "data-name": "Caminho 1349",
    d: "M838.782,1422.577c.664.383,1.2.075,1.2-.687a2.636,2.636,0,0,0-1.2-2.073.85.85,0,0,0-.85-.086.837.837,0,0,0-.354.773,2.638,2.638,0,0,0,1.2,2.073",
    transform: "translate(-602.512 -1021.221)",
    fill: "#c8c9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1350",
    "data-name": "Caminho 1350",
    d: "M832.785,1412.107a2.314,2.314,0,0,0-.506,1.577,6.344,6.344,0,0,0,2.877,4.984,2.294,2.294,0,0,0,1.688.345,1.834,1.834,0,0,1-2.39.073,6.343,6.343,0,0,1-2.878-4.984c0-1.108.48-1.812,1.208-2",
    transform: "translate(-598.19 -1015.792)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1351",
    "data-name": "Caminho 1351",
    d: "M823.734,1343.266a3.077,3.077,0,0,1,2.906.359l5.221,3.014a9.029,9.029,0,0,1,3.694,4.058l7,17.958c.816,1.782-1.311,5.294-1.311,5.294l-2.875-.542s-12.932-19.218-12.935-19.216l-.049.025-.014.007-.045.024-.017.009-.042.023-.021.011-.037.021-.024.014-.033.02-.027.017-.029.019-.031.02-.026.017-.034.022-.023.016-.035.024-.021.015-.037.027-.017.013-.039.03-.015.012-.041.032-.013.011-.042.035-.054.047-.053.048-.053.049-.052.051-.051.052-.05.053-.049.054-.045.051c-.65-.651-5.8-8.758-5.8-8.758Z",
    transform: "translate(-588.791 -966.112)",
    fill: "#f4ae3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1352",
    "data-name": "Caminho 1352",
    d: "M885.555,1437.341l5.223-3.036,10.813,6.243-5.223,3.036Z",
    transform: "translate(-637.019 -1031.761)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1353",
    "data-name": "Caminho 1353",
    d: "M931.627,1461.692l-5.224,3.036v-6.293c0-3.495,5.224-3.036,5.224-3.036Z",
    transform: "translate(-666.403 -1046.92)",
    fill: "#d28800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1354",
    "data-name": "Caminho 1354",
    d: "M935.164,1451.933l5.224-3.036c1.127-.608,2.664-.5,4.356.481q.216.125.428.264a13.812,13.812,0,0,1,5.793,10.512c-.006,1.931-.675,3.3-1.759,3.965l-5.224,3.036-8.819-8.929Z",
    transform: "translate(-672.705 -1041.988)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1355",
    "data-name": "Caminho 1355",
    d: "M934.641,1460.194c-3.446-1.99-6.249-.392-6.26,3.57a9.937,9.937,0,0,0,.232,2.1,13.931,13.931,0,0,0,5.988,8.672c1.766,1.02,3.364,1.1,4.5.4,1.084-.665,1.754-2.034,1.759-3.965a13.81,13.81,0,0,0-5.793-10.512q-.212-.139-.428-.264",
    transform: "translate(-667.825 -1049.768)",
    fill: "#33363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1356",
    "data-name": "Caminho 1356",
    d: "M943.206,1481.743c1.6.921,2.891.181,2.9-1.65a6.337,6.337,0,0,0-2.877-4.984c-1.594-.92-2.891-.183-2.9,1.651a6.344,6.344,0,0,0,2.877,4.984",
    transform: "translate(-676.42 -1060.828)",
    fill: "#8d8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1357",
    "data-name": "Caminho 1357",
    d: "M949.438,1483.372a.875.875,0,0,0,1.439-.82,3.148,3.148,0,0,0-1.43-2.476,1.053,1.053,0,0,0-.961-.131.968.968,0,0,0-.477.951,3.151,3.151,0,0,0,1.429,2.476",
    transform: "translate(-681.945 -1064.544)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1358",
    "data-name": "Caminho 1358",
    d: "M950.164,1483.642l-.953.165-1.612-2.961.592-.731Z",
    transform: "translate(-681.651 -1064.714)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1359",
    "data-name": "Caminho 1359",
    d: "M947.534,1485.365c.664.383,1.2.075,1.2-.687a2.635,2.635,0,0,0-1.2-2.073.85.85,0,0,0-.85-.086.838.838,0,0,0-.354.773,2.639,2.639,0,0,0,1.2,2.073",
    transform: "translate(-680.742 -1066.386)",
    fill: "#c8c9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1360",
    "data-name": "Caminho 1360",
    d: "M941.537,1474.895a2.313,2.313,0,0,0-.505,1.577,6.344,6.344,0,0,0,2.877,4.984,2.294,2.294,0,0,0,1.688.345,1.835,1.835,0,0,1-2.39.073,6.344,6.344,0,0,1-2.877-4.984c0-1.108.48-1.812,1.208-2",
    transform: "translate(-676.42 -1060.959)",
    fill: "#70747a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1361",
    "data-name": "Caminho 1361",
    d: "M938.149,1406.541l.022-.008c.608-.355,24.064-14.029,24.321-14.14,1.335-.574,3.088-.383,4.993.717l3.848,2.222-29.568,17.184-3.265-1.542a11.569,11.569,0,0,0-2.941-.934l-2.628-.462s4.958-2.923,5.218-3.036",
    transform: "translate(-671.099 -1001.384)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1362",
    "data-name": "Caminho 1362",
    d: "M931.234,1454.338c-1.906-1.1-3.653-1.292-4.988-.717a4.487,4.487,0,0,0-2.483,3.63,8.732,8.732,0,0,0-.113,1.411l-.008,2.751,0,1.375.776.448.006-2.162.005-1.964c.012-4.3,3.066-6.039,6.806-3.88l.428.247,3.42,1.974v-.892Z",
    transform: "translate(-664.414 -1045.427)",
    fill: "#ffcc49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1363",
    "data-name": "Caminho 1363",
    d: "M813.589,1356.871c.008-2.7,1.915-3.783,4.262-2.428l5.221,3.014a9.032,9.032,0,0,1,3.694,4.058l7,17.958,10.813,6.243c-.073.438-.121,4.161-.121,4.161l-15.791-9.117.007-2.542a16.245,16.245,0,0,0-6.793-12.376c-.174-.109-.332-.2-.494-.293a5.139,5.139,0,0,0-4.734-.543l-.057.028-.014.007-.045.024-.017.009-.042.023-.021.012-.037.021-.024.014-.033.02-.027.016-.029.019-.031.019-.026.017-.034.022-.023.016-.035.025-.021.015-.037.027-.017.013-.039.03-.015.012-.041.033-.013.011-.042.035-.054.047-.053.048-.053.049-.052.051-.051.051-.05.053-.049.054-.048.056-.048.056c-.032.038-.062.077-.093.116a4.586,4.586,0,0,0-.665,1.247c-.01.028-.019.054-.028.081l-.027.081c-.009.028-.018.055-.026.082s-.017.055-.024.082-.017.059-.024.086-.015.056-.022.083l-.022.088c-.008.031-.014.058-.02.086s-.013.059-.019.085-.013.063-.019.089-.013.064-.018.091-.012.063-.016.089l0,.014c0,.025-.008.05-.012.075l0,.019-.011.073,0,.02-.01.072c0,.008,0,.016,0,.024,0,.024-.006.049-.01.073,0,.007,0,.015,0,.022l-.008.074,0,.023c0,.024-.005.047-.007.071s0,.018,0,.027,0,.048-.006.072c0,.009,0,.017,0,.026s0,.045-.005.068l0,.032c0,.02,0,.039,0,.059s0,.028,0,.043,0,.039,0,.059,0,.028,0,.042,0,.046,0,.068l0,.035c0,.023,0,.045,0,.068s0,.024,0,.036,0,.048,0,.073,0,.021,0,.032c0,.035,0,.07,0,.106l-.772-.446Z",
    transform: "translate(-585.225 -973.893)",
    fill: "#ffbe17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1364",
    "data-name": "Caminho 1364",
    d: "M993.972,1403.673v.891l-29.566,17.185v-.892Z",
    transform: "translate(-693.74 -1009.725)",
    fill: "#ffd554"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1365",
    "data-name": "Caminho 1365",
    d: "M952.585,1433.427l-2.242-1.3-.8-5.053,1.646.957Z",
    transform: "translate(-683.046 -1026.557)",
    fill: "#ffbe17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1366",
    "data-name": "Caminho 1366",
    d: "M978.385,1382.9l1.4,5.4-22.98,13.354-1.4-5.4Z",
    transform: "translate(-687.265 -994.781)",
    fill: "#ffd554"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1367",
    "data-name": "Caminho 1367",
    d: "M972.764,1379.584l-23.649,13.743,1.694.985,23.649-13.743Z",
    transform: "translate(-682.74 -992.397)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1368",
    "data-name": "Caminho 1368",
    d: "M949.725,1389.805l-1.646-.957,21.879-12.714,1.646.957Z",
    transform: "translate(-681.995 -989.916)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1369",
    "data-name": "Caminho 1369",
    d: "M860.954,1300.464l1.1-.64.058-20.429-1.1.64Z",
    transform: "translate(-619.322 -920.327)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1370",
    "data-name": "Caminho 1370",
    d: "M875.634,1287.136,858.42,1277.2l-.058,20.429-1.011-.584.062-21.592,19.022,10.982,8.436,32.528-1.646-.957Z",
    transform: "translate(-616.731 -917.49)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1371",
    "data-name": "Caminho 1371",
    d: "M933.656,1345l1.1-.64-8.308-32.056-1.1.64Z",
    transform: "translate(-665.643 -943.998)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1372",
    "data-name": "Caminho 1372",
    d: "M876.593,1284.793l1.1-.64-19.022-10.982-1.1.64Z",
    transform: "translate(-616.889 -915.85)",
    fill: "#1a1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1373",
    "data-name": "Caminho 1373",
    d: "M938.928,1255.153l1.1-.64.058-20.429-1.1.64Z",
    transform: "translate(-675.412 -887.733)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1374",
    "data-name": "Caminho 1374",
    d: "M935.388,1230.139l19.022,10.983,8.021,30.948-1.646-.957-7.176-29.289-17.213-9.938-.058,20.429-1.011-.584Z",
    transform: "translate(-672.822 -884.895)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1375",
    "data-name": "Caminho 1375",
    d: "M1011.63,1299.686l.841-.489.26-.151-8.308-32.056-1.1.64Z",
    transform: "translate(-721.734 -911.404)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1376",
    "data-name": "Caminho 1376",
    d: "M954.567,1239.482l1.1-.64-19.022-10.982-1.1.64Z",
    transform: "translate(-672.979 -883.255)",
    fill: "#1a1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1377",
    "data-name": "Caminho 1377",
    d: "M976.925,1377.264l.41,1.581L954.354,1392.2l-.41-1.581Z",
    transform: "translate(-686.214 -990.728)",
    fill: "#4e5159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1378",
    "data-name": "Caminho 1378",
    d: "M973.012,1308.816l6.154,3.553-.091,47.414L976,1358.007l.088-45.8-3.074-1.786Z",
    transform: "translate(-699.93 -941.491)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1379",
    "data-name": "Caminho 1379",
    d: "M994.616,1366.017l1.929-1.121.091-47.414-1.929,1.121Z",
    transform: "translate(-715.472 -947.725)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1380",
    "data-name": "Caminho 1380",
    d: "M1002.422,1288.8l-11.574,6.726v-1.608l11.574-6.726Z",
    transform: "translate(-712.761 -925.932)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1381",
    "data-name": "Caminho 1381",
    d: "M1031.854,1287.188l-.091,47.414,3.077,1.776.091-47.414Z",
    transform: "translate(-742.193 -925.932)",
    fill: "#33363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1382",
    "data-name": "Caminho 1382",
    d: "M1042.727,1338.058l1.929-1.121.091-47.414-1.929,1.121Z",
    transform: "translate(-750.08 -927.613)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1383",
    "data-name": "Caminho 1383",
    d: "M973.012,1285.831l15.432-8.968,6.154,3.553-1.929,1.121-3.077-1.777-11.574,6.726,3.077,1.776-1.929,1.121-3.077-1.776Z",
    transform: "translate(-699.93 -918.506)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1384",
    "data-name": "Caminho 1384",
    d: "M1071.863,1261.168l.711.413a.771.771,0,0,1,.133.1l.029.029a.854.854,0,0,1,.109.135.918.918,0,0,1,.062.11l.006.014c.011.024.022.049.032.075s.008.026.013.038.005.015.008.023l.007.021c.008.026.015.053.021.081,0,.009,0,.019.006.029s0,.012,0,.019,0,.019.006.029.008.049.011.075,0,.028,0,.042,0,.01,0,.015,0,.012,0,.018c0,.024,0,.049,0,.074s0,.05,0,.076c0,0,1.048,18.323,1.048,18.323l.595,5.95-1.577.911-1.423-.827-.041-14.363c-.011-.006-.025-10.816-.025-10.816q0-.09-.008-.173c0-.005,0-.01,0-.015-.005-.051-.012-.1-.021-.147l0-.019a1.343,1.343,0,0,0-.034-.131l-.008-.024a1.14,1.14,0,0,0-.044-.113,1,1,0,0,0-.068-.125.855.855,0,0,0-.109-.135l-.029-.028a.757.757,0,0,0-.133-.1Z",
    transform: "translate(-770.526 -906.917)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1385",
    "data-name": "Caminho 1385",
    d: "M1011.517,1301.544l-.849-.494-24.456,14.11.849.494Z",
    transform: "translate(-709.425 -935.905)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1386",
    "data-name": "Caminho 1386",
    d: "M997.263,1332.429l-.62-.371v3.842l.542.315.077.056Z",
    transform: "translate(-716.93 -958.209)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1387",
    "data-name": "Caminho 1387",
    d: "M999.584,1335.153l0,2.931-.735.413v-2.931Z",
    transform: "translate(-718.518 -960.436)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1388",
    "data-name": "Caminho 1388",
    d: "M1010.613,1324.731l-.62-.371v3.842l.542.315.077.056Z",
    transform: "translate(-726.533 -952.672)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1389",
    "data-name": "Caminho 1389",
    d: "M1012.933,1327.454l0,2.931-.735.413v-2.931Z",
    transform: "translate(-728.121 -954.898)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1390",
    "data-name": "Caminho 1390",
    d: "M1023.962,1317.032l-.62-.371v3.842l.542.315.077.056Z",
    transform: "translate(-736.135 -947.134)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1391",
    "data-name": "Caminho 1391",
    d: "M1026.282,1319.756l0,2.931-.735.413v-2.931Z",
    transform: "translate(-737.723 -949.36)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1392",
    "data-name": "Caminho 1392",
    d: "M1037.311,1309.334l-.62-.371v3.842l.542.315.077.056Z",
    transform: "translate(-745.738 -941.596)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1393",
    "data-name": "Caminho 1393",
    d: "M1039.631,1312.058l0,2.931-.735.413v-2.931Z",
    transform: "translate(-747.326 -943.823)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1394",
    "data-name": "Caminho 1394",
    d: "M1050.66,1301.635l-.62-.371v3.842l.542.315.077.056Z",
    transform: "translate(-755.34 -936.058)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1395",
    "data-name": "Caminho 1395",
    d: "M1052.98,1304.359l0,2.931-.735.413v-2.931Z",
    transform: "translate(-756.928 -938.285)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1396",
    "data-name": "Caminho 1396",
    d: "M1064.009,1293.937l-.62-.371v3.842l.542.315.077.056Z",
    transform: "translate(-764.943 -930.52)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1397",
    "data-name": "Caminho 1397",
    d: "M1066.329,1296.661l0,2.931-.735.413v-2.931Z",
    transform: "translate(-766.531 -932.747)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1398",
    "data-name": "Caminho 1398",
    d: "M1011.517,1288.079l-.849-.494L986.211,1301.7l.849.494Z",
    transform: "translate(-709.425 -926.219)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1399",
    "data-name": "Caminho 1399",
    d: "M999.584,1304.265l0,7.8-.735.413v-7.8Z",
    transform: "translate(-718.518 -938.217)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1400",
    "data-name": "Caminho 1400",
    d: "M997.215,1301.541l-.639-.371.019,8.709.542.315.077.056Z",
    transform: "translate(-716.881 -935.99)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1401",
    "data-name": "Caminho 1401",
    d: "M1063.96,1263.049l-.639-.371.019,8.709.542.315.077.056Z",
    transform: "translate(-764.894 -908.301)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1402",
    "data-name": "Caminho 1402",
    d: "M1066.329,1265.773l0,7.8-.735.413v-7.8Z",
    transform: "translate(-766.531 -910.528)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1403",
    "data-name": "Caminho 1403",
    d: "M1050.611,1270.747l-.639-.371.019,8.709.543.315.077.056Z",
    transform: "translate(-755.291 -913.839)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1404",
    "data-name": "Caminho 1404",
    d: "M1052.98,1273.471l0,7.8-.735.413v-7.8Z",
    transform: "translate(-756.928 -916.066)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1405",
    "data-name": "Caminho 1405",
    d: "M1037.262,1278.446l-.639-.371.019,8.709.543.315.077.056Z",
    transform: "translate(-745.689 -919.377)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1406",
    "data-name": "Caminho 1406",
    d: "M1039.631,1281.17l0,7.8-.735.413v-7.8Z",
    transform: "translate(-747.326 -921.603)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1407",
    "data-name": "Caminho 1407",
    d: "M1023.913,1286.144l-.639-.371.019,8.709.542.315.077.056Z",
    transform: "translate(-736.086 -924.915)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1408",
    "data-name": "Caminho 1408",
    d: "M1026.282,1288.868l0,7.8-.735.413v-7.8Z",
    transform: "translate(-737.723 -927.141)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1409",
    "data-name": "Caminho 1409",
    d: "M1010.564,1293.843l-.639-.371.019,8.709.542.315.077.056Z",
    transform: "translate(-726.484 -930.453)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1410",
    "data-name": "Caminho 1410",
    d: "M1012.933,1296.566l0,7.8-.735.413v-7.8Z",
    transform: "translate(-728.121 -932.679)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1411",
    "data-name": "Caminho 1411",
    d: "M1011.728,1338.169l-.849-.494-24.374,14.072.85.494Z",
    transform: "translate(-709.637 -962.251)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1412",
    "data-name": "Caminho 1412",
    d: "M985.956,1389.546l-1.423-.827.006,2.139,1.423.827Z",
    transform: "translate(-708.218 -998.969)",
    fill: "#4f5156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1413",
    "data-name": "Caminho 1413",
    d: "M1049.562,1269.438l-1.423-.827-.717.414,1.423.827Z",
    transform: "translate(-753.457 -912.57)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1414",
    "data-name": "Caminho 1414",
    d: "M1048.845,1270.913l-1.423-.827,0,.687,1.423.827Z",
    transform: "translate(-753.457 -913.63)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1415",
    "data-name": "Caminho 1415",
    d: "M1011.728,1315.278l-.849-.494-24.374,14.072.85.494Z",
    transform: "translate(-709.637 -945.784)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1416",
    "data-name": "Caminho 1416",
    d: "M1036.126,1277.2l-1.423-.827-.717.414,1.423.827Z",
    transform: "translate(-743.792 -918.15)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1417",
    "data-name": "Caminho 1417",
    d: "M1035.409,1278.67l-1.423-.827,0,.687,1.423.827Z",
    transform: "translate(-743.792 -919.21)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1418",
    "data-name": "Caminho 1418",
    d: "M985.884,1364.009l-1.423-.827.006,2.139,1.423.827Z",
    transform: "translate(-708.166 -980.599)",
    fill: "#4f5156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1419",
    "data-name": "Caminho 1419",
    d: "M1013.906,1316.544v2.142l-24.367,14.069-.006-2.139Z",
    transform: "translate(-711.814 -947.05)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1420",
    "data-name": "Caminho 1420",
    d: "M1022.688,1284.956l-1.423-.827-.715.413,1.423.827Z",
    transform: "translate(-734.127 -923.732)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1421",
    "data-name": "Caminho 1421",
    d: "M1021.973,1286.428l-1.423-.827,0,.687,1.423.827Z",
    transform: "translate(-734.126 -924.791)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1422",
    "data-name": "Caminho 1422",
    d: "M1008.532,1294.188l-1.423-.827,0,.687,1.423.827Z",
    transform: "translate(-724.458 -930.373)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1423",
    "data-name": "Caminho 1423",
    d: "M1009.249,1292.713l-1.423-.827-.717.414,1.423.827Z",
    transform: "translate(-724.458 -929.312)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1424",
    "data-name": "Caminho 1424",
    d: "M995.1,1301.945l-1.423-.827,0,.687,1.423.827Z",
    transform: "translate(-714.792 -935.953)",
    fill: "#2b2e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1425",
    "data-name": "Caminho 1425",
    d: "M995.812,1300.471l-1.423-.827-.717.414,1.423.827Z",
    transform: "translate(-714.792 -934.893)",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1426",
    "data-name": "Caminho 1426",
    d: "M986.94,1269.047a6.932,6.932,0,0,0-3.142,5.44l.066,25.179,1.577-.91-.007-2.468-.006-2.139-.014-5.028-.006-2.139-.007-2.6,0-.823-.006-2.265,0-.823-.014-6.9a3.466,3.466,0,0,1,1.57-2.72l21.673-12.513c.868-.5,1.577-.1,1.58.9l.066,25.18,1.577-.91-.066-25.18c-.006-2-1.425-2.8-3.161-1.8Z",
    transform: "translate(-707.69 -903.572)",
    fill: "#323436"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_488",
    "data-name": "Grupo 488",
    transform: "translate(274.685 351.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_487",
    "data-name": "Grupo 487",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_812",
    "data-name": "Ret\\xE2ngulo 812",
    width: 52.73,
    height: 47.471,
    transform: "translate(-19.771 32.283) rotate(-58.516)",
    fill: "url(#linear-gradient-26)"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_490",
    "data-name": "Grupo 490",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_489",
    "data-name": "Grupo 489",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1428",
    "data-name": "Caminho 1428",
    d: "M1013.906,1339.435v2.143l-24.367,14.069-.006-2.139Z",
    transform: "translate(-711.814 -963.516)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1429",
    "data-name": "Caminho 1429",
    d: "M1009.214,1345.709l-1.423-.827-3.218,1.858,1.439.827Z",
    transform: "translate(-722.634 -967.435)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1430",
    "data-name": "Caminho 1430",
    d: "M1006.012,1352.329l2.038.774-.212,12.89a3.019,3.019,0,0,0,1.547,2.636s18.42,12.016,21.329,12.994a4.378,4.378,0,0,0,.581.16l.054.009.051.006.047,0h.081l.035,0,.03-.006.026-.009.019-.009a.1.1,0,0,0,.037-.035.093.093,0,0,0,.012-.049l0,1.07a.09.09,0,0,1-.049.084l-.019.009-.026.008-.031.006-.035,0h-.039l-.043,0-.047,0-.05-.007-.055-.009a4.358,4.358,0,0,1-.581-.16c-2.836-.953-11.7-5.7-18-9.153-3.443-1.888-6.131-3.4-6.538-3.628a3.078,3.078,0,0,1-1.609-2.636V1351.5Z",
    transform: "translate(-722.635 -972.196)",
    fill: "#383b3f"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_492",
    "data-name": "Grupo 492",
    transform: "translate(283.378 378.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_814",
    "data-name": "Ret\\xE2ngulo 814",
    width: 39.031,
    height: 41.015,
    transform: "translate(-13.897 8.064) rotate(-30.124)",
    fill: "url(#linear-gradient-27)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_493",
    "data-name": "Grupo 493",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1432",
    "data-name": "Caminho 1432",
    d: "M1053.5,1318.878l-1.423-.827-3.218,1.858,1.438.827Z",
    transform: "translate(-754.491 -948.134)",
    fill: "#8e9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1433",
    "data-name": "Caminho 1433",
    d: "M1048.859,1324.671l1.438.827,2.038.774-.212,12.89a3.019,3.019,0,0,0,1.547,2.636s18.42,12.016,21.329,12.994a4.368,4.368,0,0,0,.581.16l.054.009.05.007.047,0,.043,0h.039l.035,0,.031-.006.026-.008.019-.009a.1.1,0,0,0,.036-.035.1.1,0,0,0,.012-.048l0,1.07a.091.091,0,0,1-.049.084l-.019.009-.026.008-.03.006-.035,0h-.039l-.042,0-.047,0-.051-.006-.054-.009a4.354,4.354,0,0,1-.581-.16c-2.836-.953-11.7-5.7-18-9.156-3.443-1.881-6.131-3.4-6.538-3.625a3.078,3.078,0,0,1-1.609-2.636Z",
    transform: "translate(-754.491 -952.896)",
    fill: "#383b3f"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496",
    transform: "translate(295.807 370.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_816",
    "data-name": "Ret\\xE2ngulo 816",
    width: 39.03,
    height: 41.015,
    transform: "translate(-13.897 8.064) rotate(-30.124)",
    fill: "url(#linear-gradient-28)"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_497",
    "data-name": "Grupo 497",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1435",
    "data-name": "Caminho 1435",
    d: "M1013.693,1289.344v.874l-24.45,14.107-.006-.87Z",
    transform: "translate(-711.602 -927.484)",
    fill: "#37383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1436",
    "data-name": "Caminho 1436",
    d: "M1013.693,1302.81v.874l-24.45,14.107-.006-.87Z",
    transform: "translate(-711.602 -937.17)",
    fill: "#37383c"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_500",
    "data-name": "Grupo 500",
    transform: "translate(242.127 343.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_499",
    "data-name": "Grupo 499",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_818",
    "data-name": "Ret\\xE2ngulo 818",
    width: 30.9,
    height: 13.438,
    transform: "translate(0)",
    fill: "url(#linear-gradient-29)"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_502",
    "data-name": "Grupo 502",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_501",
    "data-name": "Grupo 501",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1438",
    "data-name": "Caminho 1438",
    d: "M961.883,1249.264l0,1.717.9-.517-.005-1.716Z",
    transform: "translate(-691.925 -898.28)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1439",
    "data-name": "Caminho 1439",
    d: "M924.123,1228.972l10.6,6.159.9-.517-10.6-6.159Z",
    transform: "translate(-664.762 -883.683)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1440",
    "data-name": "Caminho 1440",
    d: "M924.123,1230.3l0,.874,10.6,6.159,0-.874Z",
    transform: "translate(-664.762 -885.008)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1441",
    "data-name": "Caminho 1441",
    d: "M912.937,1236.755l0,.874,10.6,6.159,0-.874Z",
    transform: "translate(-656.716 -889.654)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1442",
    "data-name": "Caminho 1442",
    d: "M950.7,1255.722l0,1.716.9-.517-.005-1.717Z",
    transform: "translate(-683.879 -902.926)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1443",
    "data-name": "Caminho 1443",
    d: "M912.937,1235.43l10.6,6.159.9-.517-10.6-6.159Z",
    transform: "translate(-656.716 -888.329)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1444",
    "data-name": "Caminho 1444",
    d: "M901.746,1243.216l0,.874,10.6,6.159,0-.874Z",
    transform: "translate(-648.666 -894.301)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1445",
    "data-name": "Caminho 1445",
    d: "M939.507,1262.18l0,1.716.9-.518-.005-1.716Z",
    transform: "translate(-675.829 -907.571)",
    fill: "#333132"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_504",
    "data-name": "Grupo 504",
    transform: "translate(274.061 349.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_503",
    "data-name": "Grupo 503",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_820",
    "data-name": "Ret\\xE2ngulo 820",
    width: 9.968,
    height: 7.87,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-30)"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_506",
    "data-name": "Grupo 506",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_505",
    "data-name": "Grupo 505",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1447",
    "data-name": "Caminho 1447",
    d: "M928.321,1268.639l0,1.716.9-.518-.005-1.716Z",
    transform: "translate(-667.783 -912.217)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1448",
    "data-name": "Caminho 1448",
    d: "M890.56,1248.347l10.6,6.159.9-.518-10.6-6.159Z",
    transform: "translate(-640.62 -897.62)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1449",
    "data-name": "Caminho 1449",
    d: "M890.56,1249.674l0,.874,10.6,6.159,0-.874Z",
    transform: "translate(-640.62 -898.947)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1450",
    "data-name": "Caminho 1450",
    d: "M1003.342,1273.357l0,1.717.9-.517-.005-1.717Z",
    transform: "translate(-721.748 -915.611)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1451",
    "data-name": "Caminho 1451",
    d: "M879.375,1256.132l0,.874,10.6,6.159,0-.874Z",
    transform: "translate(-632.573 -903.593)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1452",
    "data-name": "Caminho 1452",
    d: "M917.135,1275.1l0,1.717.9-.518-.005-1.716Z",
    transform: "translate(-659.736 -916.863)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1453",
    "data-name": "Caminho 1453",
    d: "M868.189,1262.59l0,.874,10.6,6.159,0-.874Z",
    transform: "translate(-624.527 -908.238)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1454",
    "data-name": "Caminho 1454",
    d: "M905.95,1281.555l0,1.716.9-.518-.005-1.716Z",
    transform: "translate(-651.69 -921.508)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1455",
    "data-name": "Caminho 1455",
    d: "M901.925,1258.521l0,1.717,20.931-12.084-.005-1.717Z",
    transform: "translate(-648.795 -896.619)",
    fill: "#66696f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1456",
    "data-name": "Caminho 1456",
    d: "M965.586,1254.393l0,.874,10.6,6.158,0-.874Z",
    transform: "translate(-694.589 -902.342)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1457",
    "data-name": "Caminho 1457",
    d: "M965.586,1253.068l10.6,6.158.9-.517-10.6-6.158Z",
    transform: "translate(-694.589 -901.016)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1458",
    "data-name": "Caminho 1458",
    d: "M879.375,1254.8l10.6,6.159.9-.518-10.6-6.159Z",
    transform: "translate(-632.573 -902.266)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1459",
    "data-name": "Caminho 1459",
    d: "M992.156,1279.815l0,1.717.9-.517-.005-1.716Z",
    transform: "translate(-713.702 -920.257)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1460",
    "data-name": "Caminho 1460",
    d: "M954.4,1259.526l10.6,6.158.9-.517-10.6-6.158Z",
    transform: "translate(-686.542 -905.662)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1461",
    "data-name": "Caminho 1461",
    d: "M954.4,1260.851l0,.874,10.6,6.158,0-.874Z",
    transform: "translate(-686.542 -906.987)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1462",
    "data-name": "Caminho 1462",
    d: "M943.21,1265.984l10.6,6.158.9-.517-10.6-6.158Z",
    transform: "translate(-678.493 -910.308)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1463",
    "data-name": "Caminho 1463",
    d: "M943.21,1267.312l0,.874,10.6,6.158,0-.874Z",
    transform: "translate(-678.493 -911.635)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1464",
    "data-name": "Caminho 1464",
    d: "M980.966,1286.274l0,1.717.9-.518-.005-1.716Z",
    transform: "translate(-705.652 -924.903)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1465",
    "data-name": "Caminho 1465",
    d: "M969.78,1292.732l0,1.716.9-.518-.005-1.717Z",
    transform: "translate(-697.606 -929.548)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1466",
    "data-name": "Caminho 1466",
    d: "M932.024,1272.443l10.6,6.158.9-.518-10.6-6.158Z",
    transform: "translate(-670.446 -914.953)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1467",
    "data-name": "Caminho 1467",
    d: "M932.024,1273.77l0,.874,10.6,6.158,0-.874Z",
    transform: "translate(-670.446 -916.28)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1468",
    "data-name": "Caminho 1468",
    d: "M958.594,1299.19l0,1.716.9-.518-.005-1.716Z",
    transform: "translate(-689.559 -934.194)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1469",
    "data-name": "Caminho 1469",
    d: "M920.838,1280.228l0,.874,10.6,6.158,0-.874Z",
    transform: "translate(-662.4 -920.926)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1470",
    "data-name": "Caminho 1470",
    d: "M920.838,1278.9l10.6,6.158.9-.518-10.6-6.158Z",
    transform: "translate(-662.4 -919.599)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1471",
    "data-name": "Caminho 1471",
    d: "M947.408,1305.648l0,1.717.9-.518-.005-1.716Z",
    transform: "translate(-681.513 -938.839)",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1472",
    "data-name": "Caminho 1472",
    d: "M909.652,1286.686l0,.874,10.6,6.158,0-.874Z",
    transform: "translate(-654.353 -925.572)",
    fill: "#383b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1473",
    "data-name": "Caminho 1473",
    d: "M909.652,1285.359l10.6,6.158.9-.517-10.6-6.158Z",
    transform: "translate(-654.353 -924.244)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1474",
    "data-name": "Caminho 1474",
    d: "M901.746,1241.888l10.6,6.159.9-.518-10.6-6.159Z",
    transform: "translate(-648.666 -892.974)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1475",
    "data-name": "Caminho 1475",
    d: "M868.189,1261.263l10.6,6.159.9-.518-10.6-6.159Z",
    transform: "translate(-624.527 -906.911)",
    fill: "#7a7c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1476",
    "data-name": "Caminho 1476",
    d: "M858.343,1234.408l20.08,11.669a4.683,4.683,0,0,0,4.244,0l18.763-10.833a1.3,1.3,0,0,0,.014-2.459l-20.08-11.67a4.688,4.688,0,0,0-4.246,0l-18.763,10.833a1.3,1.3,0,0,0-.012,2.458m11.6,5.534,20.931-12.085,9.52,5.532a.662.662,0,0,1-.007,1.251l-18.764,10.833a2.385,2.385,0,0,1-2.16,0Zm-10.553-7.388,18.764-10.833a2.383,2.383,0,0,1,2.16,0l9.521,5.533-20.931,12.084-9.521-5.533a.662.662,0,0,1,.007-1.251",
    transform: "translate(-616.817 -878.039)",
    fill: "#898b8f"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_508",
    "data-name": "Grupo 508",
    transform: "translate(240.654 355.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_507",
    "data-name": "Grupo 507",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_822",
    "data-name": "Ret\\xE2ngulo 822",
    width: 44.85,
    height: 15.117,
    fill: "url(#linear-gradient-31)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_515",
    "data-name": "Grupo 515",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_514",
    "data-name": "Grupo 514",
    clipPath: "url(#clip-path-2)"
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1478",
    "data-name": "Caminho 1478",
    d: "M1032.086,1303.384v.667l3.077,1.777v-.667Z",
    transform: "translate(-742.425 -937.583)",
    fill: "#11141e"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1479",
    "data-name": "Caminho 1479",
    d: "M1043.051,1307.508l1.929-1.121v-.667l-1.929,1.121Z",
    transform: "translate(-750.313 -939.264)",
    fill: "#33363f"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1480",
    "data-name": "Caminho 1480",
    d: "M983.976,1331.343v.667l3.077,1.777v-.667Z",
    transform: "translate(-707.817 -957.695)",
    fill: "#11141e"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1481",
    "data-name": "Caminho 1481",
    d: "M994.94,1335.467l1.929-1.121v-.667l-1.929,1.121Z",
    transform: "translate(-715.704 -959.376)",
    fill: "#33363f"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1482",
    "data-name": "Caminho 1482",
    d: "M1028.458,1374.974l-36.817,21.253v-1.314l36.817-21.253Z",
    transform: "translate(-713.331 -988.136)",
    fill: "#e6b467"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1483",
    "data-name": "Caminho 1483",
    d: "M977.431,1392.572l32.813-18.945,3.988,2.318-32.813,18.945Z",
    transform: "translate(-703.109 -988.112)",
    fill: "#eec178"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1484",
    "data-name": "Caminho 1484",
    d: "M1094.348,1361.313l4,2.327v-4.8l-4-2.327Z",
    transform: "translate(-787.213 -975.798)",
    fill: "#ae7a3b"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1485",
    "data-name": "Caminho 1485",
    d: "M1112.592,1361.339l-3.988,2.318v-4.8l3.988-2.318Z",
    transform: "translate(-797.468 -975.817)",
    fill: "#f3ca8d"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1486",
    "data-name": "Caminho 1486",
    d: "M1104.878,1505.943l-3.988,2.318v-1.314l3.988-2.318Z",
    transform: "translate(-791.919 -1082.347)",
    fill: "#e9ba71"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1487",
    "data-name": "Caminho 1487",
    d: "M1086.681,1505.943l3.988,2.318v-1.314l-3.988-2.318Z",
    transform: "translate(-781.697 -1082.347)",
    fill: "#c48b2e"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1488",
    "data-name": "Caminho 1488",
    d: "M1089.266,1372l36.091,20.974v-1.314l-36.091-20.974Z",
    transform: "translate(-783.557 -985.995)",
    fill: "#ae7a3b"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1489",
    "data-name": "Caminho 1489",
    d: "M1012.38,1450.866l-36.089-20.976-3.988,2.318,36.089,20.975Z",
    transform: "translate(-699.421 -1028.585)",
    fill: "#dcaf72"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1490",
    "data-name": "Caminho 1490",
    d: "M972.294,1439.468l36.091,20.974v-1.314l-36.091-20.974Z",
    transform: "translate(-699.414 -1034.529)",
    fill: "#9d6016"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1491",
    "data-name": "Caminho 1491",
    d: "M1221.851,1438.473l-3.988,2.318v-1.314l3.988-2.318Z",
    transform: "translate(-876.062 -1033.813)",
    fill: "#e9ba71"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1492",
    "data-name": "Caminho 1492",
    d: "M1129.352,1383.4l-36.089-20.975-3.988,2.317,36.089,20.976Z",
    transform: "translate(-783.564 -980.052)",
    fill: "#d89c3d"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1493",
    "data-name": "Caminho 1493",
    d: "M1104.878,1484.141l-3.988,2.318v-1.314l3.988-2.318Z",
    transform: "translate(-791.919 -1066.664)",
    fill: "#f4cc90"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1494",
    "data-name": "Caminho 1494",
    d: "M1086.681,1456.072l32.813-18.945,3.988,2.318-32.813,18.945Z",
    transform: "translate(-781.697 -1033.79)",
    fill: "#f7d194"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1495",
    "data-name": "Caminho 1495",
    d: "M1104.878,1492.314l-3.988,2.318v-4.8l3.988-2.317Z",
    transform: "translate(-791.919 -1070.033)",
    fill: "#f3ca8d"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1496",
    "data-name": "Caminho 1496",
    d: "M1221.841,1424.839l-3.988,2.318v-4.8l3.988-2.317Z",
    transform: "translate(-876.056 -1021.495)",
    fill: "#f3ca8d"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1497",
    "data-name": "Caminho 1497",
    d: "M1050.253,1460.564l-3.988,2.318v-4.8l3.988-2.317Z",
    transform: "translate(-752.625 -1047.194)",
    fill: "#f3ca8d"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1498",
    "data-name": "Caminho 1498",
    d: "M995.629,1428.814l-3.988,2.318v-4.8l3.988-2.318Z",
    transform: "translate(-713.331 -1024.354)",
    fill: "#f3ca8d"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1499",
    "data-name": "Caminho 1499",
    d: "M1012.38,1429.064l-36.089-20.976-3.988,2.318,36.089,20.976Z",
    transform: "translate(-699.421 -1012.902)",
    fill: "#d29c3d"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1500",
    "data-name": "Caminho 1500",
    d: "M972.294,1417.666l36.091,20.974v-1.314l-36.091-20.974Z",
    transform: "translate(-699.414 -1018.846)",
    fill: "#9d6016"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1501",
    "data-name": "Caminho 1501",
    d: "M1221.851,1416.671l-3.988,2.318v-1.314l3.988-2.318Z",
    transform: "translate(-876.062 -1018.13)",
    fill: "#f4cc90"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1502",
    "data-name": "Caminho 1502",
    d: "M1129.352,1361.595l-36.089-20.976-3.988,2.318,36.089,20.976Z",
    transform: "translate(-783.564 -964.368)",
    fill: "#d89c3d"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1503",
    "data-name": "Caminho 1503",
    d: "M1089.266,1350.2l36.091,20.974v-1.314l-36.091-20.974Z",
    transform: "translate(-783.557 -970.312)",
    fill: "#b7874c"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1504",
    "data-name": "Caminho 1504",
    d: "M1163.36,1450.4l-3.988,2.318v-1.314l3.988-2.318Z",
    transform: "translate(-833.987 -1042.396)",
    fill: "#f4cc90"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1505",
    "data-name": "Caminho 1505",
    d: "M1070.861,1395.327l-36.089-20.976-3.988,2.318,36.089,20.976Z",
    transform: "translate(-741.489 -988.633)",
    fill: "#d89c3d"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1506",
    "data-name": "Caminho 1506",
    d: "M1030.775,1383.93l36.091,20.974v-1.314l-36.091-20.974Z",
    transform: "translate(-741.482 -994.578)",
    fill: "#a7712e"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1507",
    "data-name": "Caminho 1507",
    d: "M1086.681,1478.714l3.988,2.318v-1.314l-3.988-2.318Z",
    transform: "translate(-781.697 -1062.76)",
    fill: "#c48b2e"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1508",
    "data-name": "Caminho 1508",
    d: "M1081.552,1489.333l5.427,3.154v-4.8l-5.427-3.154Z",
    transform: "translate(-778.009 -1067.889)",
    fill: "#b5854b"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1509",
    "data-name": "Caminho 1509",
    d: "M1203.6,1424.812l4,2.327v-4.8l-4-2.327Z",
    transform: "translate(-865.801 -1021.475)",
    fill: "#ae7a3b"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1510",
    "data-name": "Caminho 1510",
    d: "M1145.106,1458.544l4,2.327v-4.8l-4-2.327Z",
    transform: "translate(-823.726 -1045.741)",
    fill: "#b7874c"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1511",
    "data-name": "Caminho 1511",
    d: "M1026.928,1457.584l5.427,3.154v-4.8l-5.427-3.154Z",
    transform: "translate(-738.715 -1045.05)",
    fill: "#b5854b"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1512",
    "data-name": "Caminho 1512",
    d: "M972.3,1425.835l5.427,3.154v-4.8l-5.427-3.154Z",
    transform: "translate(-699.421 -1022.211)",
    fill: "#b5854b"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1513",
    "data-name": "Caminho 1513",
    d: "M1067.616,1467.635l3.988,2.318v-1.314l-3.988-2.318Z",
    transform: "translate(-767.983 -1054.791)",
    fill: "#bf8423"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1514",
    "data-name": "Caminho 1514",
    d: "M1048.552,1456.556l3.988,2.318v-1.314l-3.988-2.317Z",
    transform: "translate(-754.27 -1046.822)",
    fill: "#c48b2e"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1515",
    "data-name": "Caminho 1515",
    d: "M1029.487,1445.476l3.988,2.318v-1.314l-3.988-2.318Z",
    transform: "translate(-740.556 -1038.851)",
    fill: "#b48143"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1516",
    "data-name": "Caminho 1516",
    d: "M1010.423,1434.4l3.988,2.318V1435.4l-3.988-2.317Z",
    transform: "translate(-726.842 -1030.882)",
    fill: "#c48b2e"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1517",
    "data-name": "Caminho 1517",
    d: "M991.358,1423.318l3.988,2.318v-1.314L991.358,1422Z",
    transform: "translate(-713.128 -1022.912)",
    fill: "#b48143"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1518",
    "data-name": "Caminho 1518",
    d: "M972.294,1412.24l3.988,2.318v-1.314l-3.988-2.317Z",
    transform: "translate(-699.414 -1014.943)",
    fill: "#a66d28"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1519",
    "data-name": "Caminho 1519",
    d: "M972.3,1356.45l36.814-21.255,3.99,2.318-36.815,21.255Z",
    transform: "translate(-699.417 -960.466)",
    fill: "#f9d59c"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1520",
    "data-name": "Caminho 1520",
    d: "M991.363,1367.529l36.814-21.255,3.988,2.318-36.814,21.255Z",
    transform: "translate(-713.131 -968.436)",
    fill: "#fedeac"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1521",
    "data-name": "Caminho 1521",
    d: "M1010.427,1378.608l36.814-21.255,3.988,2.318-36.815,21.255Z",
    transform: "translate(-726.845 -976.406)",
    fill: "#f6d093"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1522",
    "data-name": "Caminho 1522",
    d: "M1029.487,1389.684l36.814-21.255,3.99,2.318L1033.476,1392Z",
    transform: "translate(-740.556 -984.373)",
    fill: "#fedeac"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1523",
    "data-name": "Caminho 1523",
    d: "M1048.552,1400.763l36.814-21.255,3.988,2.318-36.814,21.255Z",
    transform: "translate(-754.27 -992.343)",
    fill: "#f9d69e"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1524",
    "data-name": "Caminho 1524",
    d: "M1067.616,1411.842l36.814-21.255,3.988,2.318L1071.6,1414.16Z",
    transform: "translate(-767.983 -1000.313)",
    fill: "#ffefcb"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1525",
    "data-name": "Caminho 1525",
    d: "M1086.681,1422.922l36.814-21.255,3.988,2.318-36.814,21.255Z",
    transform: "translate(-781.697 -1008.282)",
    fill: "#ffe6bb"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1526",
    "data-name": "Caminho 1526",
    d: "M1023.321,1344.77,986.5,1366.024v-1.314l36.817-21.253Z",
    transform: "translate(-709.636 -966.409)",
    fill: "#e9ba71"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1527",
    "data-name": "Caminho 1527",
    d: "M1042.385,1355.849l-36.817,21.253v-1.314l36.817-21.253Z",
    transform: "translate(-723.35 -974.378)",
    fill: "#e9ba71"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1528",
    "data-name": "Caminho 1528",
    d: "M1061.45,1366.928l-36.817,21.253v-1.314l36.817-21.253Z",
    transform: "translate(-737.064 -982.348)",
    fill: "#e9ba71"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1529",
    "data-name": "Caminho 1529",
    d: "M1080.514,1378.007,1043.7,1399.26v-1.314l36.817-21.253Z",
    transform: "translate(-750.778 -990.317)",
    fill: "#e9ba71"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1530",
    "data-name": "Caminho 1530",
    d: "M1099.579,1389.086l-36.817,21.253v-1.314l36.817-21.254Z",
    transform: "translate(-764.492 -998.287)",
    fill: "#e9ba71"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1531",
    "data-name": "Caminho 1531",
    d: "M1118.643,1400.165l-36.817,21.253V1420.1l36.817-21.253Z",
    transform: "translate(-778.205 -1006.257)",
    fill: "#e9ba71"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1532",
    "data-name": "Caminho 1532",
    d: "M1137.708,1411.244,1100.89,1432.5v-1.314l36.817-21.253Z",
    transform: "translate(-791.919 -1014.227)",
    fill: "#e9ba71"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1533",
    "data-name": "Caminho 1533",
    d: "M1104.878,1492.314l-3.988,2.318v-4.8l3.988-2.317Z",
    transform: "translate(-791.919 -1070.033)",
    fill: "#e9ba71"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1534",
    "data-name": "Caminho 1534",
    d: "M1163.36,1458.577l-3.988,2.318v-4.8l3.988-2.317Z",
    transform: "translate(-833.987 -1045.764)",
    fill: "#e9ba71"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    "data-name": "Caminho 1535",
    d: "M1221.841,1424.839l-3.988,2.318v-4.8l3.988-2.317Z",
    transform: "translate(-876.056 -1021.495)",
    fill: "#e9ba71"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1536",
    "data-name": "Caminho 1536",
    d: "M1137.708,1438.473l-36.817,21.253v-1.314l36.817-21.253Z",
    transform: "translate(-791.919 -1033.813)",
    fill: "#e6b467"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1537",
    "data-name": "Caminho 1537",
    d: "M1068.878,1338.364l11.647-6.724-11.647-6.724-11.647,6.724Z",
    transform: "translate(-760.513 -953.072)",
    fill: "#e8d6a2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1538",
    "data-name": "Caminho 1538",
    d: "M1085.836,1342.659l2.128-1.229-11.647-6.724-2.128,1.228Z",
    transform: "translate(-772.712 -960.115)",
    fill: "#b58850"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1539",
    "data-name": "Caminho 1539",
    d: "M1110.129,1362.323l-11.647,6.724V1355.6l11.647-6.724Z",
    transform: "translate(-790.187 -970.306)",
    fill: "#b58850"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1540",
    "data-name": "Caminho 1540",
    d: "M1117.568,1401.772l-2.128,1.228v-1.877l2.128-1.229Z",
    transform: "translate(-802.386 -1007.007)",
    fill: "#815300"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1541",
    "data-name": "Caminho 1541",
    d: "M1117.568,1360.542l-2.128,1.229v-1.877l2.128-1.229Z",
    transform: "translate(-802.386 -977.349)",
    fill: "#815300"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1542",
    "data-name": "Caminho 1542",
    d: "M1068.878,1369.048l-11.647-6.724v-13.448l11.647,6.724Z",
    transform: "translate(-760.513 -970.307)",
    fill: "#d6b477"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1543",
    "data-name": "Caminho 1543",
    d: "M1067.284,1388.788v2.664l2.307,1.332v-2.664Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-767.745 -999.018)",
    fill: "#815300"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1544",
    "data-name": "Caminho 1544",
    d: "M1069,1393.207l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-768.857 -1001.081)",
    fill: "#815300"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1545",
    "data-name": "Caminho 1545",
    d: "M1071.873,1394.866l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-770.925 -1002.275)",
    fill: "#815300"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1546",
    "data-name": "Caminho 1546",
    d: "M1070.079,1398.019l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-768.545 -1004.96)",
    fill: "#815300"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1547",
    "data-name": "Caminho 1547",
    d: "M1076.864,1394.319v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-774.636 -1002.997)",
    fill: "#815300"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1548",
    "data-name": "Caminho 1548",
    d: "M1079.51,1398.583v.53l-.244-.141c-.042-.025-.076,0-.076.044v.065l.8.461v-.065a.168.168,0,0,0-.076-.132l-.244-.141v-.53c.26.106.461-.037.461-.35v-.552l-.3-.174-.109.215.253.146-.455.351.148-.365-.234-.135.156-.352-.537-.31v.552a1.209,1.209,0,0,0,.46.882",
    transform: "translate(-776.208 -1005.033)",
    fill: "#815300"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1549",
    "data-name": "Caminho 1549",
    d: "M1086.484,1399.873v2.664l2.307,1.332V1401.2Zm2.2,3.81-2.093-1.208v-2.416l2.093,1.208Z",
    transform: "translate(-781.556 -1006.992)",
    fill: "#815300"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1550",
    "data-name": "Caminho 1550",
    d: "M1088.09,1404.247a.726.726,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.251.251,0,0,1-.113-.2.113.113,0,0,0-.051-.089c-.028-.016-.051,0-.051.029a.477.477,0,0,0,.215.373c.119.068.216.013.216-.124v-.753a.091.091,0,0,0,0-.026,1.844,1.844,0,0,1,.283.275.507.507,0,0,1,.295.056,2,2,0,0,1,.223.187,1.834,1.834,0,0,0-.8-1.214s0-.183,0-.183a.113.113,0,0,0-.051-.089c-.028-.016-.051,0-.051.03v.181c-.42-.216-.759-.073-.8.295a1.074,1.074,0,0,1,.223.071,1.293,1.293,0,0,1,.3.285",
    transform: "translate(-782.339 -1009.513)",
    fill: "#815300"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1551",
    "data-name": "Caminho 1551",
    d: "M1025.6,1363.281l11.647-6.724-11.647-6.724-11.647,6.724Z",
    transform: "translate(-729.383 -970.995)",
    fill: "#e8d6a2"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1552",
    "data-name": "Caminho 1552",
    d: "M1042.56,1367.576l2.128-1.228-11.647-6.724-2.128,1.229Z",
    transform: "translate(-741.582 -978.039)",
    fill: "#b58850"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1553",
    "data-name": "Caminho 1553",
    d: "M1066.853,1387.239l-11.647,6.724v-13.448l11.647-6.724Z",
    transform: "translate(-759.056 -988.23)",
    fill: "#b58850"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1554",
    "data-name": "Caminho 1554",
    d: "M1074.292,1426.688l-2.128,1.229v-1.877l2.128-1.229Z",
    transform: "translate(-771.255 -1024.931)",
    fill: "#815300"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1555",
    "data-name": "Caminho 1555",
    d: "M1074.292,1385.459l-2.128,1.228v-1.877l2.128-1.229Z",
    transform: "translate(-771.255 -995.273)",
    fill: "#815300"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1556",
    "data-name": "Caminho 1556",
    d: "M1025.6,1393.964l-11.647-6.724v-13.448l11.647,6.724Z",
    transform: "translate(-729.383 -988.231)",
    fill: "#d6b477"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1557",
    "data-name": "Caminho 1557",
    d: "M1024.007,1413.7v2.665l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-736.614 -1016.941)",
    fill: "#815300"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1558",
    "data-name": "Caminho 1558",
    d: "M1025.723,1418.124l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-737.727 -1019.005)",
    fill: "#815300"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1559",
    "data-name": "Caminho 1559",
    d: "M1028.6,1419.783l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-739.794 -1020.199)",
    fill: "#815300"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1560",
    "data-name": "Caminho 1560",
    d: "M1026.8,1422.936l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-737.415 -1022.883)",
    fill: "#815300"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1561",
    "data-name": "Caminho 1561",
    d: "M1033.588,1419.236v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-743.506 -1020.921)",
    fill: "#815300"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1562",
    "data-name": "Caminho 1562",
    d: "M1036.234,1423.5v.53l-.244-.141c-.042-.025-.076,0-.076.044V1424l.8.462v-.065a.167.167,0,0,0-.076-.131l-.244-.141v-.53c.26.106.461-.037.461-.35v-.552l-.3-.174-.109.216.253.146-.455.352.148-.365-.234-.135.156-.352-.537-.31v.552a1.209,1.209,0,0,0,.461.882",
    transform: "translate(-745.077 -1022.956)",
    fill: "#815300"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1563",
    "data-name": "Caminho 1563",
    d: "M1043.208,1424.79v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.093-1.208v-2.416l2.093,1.208Z",
    transform: "translate(-750.426 -1024.916)",
    fill: "#815300"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1564",
    "data-name": "Caminho 1564",
    d: "M1044.814,1429.164a.726.726,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.112.112,0,0,0-.051-.089c-.028-.016-.051,0-.051.03a.476.476,0,0,0,.215.373c.119.069.216.013.216-.124v-.753a.091.091,0,0,0,0-.026,1.849,1.849,0,0,1,.283.275.505.505,0,0,1,.295.056,2,2,0,0,1,.223.187,1.834,1.834,0,0,0-.8-1.214s0-.183,0-.183a.113.113,0,0,0-.051-.088c-.028-.016-.051,0-.051.03v.182c-.421-.216-.759-.073-.8.295a1.059,1.059,0,0,1,.223.071,1.293,1.293,0,0,1,.3.285",
    transform: "translate(-751.208 -1027.437)",
    fill: "#815300"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1565",
    "data-name": "Caminho 1565",
    d: "M1068.878,1288.531l11.647-6.724-11.647-6.724-11.647,6.724Z",
    transform: "translate(-760.513 -917.225)",
    fill: "#e8d6a2"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1566",
    "data-name": "Caminho 1566",
    d: "M1085.836,1292.826l2.128-1.229-11.647-6.724-2.128,1.228Z",
    transform: "translate(-772.712 -924.268)",
    fill: "#b58850"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1567",
    "data-name": "Caminho 1567",
    d: "M1110.129,1312.49l-11.647,6.724v-13.448l11.647-6.724Z",
    transform: "translate(-790.187 -934.459)",
    fill: "#b58850"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1568",
    "data-name": "Caminho 1568",
    d: "M1117.568,1351.939l-2.128,1.228v-1.877l2.128-1.229Z",
    transform: "translate(-802.386 -971.16)",
    fill: "#815300"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1569",
    "data-name": "Caminho 1569",
    d: "M1117.568,1310.709l-2.128,1.228v-1.877l2.128-1.229Z",
    transform: "translate(-802.386 -941.502)",
    fill: "#815300"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1570",
    "data-name": "Caminho 1570",
    d: "M1068.878,1319.215l-11.647-6.724v-13.448l11.647,6.724Z",
    transform: "translate(-760.513 -934.46)",
    fill: "#d6b477"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1571",
    "data-name": "Caminho 1571",
    d: "M1067.284,1338.955v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-767.745 -963.171)",
    fill: "#815300"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1572",
    "data-name": "Caminho 1572",
    d: "M1069,1343.374l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-768.857 -965.234)",
    fill: "#815300"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1573",
    "data-name": "Caminho 1573",
    d: "M1071.873,1345.033l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-770.925 -966.428)",
    fill: "#815300"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1574",
    "data-name": "Caminho 1574",
    d: "M1070.079,1348.186l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-768.545 -969.113)",
    fill: "#815300"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1575",
    "data-name": "Caminho 1575",
    d: "M1076.864,1344.486v2.664l2.307,1.332v-2.664Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-774.636 -967.15)",
    fill: "#815300"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1576",
    "data-name": "Caminho 1576",
    d: "M1079.51,1348.75v.53l-.244-.141c-.042-.024-.076,0-.076.044v.065l.8.462v-.065a.167.167,0,0,0-.076-.131l-.244-.141v-.53c.26.106.461-.037.461-.35v-.552l-.3-.174-.109.215.253.146-.455.352.148-.365-.234-.135.156-.352-.537-.31v.552a1.208,1.208,0,0,0,.46.882",
    transform: "translate(-776.208 -969.186)",
    fill: "#815300"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1577",
    "data-name": "Caminho 1577",
    d: "M1086.484,1350.04v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.093-1.208v-2.416l2.093,1.208Z",
    transform: "translate(-781.556 -971.145)",
    fill: "#815300"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1578",
    "data-name": "Caminho 1578",
    d: "M1088.09,1354.414a.724.724,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.113.113,0,0,0-.051-.088c-.028-.016-.051,0-.051.029a.477.477,0,0,0,.215.373c.119.068.216.013.216-.124v-.753a.091.091,0,0,0,0-.026,1.85,1.85,0,0,1,.283.275.507.507,0,0,1,.295.056,2,2,0,0,1,.223.187,1.834,1.834,0,0,0-.8-1.214s0-.183,0-.183a.113.113,0,0,0-.051-.088c-.028-.016-.051,0-.051.03v.182c-.42-.216-.759-.073-.8.295a1.066,1.066,0,0,1,.223.071,1.3,1.3,0,0,1,.3.285",
    transform: "translate(-782.339 -973.666)",
    fill: "#815300"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1579",
    "data-name": "Caminho 1579",
    d: "M1025.6,1313.448l11.647-6.724L1025.6,1300l-11.647,6.724Z",
    transform: "translate(-729.383 -935.148)",
    fill: "#e8d6a2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1580",
    "data-name": "Caminho 1580",
    d: "M1042.56,1317.743l2.128-1.229-11.647-6.724-2.128,1.228Z",
    transform: "translate(-741.582 -942.192)",
    fill: "#b58850"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1581",
    "data-name": "Caminho 1581",
    d: "M1066.853,1337.406l-11.647,6.724v-13.448l11.647-6.724Z",
    transform: "translate(-759.056 -952.383)",
    fill: "#b58850"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1582",
    "data-name": "Caminho 1582",
    d: "M1074.292,1376.855l-2.128,1.229v-1.877l2.128-1.229Z",
    transform: "translate(-771.255 -989.084)",
    fill: "#815300"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1583",
    "data-name": "Caminho 1583",
    d: "M1074.292,1335.626l-2.128,1.229v-1.877l2.128-1.229Z",
    transform: "translate(-771.255 -959.426)",
    fill: "#815300"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1584",
    "data-name": "Caminho 1584",
    d: "M1025.6,1344.131l-11.647-6.724v-13.448l11.647,6.724Z",
    transform: "translate(-729.383 -952.384)",
    fill: "#d6b477"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1585",
    "data-name": "Caminho 1585",
    d: "M1024.007,1363.872v2.664l2.307,1.332V1365.2Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-736.614 -981.095)",
    fill: "#815300"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1586",
    "data-name": "Caminho 1586",
    d: "M1025.723,1368.291l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-737.727 -983.158)",
    fill: "#815300"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1587",
    "data-name": "Caminho 1587",
    d: "M1028.6,1369.95l.3.171V1369l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-739.794 -984.352)",
    fill: "#815300"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1588",
    "data-name": "Caminho 1588",
    d: "M1026.8,1373.1l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-737.415 -987.036)",
    fill: "#815300"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1589",
    "data-name": "Caminho 1589",
    d: "M1033.588,1369.4v2.664l2.307,1.332v-2.664Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-743.506 -985.073)",
    fill: "#815300"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1590",
    "data-name": "Caminho 1590",
    d: "M1036.234,1373.666v.53l-.244-.141c-.042-.024-.076,0-.076.044v.065l.8.462v-.065a.167.167,0,0,0-.076-.131l-.244-.141v-.53c.26.106.461-.037.461-.35v-.552l-.3-.174-.109.216.253.146-.455.351.148-.365-.234-.136.156-.352-.537-.31v.552a1.209,1.209,0,0,0,.461.882",
    transform: "translate(-745.077 -987.109)",
    fill: "#815300"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1591",
    "data-name": "Caminho 1591",
    d: "M1043.208,1374.957v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.093-1.208v-2.416l2.093,1.208Z",
    transform: "translate(-750.426 -989.069)",
    fill: "#815300"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1592",
    "data-name": "Caminho 1592",
    d: "M1044.814,1379.331a.724.724,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.112.112,0,0,0-.051-.088c-.028-.016-.051,0-.051.03a.476.476,0,0,0,.215.373c.119.068.216.013.216-.124v-.753a.09.09,0,0,0,0-.026,1.849,1.849,0,0,1,.283.275.507.507,0,0,1,.295.056,2.028,2.028,0,0,1,.223.187,1.834,1.834,0,0,0-.8-1.214s0-.183,0-.183a.113.113,0,0,0-.051-.088c-.028-.016-.051,0-.051.029v.182c-.421-.216-.759-.073-.8.295a1.053,1.053,0,0,1,.223.071,1.29,1.29,0,0,1,.3.285",
    transform: "translate(-751.208 -991.59)",
    fill: "#815300"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1593",
    "data-name": "Caminho 1593",
    d: "M1111.662,1362.953l11.647-6.724-11.647-6.724-11.647,6.724Z",
    transform: "translate(-791.29 -970.76)",
    fill: "#e8d6a2"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1594",
    "data-name": "Caminho 1594",
    d: "M1128.62,1367.248l2.128-1.228L1119.1,1359.3l-2.128,1.228Z",
    transform: "translate(-803.489 -977.803)",
    fill: "#b58850"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1595",
    "data-name": "Caminho 1595",
    d: "M1152.913,1386.912l-11.646,6.724v-13.448l11.646-6.724Z",
    transform: "translate(-820.963 -987.995)",
    fill: "#b58850"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1596",
    "data-name": "Caminho 1596",
    d: "M1160.353,1426.36l-2.128,1.229v-1.877l2.128-1.229Z",
    transform: "translate(-833.163 -1024.695)",
    fill: "#815300"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1597",
    "data-name": "Caminho 1597",
    d: "M1160.353,1385.131l-2.128,1.228v-1.877l2.128-1.229Z",
    transform: "translate(-833.163 -995.037)",
    fill: "#815300"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1598",
    "data-name": "Caminho 1598",
    d: "M1111.662,1393.636l-11.647-6.724v-13.448l11.647,6.724Z",
    transform: "translate(-791.29 -987.995)",
    fill: "#d6b477"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1599",
    "data-name": "Caminho 1599",
    d: "M1110.068,1413.377v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-798.521 -1016.706)",
    fill: "#815300"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1600",
    "data-name": "Caminho 1600",
    d: "M1111.783,1417.8l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-799.634 -1018.769)",
    fill: "#815300"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1601",
    "data-name": "Caminho 1601",
    d: "M1114.657,1419.455l.3.171V1418.5l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-801.702 -1019.963)",
    fill: "#815300"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1602",
    "data-name": "Caminho 1602",
    d: "M1112.863,1422.608l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-799.322 -1022.648)",
    fill: "#815300"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1603",
    "data-name": "Caminho 1603",
    d: "M1119.648,1418.908v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-805.412 -1020.685)",
    fill: "#815300"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1604",
    "data-name": "Caminho 1604",
    d: "M1122.295,1423.172v.53l-.245-.141c-.042-.024-.076,0-.076.044v.065l.8.462v-.065a.167.167,0,0,0-.076-.131l-.244-.141v-.53c.26.106.46-.037.46-.35v-.552l-.3-.174-.109.216.253.146-.455.351.148-.365-.234-.135.156-.352-.537-.31v.552a1.209,1.209,0,0,0,.461.882",
    transform: "translate(-806.985 -1022.721)",
    fill: "#815300"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1605",
    "data-name": "Caminho 1605",
    d: "M1129.268,1424.462v2.664l2.307,1.332v-2.664Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-812.332 -1024.68)",
    fill: "#815300"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1606",
    "data-name": "Caminho 1606",
    d: "M1130.875,1428.836a.718.718,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.112.112,0,0,0-.051-.089c-.028-.016-.051,0-.051.03a.477.477,0,0,0,.215.373c.119.068.215.013.215-.124v-.753a.09.09,0,0,0,0-.026,1.844,1.844,0,0,1,.283.275.509.509,0,0,1,.295.055,2.04,2.04,0,0,1,.223.187,1.836,1.836,0,0,0-.8-1.214v-.182a.113.113,0,0,0-.051-.089c-.028-.016-.051,0-.051.03v.182c-.421-.216-.759-.073-.8.295a1.059,1.059,0,0,1,.223.071,1.293,1.293,0,0,1,.3.285",
    transform: "translate(-813.116 -1027.201)",
    fill: "#815300"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1607",
    "data-name": "Caminho 1607",
    d: "M1068.386,1387.87l11.646-6.724-11.646-6.724-11.647,6.724Z",
    transform: "translate(-760.159 -988.683)",
    fill: "#e8d6a2"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1608",
    "data-name": "Caminho 1608",
    d: "M1085.344,1392.165l2.128-1.229-11.647-6.724-2.128,1.228Z",
    transform: "translate(-772.358 -995.727)",
    fill: "#b58850"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1609",
    "data-name": "Caminho 1609",
    d: "M1109.637,1411.828l-11.647,6.724V1405.1l11.647-6.724Z",
    transform: "translate(-789.833 -1005.918)",
    fill: "#b58850"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1610",
    "data-name": "Caminho 1610",
    d: "M1117.076,1451.277l-2.128,1.229v-1.877l2.128-1.228Z",
    transform: "translate(-802.032 -1042.619)",
    fill: "#815300"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1611",
    "data-name": "Caminho 1611",
    d: "M1117.076,1410.048l-2.128,1.229V1409.4l2.128-1.229Z",
    transform: "translate(-802.032 -1012.961)",
    fill: "#815300"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1612",
    "data-name": "Caminho 1612",
    d: "M1068.386,1418.552l-11.647-6.724V1398.38l11.647,6.724Z",
    transform: "translate(-760.159 -1005.918)",
    fill: "#d6b477"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1613",
    "data-name": "Caminho 1613",
    d: "M1066.792,1438.294v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-767.391 -1034.63)",
    fill: "#815300"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1614",
    "data-name": "Caminho 1614",
    d: "M1068.507,1442.712l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-768.504 -1036.693)",
    fill: "#815300"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1615",
    "data-name": "Caminho 1615",
    d: "M1071.381,1444.372l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-770.571 -1037.886)",
    fill: "#815300"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1616",
    "data-name": "Caminho 1616",
    d: "M1069.587,1447.524l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-768.191 -1040.571)",
    fill: "#815300"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1617",
    "data-name": "Caminho 1617",
    d: "M1076.372,1443.825v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-774.282 -1038.609)",
    fill: "#815300"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1618",
    "data-name": "Caminho 1618",
    d: "M1079.019,1448.088v.53l-.245-.141c-.042-.024-.076,0-.076.044v.065l.8.462v-.065a.167.167,0,0,0-.076-.131l-.244-.141v-.53c.26.106.461-.037.461-.35v-.552l-.3-.174-.109.216.253.146-.455.351.148-.365-.234-.135.156-.352-.537-.31v.552a1.208,1.208,0,0,0,.461.882",
    transform: "translate(-775.855 -1040.644)",
    fill: "#815300"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1619",
    "data-name": "Caminho 1619",
    d: "M1085.992,1449.379v2.664l2.307,1.332v-2.664Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-781.202 -1042.604)",
    fill: "#815300"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1620",
    "data-name": "Caminho 1620",
    d: "M1087.6,1453.753a.717.717,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.112.112,0,0,0-.051-.089c-.028-.016-.051,0-.051.03a.477.477,0,0,0,.215.373c.119.068.215.013.215-.124v-.753a.091.091,0,0,0,0-.026,1.85,1.85,0,0,1,.283.275.508.508,0,0,1,.295.056,2.052,2.052,0,0,1,.223.187,1.835,1.835,0,0,0-.8-1.214s0-.183,0-.183a.113.113,0,0,0-.051-.088c-.028-.016-.051,0-.051.029v.182c-.421-.216-.759-.073-.8.295a1.059,1.059,0,0,1,.223.071,1.3,1.3,0,0,1,.3.285",
    transform: "translate(-781.985 -1045.125)",
    fill: "#815300"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1621",
    "data-name": "Caminho 1621",
    d: "M1111.662,1313.12l11.647-6.724-11.647-6.724-11.647,6.724Z",
    transform: "translate(-791.29 -934.913)",
    fill: "#e8d6a2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1622",
    "data-name": "Caminho 1622",
    d: "M1128.62,1317.415l2.128-1.228-11.647-6.724-2.128,1.228Z",
    transform: "translate(-803.489 -941.956)",
    fill: "#b58850"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1623",
    "data-name": "Caminho 1623",
    d: "M1152.913,1337.079l-11.646,6.724v-13.448l11.646-6.724Z",
    transform: "translate(-820.963 -952.148)",
    fill: "#b58850"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1624",
    "data-name": "Caminho 1624",
    d: "M1160.353,1376.528l-2.128,1.228v-1.877l2.128-1.228Z",
    transform: "translate(-833.163 -988.849)",
    fill: "#815300"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1625",
    "data-name": "Caminho 1625",
    d: "M1160.353,1335.3l-2.128,1.228v-1.877l2.128-1.228Z",
    transform: "translate(-833.163 -959.19)",
    fill: "#815300"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1626",
    "data-name": "Caminho 1626",
    d: "M1111.662,1343.8l-11.647-6.724v-13.448l11.647,6.724Z",
    transform: "translate(-791.29 -952.148)",
    fill: "#d6b477"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1627",
    "data-name": "Caminho 1627",
    d: "M1110.068,1363.544v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-798.521 -980.859)",
    fill: "#815300"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1628",
    "data-name": "Caminho 1628",
    d: "M1111.783,1367.963l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-799.634 -982.922)",
    fill: "#815300"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1629",
    "data-name": "Caminho 1629",
    d: "M1114.657,1369.622l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-801.702 -984.116)",
    fill: "#815300"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1630",
    "data-name": "Caminho 1630",
    d: "M1112.863,1372.775l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-799.322 -986.8)",
    fill: "#815300"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1631",
    "data-name": "Caminho 1631",
    d: "M1119.648,1369.075v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-805.412 -984.838)",
    fill: "#815300"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1632",
    "data-name": "Caminho 1632",
    d: "M1122.295,1373.339v.53l-.245-.141c-.042-.024-.076,0-.076.044v.065l.8.462v-.065a.168.168,0,0,0-.076-.132l-.244-.141v-.53c.26.106.46-.037.46-.35v-.552l-.3-.174-.109.216.253.146-.455.351.148-.365-.234-.135.156-.352-.537-.31v.552a1.209,1.209,0,0,0,.461.882",
    transform: "translate(-806.985 -986.873)",
    fill: "#815300"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1633",
    "data-name": "Caminho 1633",
    d: "M1129.268,1374.629v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-812.332 -988.833)",
    fill: "#815300"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1634",
    "data-name": "Caminho 1634",
    d: "M1130.875,1379a.72.72,0,0,1,.283.052.049.049,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.112.112,0,0,0-.051-.088c-.028-.016-.051,0-.051.029a.477.477,0,0,0,.215.373c.119.068.215.013.215-.124v-.753a.089.089,0,0,0,0-.026,1.837,1.837,0,0,1,.283.275.508.508,0,0,1,.295.056,2.025,2.025,0,0,1,.223.187,1.836,1.836,0,0,0-.8-1.214v-.182a.113.113,0,0,0-.051-.089c-.028-.016-.051,0-.051.03v.182c-.421-.216-.759-.073-.8.295a1.058,1.058,0,0,1,.223.071,1.286,1.286,0,0,1,.3.285",
    transform: "translate(-813.116 -991.354)",
    fill: "#815300"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1635",
    "data-name": "Caminho 1635",
    d: "M1068.386,1338.036l11.646-6.724-11.646-6.724-11.647,6.724Z",
    transform: "translate(-760.159 -952.836)",
    fill: "#e8d6a2"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1636",
    "data-name": "Caminho 1636",
    d: "M1085.344,1342.332l2.128-1.228-11.647-6.724-2.128,1.228Z",
    transform: "translate(-772.358 -959.879)",
    fill: "#b58850"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1637",
    "data-name": "Caminho 1637",
    d: "M1109.637,1361.995l-11.647,6.724v-13.448l11.647-6.724Z",
    transform: "translate(-789.833 -970.071)",
    fill: "#b58850"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1638",
    "data-name": "Caminho 1638",
    d: "M1117.076,1401.444l-2.128,1.228v-1.877l2.128-1.229Z",
    transform: "translate(-802.032 -1006.771)",
    fill: "#815300"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1639",
    "data-name": "Caminho 1639",
    d: "M1117.076,1360.215l-2.128,1.229v-1.877l2.128-1.228Z",
    transform: "translate(-802.032 -977.114)",
    fill: "#815300"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1640",
    "data-name": "Caminho 1640",
    d: "M1068.386,1368.719,1056.739,1362v-13.448l11.647,6.724Z",
    transform: "translate(-760.159 -970.071)",
    fill: "#d6b477"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1641",
    "data-name": "Caminho 1641",
    d: "M1066.792,1388.46v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-767.391 -998.782)",
    fill: "#815300"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1642",
    "data-name": "Caminho 1642",
    d: "M1068.507,1392.879l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-768.504 -1000.846)",
    fill: "#815300"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1643",
    "data-name": "Caminho 1643",
    d: "M1071.381,1394.539l.3.171v-1.124l.168.1-.316-.694-.316.329.168.1Z",
    transform: "translate(-770.571 -1002.039)",
    fill: "#815300"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1644",
    "data-name": "Caminho 1644",
    d: "M1069.587,1397.691l-1.682-.971v.22l1.682.971Z",
    transform: "translate(-768.191 -1004.724)",
    fill: "#815300"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1645",
    "data-name": "Caminho 1645",
    d: "M1076.372,1393.992v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-774.282 -1002.762)",
    fill: "#815300"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1646",
    "data-name": "Caminho 1646",
    d: "M1079.019,1398.255v.53l-.245-.141c-.042-.024-.076,0-.076.044v.065l.8.462v-.065a.167.167,0,0,0-.076-.131l-.244-.141v-.53c.26.106.461-.037.461-.35v-.552l-.3-.174-.109.216.253.146-.455.351.148-.365-.234-.135.156-.352-.537-.31v.552a1.208,1.208,0,0,0,.461.882",
    transform: "translate(-775.855 -1004.797)",
    fill: "#815300"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1647",
    "data-name": "Caminho 1647",
    d: "M1085.992,1399.546v2.664l2.307,1.332v-2.665Zm2.2,3.81-2.092-1.208v-2.416l2.092,1.208Z",
    transform: "translate(-781.202 -1006.757)",
    fill: "#815300"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1648",
    "data-name": "Caminho 1648",
    d: "M1087.6,1403.919a.722.722,0,0,1,.283.052.048.048,0,0,0,0,.021v.753c0,.072-.051.1-.113.065a.25.25,0,0,1-.113-.2.112.112,0,0,0-.051-.088c-.028-.016-.051,0-.051.029a.476.476,0,0,0,.215.373c.119.068.215.013.215-.124v-.753a.088.088,0,0,0,0-.026,1.837,1.837,0,0,1,.283.275.508.508,0,0,1,.295.056,2.037,2.037,0,0,1,.223.187,1.836,1.836,0,0,0-.8-1.214v-.182a.113.113,0,0,0-.051-.088c-.028-.016-.051,0-.051.03v.181c-.421-.216-.759-.073-.8.295a1.067,1.067,0,0,1,.223.071,1.288,1.288,0,0,1,.3.285",
    transform: "translate(-781.985 -1009.277)",
    fill: "#815300"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1649",
    "data-name": "Caminho 1649",
    d: "M631.157,1235.462l2.274-1.321,1.923,1.117-2.274,1.321Z",
    transform: "translate(-454.019 -887.773)",
    fill: "#bdbec1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1650",
    "data-name": "Caminho 1650",
    d: "M640.281,1361.362l-2.274,1.321V1239.443l2.274-1.322Z",
    transform: "translate(-458.947 -890.637)",
    fill: "#9d9fa3"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1651",
    "data-name": "Caminho 1651",
    d: "M631.157,1362.09l1.923,1.117V1239.966l-1.923-1.117Z",
    transform: "translate(-454.019 -891.16)",
    fill: "#8e9095"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1652",
    "data-name": "Caminho 1652",
    d: "M400.626,1101.663l2.274-1.321,1.923,1.117-2.274,1.321Z",
    transform: "translate(-288.188 -791.526)",
    fill: "#bdbec1"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1653",
    "data-name": "Caminho 1653",
    d: "M409.751,1227.564l-2.274,1.321V1105.644l2.274-1.322Z",
    transform: "translate(-293.116 -794.39)",
    fill: "#9d9fa3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1654",
    "data-name": "Caminho 1654",
    d: "M400.626,1228.291l1.923,1.117V1106.167l-1.923-1.117Z",
    transform: "translate(-288.188 -794.913)",
    fill: "#8e9095"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1655",
    "data-name": "Caminho 1655",
    d: "M345.816,1144.752l66.622,38.669-21.385,12.346L324.431,1157.1Z",
    transform: "translate(-233.378 -823.472)",
    fill: "#bdbec1"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1656",
    "data-name": "Caminho 1656",
    d: "M359.264,1145.645l16.647,9.662.2.114v-17.338l-16.844-9.776Z",
    transform: "translate(-258.435 -811.643)",
    fill: "#bd8b5a"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1657",
    "data-name": "Caminho 1657",
    d: "M388.622,1189.3v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-279.553 -855.52)",
    fill: "#89560a"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1658",
    "data-name": "Caminho 1658",
    d: "M394.921,1197.361l-.381-.22v-1.449l-.216-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-283.654 -859.72)",
    fill: "#89560a"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1659",
    "data-name": "Caminho 1659",
    d: "M391.215,1195.222l-.381-.22v-1.449l-.217-.125.408-.424.407.895-.217-.125Z",
    transform: "translate(-280.988 -858.181)",
    fill: "#89560a"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1660",
    "data-name": "Caminho 1660",
    d: "M390.058,1199.954l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-280.586 -863.181)",
    fill: "#89560a"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1661",
    "data-name": "Caminho 1661",
    d: "M376.271,1182.173v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-270.668 -850.391)",
    fill: "#89560a"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1662",
    "data-name": "Caminho 1662",
    d: "M379.888,1187.789v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.595v-.084c0-.062.044-.088.1-.057l.315.182v-.683a1.559,1.559,0,0,1-.594-1.138v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.687.692.4v.711c0,.4-.258.588-.594.452",
    transform: "translate(-272.695 -853.016)",
    fill: "#89560a"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1663",
    "data-name": "Caminho 1663",
    d: "M363.869,1175.013v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-261.747 -845.24)",
    fill: "#89560a"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1664",
    "data-name": "Caminho 1664",
    d: "M366.791,1181.143a2.359,2.359,0,0,0-.365-.354.114.114,0,0,1,.006.034v.971a.322.322,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.062.062,0,0,1,.006-.028.926.926,0,0,0-.365-.067,1.656,1.656,0,0,0-.381-.367,1.377,1.377,0,0,0-.288-.092c.049-.474.485-.659,1.027-.378v-.235c0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114v.234a2.371,2.371,0,0,1,1.027,1.567,2.644,2.644,0,0,0-.288-.241.66.66,0,0,0-.381-.072",
    transform: "translate(-262.757 -848.491)",
    fill: "#89560a"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1665",
    "data-name": "Caminho 1665",
    d: "M376.108,1115.865l15.015-8.669-16.844-9.776-15.015,8.669Z",
    transform: "translate(-258.435 -789.424)",
    fill: "#f0d9ac"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1666",
    "data-name": "Caminho 1666",
    d: "M397.971,1121.4l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-274.162 -798.504)",
    fill: "#bd8b5a"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1667",
    "data-name": "Caminho 1667",
    d: "M434.295,1149.591l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-301.606 -814.481)",
    fill: "#deb781"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1668",
    "data-name": "Caminho 1668",
    d: "M443.568,1200.449l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-317.105 -861.797)",
    fill: "#89560a"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1669",
    "data-name": "Caminho 1669",
    d: "M443.568,1147.3l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-317.105 -823.561)",
    fill: "#89560a"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1670",
    "data-name": "Caminho 1670",
    d: "M424.243,1182.961l16.647,9.662.2.115V1175.4l-16.844-9.776Z",
    transform: "translate(-305.177 -838.485)",
    fill: "#bd8b5a"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1671",
    "data-name": "Caminho 1671",
    d: "M453.6,1226.619v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-326.295 -882.363)",
    fill: "#89560a"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1672",
    "data-name": "Caminho 1672",
    d: "M459.9,1234.677l-.381-.22v-1.45l-.217-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-330.396 -886.563)",
    fill: "#89560a"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1673",
    "data-name": "Caminho 1673",
    d: "M456.194,1232.537l-.381-.22v-1.449l-.216-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-327.731 -885.024)",
    fill: "#89560a"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1674",
    "data-name": "Caminho 1674",
    d: "M455.036,1237.269l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-327.328 -890.024)",
    fill: "#89560a"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1675",
    "data-name": "Caminho 1675",
    d: "M441.249,1219.488v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-317.41 -877.233)",
    fill: "#89560a"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1676",
    "data-name": "Caminho 1676",
    d: "M444.867,1225.1v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.595v-.084c0-.062.044-.088.1-.057l.315.182v-.683a1.558,1.558,0,0,1-.594-1.138v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.687.692.4v.711c0,.4-.258.588-.594.452",
    transform: "translate(-319.438 -879.858)",
    fill: "#89560a"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1677",
    "data-name": "Caminho 1677",
    d: "M428.847,1212.328v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-308.489 -872.083)",
    fill: "#89560a"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1678",
    "data-name": "Caminho 1678",
    d: "M431.769,1218.458a2.367,2.367,0,0,0-.365-.354.114.114,0,0,1,.006.034v.97a.322.322,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.03-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.061.061,0,0,1,.006-.027.926.926,0,0,0-.365-.067,1.657,1.657,0,0,0-.381-.367,1.363,1.363,0,0,0-.288-.092c.049-.474.485-.659,1.027-.378v-.235c0-.042.029-.059.066-.038a.145.145,0,0,1,.066.114v.234a2.372,2.372,0,0,1,1.027,1.567,2.63,2.63,0,0,0-.288-.241.66.66,0,0,0-.381-.072",
    transform: "translate(-309.499 -875.334)",
    fill: "#89560a"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1679",
    "data-name": "Caminho 1679",
    d: "M441.086,1153.179l15.015-8.669-16.844-9.777-15.015,8.669Z",
    transform: "translate(-305.176 -816.266)",
    fill: "#f0d9ac"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1680",
    "data-name": "Caminho 1680",
    d: "M462.95,1158.717l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-320.904 -825.346)",
    fill: "#bd8b5a"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1681",
    "data-name": "Caminho 1681",
    d: "M499.274,1186.906l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-348.349 -841.323)",
    fill: "#deb781"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1682",
    "data-name": "Caminho 1682",
    d: "M508.546,1237.765l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-363.847 -888.639)",
    fill: "#89560a"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1683",
    "data-name": "Caminho 1683",
    d: "M508.546,1184.611l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-363.847 -850.404)",
    fill: "#89560a"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1684",
    "data-name": "Caminho 1684",
    d: "M490.229,1222.295l16.647,9.662.2.115v-17.338l-16.844-9.776Z",
    transform: "translate(-352.643 -866.78)",
    fill: "#bd8b5a"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1685",
    "data-name": "Caminho 1685",
    d: "M519.586,1265.954v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-373.761 -910.658)",
    fill: "#89560a"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1686",
    "data-name": "Caminho 1686",
    d: "M525.885,1274.011l-.381-.22v-1.45l-.217-.125.408-.424.407.895-.217-.125Z",
    transform: "translate(-377.862 -914.858)",
    fill: "#89560a"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1687",
    "data-name": "Caminho 1687",
    d: "M522.18,1271.872l-.381-.22V1270.2l-.217-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-375.197 -913.319)",
    fill: "#89560a"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1688",
    "data-name": "Caminho 1688",
    d: "M521.022,1276.6l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-374.794 -918.319)",
    fill: "#89560a"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1689",
    "data-name": "Caminho 1689",
    d: "M507.235,1258.823v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-364.877 -905.529)",
    fill: "#89560a"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1690",
    "data-name": "Caminho 1690",
    d: "M510.853,1264.439v.683l.315.182a.216.216,0,0,1,.1.169v.084l-1.031-.595v-.084c0-.062.044-.087.1-.056l.315.182v-.683a1.56,1.56,0,0,1-.594-1.138v-.711l.389.225.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.686.692.4v.711c0,.4-.258.588-.594.451",
    transform: "translate(-366.904 -908.153)",
    fill: "#89560a"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1691",
    "data-name": "Caminho 1691",
    d: "M494.833,1251.662v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-355.955 -900.377)",
    fill: "#89560a"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1692",
    "data-name": "Caminho 1692",
    d: "M497.755,1257.793a2.369,2.369,0,0,0-.365-.354.114.114,0,0,1,.006.034v.971a.323.323,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.062.062,0,0,1,.006-.028.928.928,0,0,0-.365-.067,1.658,1.658,0,0,0-.381-.367,1.371,1.371,0,0,0-.288-.092c.049-.474.485-.659,1.027-.378v-.236c0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114v.234a2.371,2.371,0,0,1,1.027,1.567,2.646,2.646,0,0,0-.288-.241.66.66,0,0,0-.381-.072",
    transform: "translate(-356.965 -903.629)",
    fill: "#89560a"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1693",
    "data-name": "Caminho 1693",
    d: "M507.072,1192.514l15.015-8.669-16.844-9.776-15.015,8.669Z",
    transform: "translate(-352.643 -844.561)",
    fill: "#f0d9ac"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1694",
    "data-name": "Caminho 1694",
    d: "M528.936,1198.051l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-368.37 -853.641)",
    fill: "#bd8b5a"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1695",
    "data-name": "Caminho 1695",
    d: "M565.26,1226.24l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-395.816 -869.618)",
    fill: "#deb781"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1696",
    "data-name": "Caminho 1696",
    d: "M574.532,1277.1l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-411.313 -916.934)",
    fill: "#89560a"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1697",
    "data-name": "Caminho 1697",
    d: "M574.532,1223.945l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-411.313 -878.699)",
    fill: "#89560a"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1698",
    "data-name": "Caminho 1698",
    d: "M324.431,1191.019l66.622,38.669v-2.276l-66.622-38.669Z",
    transform: "translate(-233.378 -855.117)",
    fill: "#8e9095"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1699",
    "data-name": "Caminho 1699",
    d: "M583.2,1284.808l-21.385,12.346v-2.276l21.385-12.347Z",
    transform: "translate(-404.137 -922.583)",
    fill: "#9d9fa3"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1700",
    "data-name": "Caminho 1700",
    d: "M345.816,1296.943l66.622,38.669-21.385,12.346-66.622-38.669Z",
    transform: "translate(-233.378 -932.95)",
    fill: "#bdbec1"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1701",
    "data-name": "Caminho 1701",
    d: "M359.264,1301.145l16.647,9.662.2.115v-17.338l-16.844-9.776Z",
    transform: "translate(-258.435 -923.5)",
    fill: "#bd8b5a"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1702",
    "data-name": "Caminho 1702",
    d: "M388.622,1344.8v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-279.553 -967.378)",
    fill: "#89560a"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1703",
    "data-name": "Caminho 1703",
    d: "M394.921,1352.861l-.381-.22v-1.45l-.216-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-283.654 -971.578)",
    fill: "#89560a"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1704",
    "data-name": "Caminho 1704",
    d: "M391.215,1350.721l-.381-.22v-1.449l-.217-.125.408-.424.407.895-.217-.125Z",
    transform: "translate(-280.988 -970.039)",
    fill: "#89560a"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1705",
    "data-name": "Caminho 1705",
    d: "M390.058,1355.453l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-280.586 -975.039)",
    fill: "#89560a"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1706",
    "data-name": "Caminho 1706",
    d: "M376.271,1337.672v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-270.668 -962.248)",
    fill: "#89560a"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1707",
    "data-name": "Caminho 1707",
    d: "M379.888,1343.288v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.595v-.084c0-.062.044-.088.1-.057l.315.182v-.683a1.559,1.559,0,0,1-.594-1.137v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.686.692.4v.711c0,.4-.258.588-.594.452",
    transform: "translate(-272.695 -964.873)",
    fill: "#89560a"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1708",
    "data-name": "Caminho 1708",
    d: "M363.869,1330.512v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-261.747 -957.097)",
    fill: "#89560a"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1709",
    "data-name": "Caminho 1709",
    d: "M366.791,1336.642a2.365,2.365,0,0,0-.365-.355.114.114,0,0,1,.006.034v.971a.323.323,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.061.061,0,0,1,.006-.027.924.924,0,0,0-.365-.067,1.657,1.657,0,0,0-.381-.368,1.376,1.376,0,0,0-.288-.091c.049-.474.485-.659,1.027-.378v-.236c0-.042.029-.059.066-.038a.145.145,0,0,1,.066.114v.234a2.372,2.372,0,0,1,1.027,1.567,2.644,2.644,0,0,0-.288-.241.659.659,0,0,0-.381-.072",
    transform: "translate(-262.757 -960.349)",
    fill: "#89560a"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1710",
    "data-name": "Caminho 1710",
    d: "M376.108,1271.363l15.015-8.669-16.844-9.776-15.015,8.669Z",
    transform: "translate(-258.435 -901.281)",
    fill: "#f0d9ac"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1711",
    "data-name": "Caminho 1711",
    d: "M397.971,1276.9l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-274.162 -910.361)",
    fill: "#bd8b5a"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1712",
    "data-name": "Caminho 1712",
    d: "M434.295,1305.09l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-301.606 -926.338)",
    fill: "#deb781"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1713",
    "data-name": "Caminho 1713",
    d: "M443.568,1355.949l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-317.105 -973.654)",
    fill: "#89560a"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1714",
    "data-name": "Caminho 1714",
    d: "M443.568,1302.8l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-317.105 -935.419)",
    fill: "#89560a"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1715",
    "data-name": "Caminho 1715",
    d: "M424.243,1338.46l16.647,9.662.2.115V1330.9l-16.844-9.776Z",
    transform: "translate(-305.177 -950.343)",
    fill: "#bd8b5a"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1716",
    "data-name": "Caminho 1716",
    d: "M453.6,1382.119v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-326.295 -994.221)",
    fill: "#89560a"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1717",
    "data-name": "Caminho 1717",
    d: "M459.9,1390.176l-.381-.22v-1.449l-.217-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-330.396 -998.42)",
    fill: "#89560a"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1718",
    "data-name": "Caminho 1718",
    d: "M456.194,1388.037l-.381-.22v-1.45l-.216-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-327.731 -996.881)",
    fill: "#89560a"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1719",
    "data-name": "Caminho 1719",
    d: "M455.036,1392.769l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-327.328 -1001.882)",
    fill: "#89560a"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1720",
    "data-name": "Caminho 1720",
    d: "M441.249,1374.988v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-317.41 -989.091)",
    fill: "#89560a"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1721",
    "data-name": "Caminho 1721",
    d: "M444.867,1380.6v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.595v-.084c0-.062.044-.088.1-.056l.315.182v-.683a1.558,1.558,0,0,1-.594-1.137v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.691.3.175-.2-.686.692.4v.711c0,.4-.258.588-.594.452",
    transform: "translate(-319.438 -991.716)",
    fill: "#89560a"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1722",
    "data-name": "Caminho 1722",
    d: "M428.847,1367.827v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-308.489 -983.94)",
    fill: "#89560a"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1723",
    "data-name": "Caminho 1723",
    d: "M431.769,1373.958a2.366,2.366,0,0,0-.365-.354.111.111,0,0,1,.006.034v.971a.323.323,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.03-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.06.06,0,0,1,.006-.027.926.926,0,0,0-.365-.067,1.658,1.658,0,0,0-.381-.367,1.376,1.376,0,0,0-.288-.091c.049-.474.485-.659,1.027-.378v-.235c0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114v.234a2.372,2.372,0,0,1,1.027,1.567,2.644,2.644,0,0,0-.288-.241.659.659,0,0,0-.381-.072",
    transform: "translate(-309.499 -987.192)",
    fill: "#89560a"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1724",
    "data-name": "Caminho 1724",
    d: "M441.086,1308.679l15.015-8.669-16.844-9.776-15.015,8.669Z",
    transform: "translate(-305.176 -928.123)",
    fill: "#f0d9ac"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1725",
    "data-name": "Caminho 1725",
    d: "M462.95,1314.217l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-320.904 -937.204)",
    fill: "#bd8b5a"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1726",
    "data-name": "Caminho 1726",
    d: "M499.274,1342.405l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-348.349 -953.181)",
    fill: "#deb781"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1727",
    "data-name": "Caminho 1727",
    d: "M508.546,1393.264l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-363.847 -1000.497)",
    fill: "#89560a"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1728",
    "data-name": "Caminho 1728",
    d: "M508.546,1340.11l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-363.847 -962.261)",
    fill: "#89560a"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1729",
    "data-name": "Caminho 1729",
    d: "M490.229,1377.794l16.647,9.662.2.114v-17.338l-16.844-9.776Z",
    transform: "translate(-352.643 -978.638)",
    fill: "#bd8b5a"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1730",
    "data-name": "Caminho 1730",
    d: "M519.586,1421.453v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-373.761 -1022.516)",
    fill: "#89560a"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1731",
    "data-name": "Caminho 1731",
    d: "M525.885,1429.51l-.381-.22v-1.45l-.217-.125.408-.424.407.895-.217-.125Z",
    transform: "translate(-377.862 -1026.715)",
    fill: "#89560a"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1732",
    "data-name": "Caminho 1732",
    d: "M522.18,1427.371l-.381-.22v-1.45l-.217-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-375.197 -1025.176)",
    fill: "#89560a"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1733",
    "data-name": "Caminho 1733",
    d: "M521.022,1432.1l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-374.794 -1030.177)",
    fill: "#89560a"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1734",
    "data-name": "Caminho 1734",
    d: "M507.235,1414.322v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-364.877 -1017.386)",
    fill: "#89560a"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1735",
    "data-name": "Caminho 1735",
    d: "M510.853,1419.938v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.595v-.084c0-.062.044-.088.1-.057l.315.182v-.683a1.559,1.559,0,0,1-.594-1.137v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.686.692.4v.711c0,.4-.258.588-.594.452",
    transform: "translate(-366.904 -1020.011)",
    fill: "#89560a"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1736",
    "data-name": "Caminho 1736",
    d: "M494.833,1407.162v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-355.955 -1012.235)",
    fill: "#89560a"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1737",
    "data-name": "Caminho 1737",
    d: "M497.755,1413.292a2.359,2.359,0,0,0-.365-.354.114.114,0,0,1,.006.034v.971a.322.322,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.062.062,0,0,1,.006-.028.924.924,0,0,0-.365-.067,1.662,1.662,0,0,0-.381-.367,1.369,1.369,0,0,0-.288-.091c.049-.474.485-.659,1.027-.378v-.235c0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114v.234a2.372,2.372,0,0,1,1.027,1.567,2.62,2.62,0,0,0-.288-.241.657.657,0,0,0-.381-.072",
    transform: "translate(-356.965 -1015.486)",
    fill: "#89560a"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1738",
    "data-name": "Caminho 1738",
    d: "M507.072,1348.014l15.015-8.669-16.844-9.776-15.015,8.669Z",
    transform: "translate(-352.643 -956.419)",
    fill: "#f0d9ac"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1739",
    "data-name": "Caminho 1739",
    d: "M528.936,1353.551l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-368.37 -965.499)",
    fill: "#bd8b5a"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1740",
    "data-name": "Caminho 1740",
    d: "M565.26,1381.74l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-395.816 -981.476)",
    fill: "#deb781"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1741",
    "data-name": "Caminho 1741",
    d: "M574.532,1432.6l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-411.313 -1028.792)",
    fill: "#89560a"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1742",
    "data-name": "Caminho 1742",
    d: "M574.532,1379.445l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-411.313 -990.556)",
    fill: "#89560a"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1743",
    "data-name": "Caminho 1743",
    d: "M324.431,1343.21l66.622,38.669V1379.6l-66.622-38.669Z",
    transform: "translate(-233.378 -964.595)",
    fill: "#8e9095"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1744",
    "data-name": "Caminho 1744",
    d: "M583.2,1437l-21.385,12.346v-2.276l21.385-12.347Z",
    transform: "translate(-404.137 -1032.061)",
    fill: "#9d9fa3"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1745",
    "data-name": "Caminho 1745",
    d: "M345.816,1449.134l66.622,38.669-21.385,12.346-66.622-38.669Z",
    transform: "translate(-233.378 -1042.427)",
    fill: "#bdbec1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1746",
    "data-name": "Caminho 1746",
    d: "M359.264,1455.173l16.647,9.662.2.115v-17.338l-16.844-9.776Z",
    transform: "translate(-258.435 -1034.3)",
    fill: "#bd8b5a"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1747",
    "data-name": "Caminho 1747",
    d: "M388.622,1498.832v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-279.553 -1078.178)",
    fill: "#89560a"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1748",
    "data-name": "Caminho 1748",
    d: "M394.921,1506.89l-.381-.22v-1.449l-.216-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-283.654 -1082.378)",
    fill: "#89560a"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1749",
    "data-name": "Caminho 1749",
    d: "M391.215,1504.75l-.381-.22v-1.449l-.217-.125.408-.424.407.895-.217-.125Z",
    transform: "translate(-280.988 -1080.839)",
    fill: "#89560a"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1750",
    "data-name": "Caminho 1750",
    d: "M390.058,1509.482l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-280.586 -1085.839)",
    fill: "#89560a"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1751",
    "data-name": "Caminho 1751",
    d: "M376.271,1491.7v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-270.668 -1073.048)",
    fill: "#89560a"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1752",
    "data-name": "Caminho 1752",
    d: "M379.888,1497.317V1498l.315.182a.216.216,0,0,1,.1.169v.084l-1.031-.595v-.084c0-.062.044-.088.1-.056l.315.182v-.683a1.56,1.56,0,0,1-.594-1.137v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.687.692.4v.712c0,.4-.258.588-.594.452",
    transform: "translate(-272.695 -1075.673)",
    fill: "#89560a"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1753",
    "data-name": "Caminho 1753",
    d: "M363.869,1484.541v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-261.747 -1067.898)",
    fill: "#89560a"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1754",
    "data-name": "Caminho 1754",
    d: "M366.791,1490.671a2.364,2.364,0,0,0-.365-.354.113.113,0,0,1,.006.034v.971a.322.322,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.062.062,0,0,1,.006-.028.924.924,0,0,0-.365-.067,1.662,1.662,0,0,0-.381-.367,1.383,1.383,0,0,0-.288-.091c.049-.474.485-.659,1.027-.378v-.235c0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114v.234a2.372,2.372,0,0,1,1.027,1.567,2.617,2.617,0,0,0-.288-.241.661.661,0,0,0-.381-.072",
    transform: "translate(-262.757 -1071.148)",
    fill: "#89560a"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1755",
    "data-name": "Caminho 1755",
    d: "M376.108,1425.392l15.015-8.669-16.844-9.777-15.015,8.669Z",
    transform: "translate(-258.435 -1012.081)",
    fill: "#f0d9ac"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1756",
    "data-name": "Caminho 1756",
    d: "M397.971,1430.93l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-274.162 -1021.161)",
    fill: "#bd8b5a"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1757",
    "data-name": "Caminho 1757",
    d: "M434.295,1459.119l-15.015,8.669V1450.45l15.015-8.669Z",
    transform: "translate(-301.606 -1037.138)",
    fill: "#deb781"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1758",
    "data-name": "Caminho 1758",
    d: "M443.568,1509.978l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-317.105 -1084.454)",
    fill: "#89560a"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1759",
    "data-name": "Caminho 1759",
    d: "M443.568,1456.824l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-317.105 -1046.219)",
    fill: "#89560a"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1760",
    "data-name": "Caminho 1760",
    d: "M424.243,1492.489l16.647,9.662.2.114v-17.338l-16.844-9.776Z",
    transform: "translate(-305.177 -1061.143)",
    fill: "#bd8b5a"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1761",
    "data-name": "Caminho 1761",
    d: "M453.6,1536.148v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-326.295 -1105.021)",
    fill: "#89560a"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1762",
    "data-name": "Caminho 1762",
    d: "M459.9,1544.205l-.381-.22v-1.45l-.217-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-330.396 -1109.22)",
    fill: "#89560a"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1763",
    "data-name": "Caminho 1763",
    d: "M456.194,1542.066l-.381-.22v-1.45l-.216-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-327.731 -1107.681)",
    fill: "#89560a"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1764",
    "data-name": "Caminho 1764",
    d: "M455.036,1546.8l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-327.328 -1112.681)",
    fill: "#89560a"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1765",
    "data-name": "Caminho 1765",
    d: "M441.249,1529.017v3.435l2.975,1.717v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-317.41 -1099.891)",
    fill: "#89560a"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1766",
    "data-name": "Caminho 1766",
    d: "M444.867,1534.633v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.6v-.084c0-.062.044-.088.1-.056l.315.182v-.683a1.559,1.559,0,0,1-.594-1.137v-.711l.389.224.14.44-.326-.188.587,1.13-.191-.69.3.175-.2-.687.692.4v.712c0,.4-.258.588-.594.452",
    transform: "translate(-319.438 -1102.516)",
    fill: "#89560a"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1767",
    "data-name": "Caminho 1767",
    d: "M428.847,1521.856v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-308.489 -1094.74)",
    fill: "#89560a"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1768",
    "data-name": "Caminho 1768",
    d: "M431.769,1527.987a2.373,2.373,0,0,0-.365-.354.113.113,0,0,1,.006.034v.971a.323.323,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.03-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.061.061,0,0,1,.006-.027.924.924,0,0,0-.365-.067,1.658,1.658,0,0,0-.381-.367,1.376,1.376,0,0,0-.288-.091c.049-.474.485-.659,1.027-.378v-.236c0-.042.029-.059.066-.038a.145.145,0,0,1,.066.114v.234a2.371,2.371,0,0,1,1.027,1.567,2.631,2.631,0,0,0-.288-.241.659.659,0,0,0-.381-.072",
    transform: "translate(-309.499 -1097.991)",
    fill: "#89560a"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1769",
    "data-name": "Caminho 1769",
    d: "M441.086,1462.708l15.015-8.669-16.844-9.777-15.015,8.669Z",
    transform: "translate(-305.176 -1038.923)",
    fill: "#f0d9ac"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1770",
    "data-name": "Caminho 1770",
    d: "M462.95,1468.245l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-320.904 -1048.003)",
    fill: "#bd8b5a"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1771",
    "data-name": "Caminho 1771",
    d: "M499.274,1496.434l-15.015,8.669v-17.338l15.015-8.669Z",
    transform: "translate(-348.349 -1063.981)",
    fill: "#deb781"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1772",
    "data-name": "Caminho 1772",
    d: "M508.546,1547.293l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-363.847 -1111.297)",
    fill: "#89560a"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1773",
    "data-name": "Caminho 1773",
    d: "M508.546,1494.139l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-363.847 -1073.061)",
    fill: "#89560a"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1774",
    "data-name": "Caminho 1774",
    d: "M490.229,1531.823l16.647,9.662.2.115v-17.338l-16.844-9.776Z",
    transform: "translate(-352.643 -1089.438)",
    fill: "#bd8b5a"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1775",
    "data-name": "Caminho 1775",
    d: "M519.586,1575.482v3.435l2.975,1.718V1577.2Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-373.761 -1133.315)",
    fill: "#89560a"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1776",
    "data-name": "Caminho 1776",
    d: "M525.885,1583.54l-.381-.22v-1.449l-.217-.125.408-.424.407.895-.217-.125Z",
    transform: "translate(-377.862 -1137.515)",
    fill: "#89560a"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1777",
    "data-name": "Caminho 1777",
    d: "M522.18,1581.4l-.381-.22v-1.45l-.217-.125.407-.424.407.895-.217-.125Z",
    transform: "translate(-375.197 -1135.976)",
    fill: "#89560a"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1778",
    "data-name": "Caminho 1778",
    d: "M521.022,1586.132l2.169,1.252v.283l-2.169-1.252Z",
    transform: "translate(-374.794 -1140.976)",
    fill: "#89560a"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1779",
    "data-name": "Caminho 1779",
    d: "M507.235,1568.351v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-364.877 -1128.186)",
    fill: "#89560a"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1780",
    "data-name": "Caminho 1780",
    d: "M510.853,1573.967v.683l.315.182a.216.216,0,0,1,.1.17v.084l-1.031-.595v-.084c0-.062.044-.088.1-.057l.315.182v-.683a1.56,1.56,0,0,1-.594-1.138V1572l.389.225.14.44-.326-.188.587,1.13-.191-.691.3.175-.2-.687.692.4v.712c0,.4-.258.588-.594.452",
    transform: "translate(-366.904 -1130.811)",
    fill: "#89560a"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1781",
    "data-name": "Caminho 1781",
    d: "M494.833,1561.191v3.435l2.975,1.718v-3.435Zm.139.24,2.7,1.557v3.115l-2.7-1.557Z",
    transform: "translate(-355.955 -1123.035)",
    fill: "#89560a"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1782",
    "data-name": "Caminho 1782",
    d: "M497.755,1567.321a2.37,2.37,0,0,0-.365-.354.115.115,0,0,1,.006.034v.971a.324.324,0,0,0,.146.253c.081.047.146.009.146-.084,0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114c0,.177-.125.249-.278.16a.614.614,0,0,1-.278-.481v-.971a.062.062,0,0,1,.006-.028.928.928,0,0,0-.365-.067,1.652,1.652,0,0,0-.381-.367,1.385,1.385,0,0,0-.288-.092c.049-.474.485-.659,1.027-.378v-.236c0-.042.029-.059.066-.038a.146.146,0,0,1,.066.114v.234a2.372,2.372,0,0,1,1.027,1.566,2.645,2.645,0,0,0-.288-.241.661.661,0,0,0-.381-.072",
    transform: "translate(-356.965 -1126.286)",
    fill: "#89560a"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1783",
    "data-name": "Caminho 1783",
    d: "M507.072,1502.042l15.015-8.669-16.844-9.776-15.015,8.669Z",
    transform: "translate(-352.643 -1067.218)",
    fill: "#f0d9ac"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1784",
    "data-name": "Caminho 1784",
    d: "M528.936,1507.58l2.743-1.584-16.844-9.776-2.743,1.584Z",
    transform: "translate(-368.37 -1076.298)",
    fill: "#bd8b5a"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1785",
    "data-name": "Caminho 1785",
    d: "M565.26,1535.769l-15.015,8.669V1527.1l15.015-8.669Z",
    transform: "translate(-395.816 -1092.276)",
    fill: "#deb781"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1786",
    "data-name": "Caminho 1786",
    d: "M574.532,1586.627l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-411.313 -1139.592)",
    fill: "#89560a"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1787",
    "data-name": "Caminho 1787",
    d: "M574.532,1533.474l-2.743,1.584v-2.42l2.743-1.584Z",
    transform: "translate(-411.313 -1101.356)",
    fill: "#89560a"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1788",
    "data-name": "Caminho 1788",
    d: "M324.431,1495.4l66.622,38.669v-2.276l-66.622-38.669Z",
    transform: "translate(-233.378 -1074.072)",
    fill: "#8e9095"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1789",
    "data-name": "Caminho 1789",
    d: "M583.2,1589.189l-21.385,12.346v-2.276l21.385-12.347Z",
    transform: "translate(-404.137 -1141.538)",
    fill: "#9d9fa3"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1790",
    "data-name": "Caminho 1790",
    d: "M546.86,1284.162l2.274-1.321,1.923,1.117-2.274,1.321Z",
    transform: "translate(-393.38 -922.805)",
    fill: "#bdbec1"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1791",
    "data-name": "Caminho 1791",
    d: "M555.984,1410.062l-2.274,1.321V1288.142l2.274-1.321Z",
    transform: "translate(-398.308 -925.669)",
    fill: "#9d9fa3"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1792",
    "data-name": "Caminho 1792",
    d: "M546.86,1410.789l1.923,1.117V1288.666l-1.923-1.117Z",
    transform: "translate(-393.38 -926.192)",
    fill: "#8e9095"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1793",
    "data-name": "Caminho 1793",
    d: "M316.329,1150.363l2.274-1.321,1.923,1.117-2.274,1.321Z",
    transform: "translate(-227.55 -826.558)",
    fill: "#bdbec1"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1794",
    "data-name": "Caminho 1794",
    d: "M325.454,1276.263l-2.274,1.321V1154.344l2.274-1.322Z",
    transform: "translate(-232.477 -829.421)",
    fill: "#9d9fa3"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1795",
    "data-name": "Caminho 1795",
    d: "M316.329,1276.99l1.923,1.117V1154.867l-1.923-1.117Z",
    transform: "translate(-227.55 -829.945)",
    fill: "#8e9095"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_513",
    "data-name": "Grupo 513",
    transform: "translate(346.871 299.349)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_512",
    "data-name": "Grupo 512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_511",
    "data-name": "Grupo 511",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_510",
    "data-name": "Grupo 510",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_509",
    "data-name": "Grupo 509",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_823",
    "data-name": "Ret\\xE2ngulo 823",
    width: 89.135,
    height: 94.179,
    transform: "matrix(0.504, -0.863, 0.863, 0.504, -26.126, 44.715)",
    fill: "url(#linear-gradient-32)"
  }))))))), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1797",
    "data-name": "Caminho 1797",
    d: "M1404.166,1052.96l-16.13,9.362-.191.111v-16.8l16.321-9.473Z",
    transform: "translate(-998.338 -745.357)",
    fill: "#bd8b5a"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1798",
    "data-name": "Caminho 1798",
    d: "M1407.282,1096.929v3.328l2.882-1.665v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1012.32 -787.874)",
    fill: "#89560a"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1799",
    "data-name": "Caminho 1799",
    d: "M1409.425,1103.071l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1013.711 -791.943)",
    fill: "#89560a"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1800",
    "data-name": "Caminho 1800",
    d: "M1413.016,1101l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1016.294 -790.451)",
    fill: "#89560a"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1801",
    "data-name": "Caminho 1801",
    d: "M1410.775,1105.583l-2.1,1.213v.274l2.1-1.213Z",
    transform: "translate(-1013.321 -795.297)",
    fill: "#89560a"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1802",
    "data-name": "Caminho 1802",
    d: "M1419.25,1090.019v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509V1090.1l2.614-1.509Z",
    transform: "translate(-1020.929 -782.903)",
    fill: "#89560a"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1803",
    "data-name": "Caminho 1803",
    d: "M1422.557,1093.8v.662l-.305.176a.21.21,0,0,0-.095.165v.081l1-.576v-.081c0-.061-.042-.085-.095-.055l-.305.176v-.661a1.511,1.511,0,0,0,.576-1.1v-.69l-.377.218-.136.426.316-.182-.569,1.1.185-.669-.293.169.2-.665-.671.387v.69c0,.391.25.57.576.438",
    transform: "translate(-1022.894 -785.446)",
    fill: "#89560a"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1804",
    "data-name": "Caminho 1804",
    d: "M1431.267,1083.08v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1029.574 -777.912)",
    fill: "#89560a"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1805",
    "data-name": "Caminho 1805",
    d: "M1433.276,1087.356a2.315,2.315,0,0,1,.354-.344.119.119,0,0,0-.005.033v.94a.313.313,0,0,1-.142.245c-.078.045-.142.008-.142-.082,0-.041-.028-.057-.064-.037a.141.141,0,0,0-.064.11c0,.171.121.241.269.156a.6.6,0,0,0,.269-.466v-.941a.062.062,0,0,0-.006-.027.9.9,0,0,1,.354-.065,1.617,1.617,0,0,1,.369-.356,1.338,1.338,0,0,1,.279-.089c-.048-.459-.47-.638-1-.366,0,0,0-.229,0-.229,0-.04-.029-.057-.064-.037a.141.141,0,0,0-.064.11v.227a2.3,2.3,0,0,0-1,1.518,2.568,2.568,0,0,1,.279-.233.639.639,0,0,1,.369-.07",
    transform: "translate(-1030.553 -781.062)",
    fill: "#89560a"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1806",
    "data-name": "Caminho 1806",
    d: "M1350.554,1024.1,1336,1015.7l16.321-9.473,14.549,8.4Z",
    transform: "translate(-961.047 -723.827)",
    fill: "#f0d9ac"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1807",
    "data-name": "Caminho 1807",
    d: "M1359.847,1029.469l-2.658-1.535,16.321-9.473,2.658,1.535Z",
    transform: "translate(-976.286 -732.625)",
    fill: "#bd8b5a"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1808",
    "data-name": "Caminho 1808",
    d: "M1336,1056.783l14.549,8.4v-16.8l-14.549-8.4Z",
    transform: "translate(-961.047 -748.107)",
    fill: "#deb781"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1809",
    "data-name": "Caminho 1809",
    d: "M1357.5,1106.063l2.658,1.535v-2.345l-2.658-1.534Z",
    transform: "translate(-976.508 -793.955)",
    fill: "#89560a"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1810",
    "data-name": "Caminho 1810",
    d: "M1357.5,1054.559l2.658,1.535v-2.345l-2.658-1.534Z",
    transform: "translate(-976.508 -756.906)",
    fill: "#89560a"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1811",
    "data-name": "Caminho 1811",
    d: "M1344.651,1087.5l-16.321,9.473v-16.8l16.321-9.473Z",
    transform: "translate(-955.526 -770.206)",
    fill: "#bd8b5a"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1812",
    "data-name": "Caminho 1812",
    d: "M1347.766,1131.472v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-969.508 -812.722)",
    fill: "#89560a"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1813",
    "data-name": "Caminho 1813",
    d: "M1349.91,1137.615l.37-.213V1136l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-970.899 -816.791)",
    fill: "#89560a"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1814",
    "data-name": "Caminho 1814",
    d: "M1353.5,1135.542l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-973.482 -815.3)",
    fill: "#89560a"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1815",
    "data-name": "Caminho 1815",
    d: "M1351.259,1140.127l-2.1,1.213v.275l2.1-1.213Z",
    transform: "translate(-970.509 -820.145)",
    fill: "#89560a"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1816",
    "data-name": "Caminho 1816",
    d: "M1359.734,1124.562v3.328l2.883-1.664V1122.9Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-978.117 -807.752)",
    fill: "#89560a"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1817",
    "data-name": "Caminho 1817",
    d: "M1363.041,1128.339V1129l-.305.176a.21.21,0,0,0-.095.164v.081l1-.577v-.081c0-.06-.042-.085-.095-.055l-.305.176v-.661a1.511,1.511,0,0,0,.576-1.1v-.69l-.377.218-.136.426.316-.182-.569,1.1.185-.669-.293.169.2-.665-.671.387v.69c0,.391.25.57.576.438",
    transform: "translate(-980.081 -810.295)",
    fill: "#89560a"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1818",
    "data-name": "Caminho 1818",
    d: "M1371.752,1117.624v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509V1117.7l2.614-1.509Z",
    transform: "translate(-986.762 -802.761)",
    fill: "#89560a"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1819",
    "data-name": "Caminho 1819",
    d: "M1373.76,1121.9a2.315,2.315,0,0,1,.354-.344.113.113,0,0,0-.005.033v.941a.313.313,0,0,1-.142.245c-.078.045-.142.009-.142-.082,0-.041-.028-.057-.064-.037a.141.141,0,0,0-.064.11c0,.171.121.241.269.155a.6.6,0,0,0,.269-.466v-.94a.061.061,0,0,0-.006-.027.9.9,0,0,1,.354-.065,1.61,1.61,0,0,1,.369-.356,1.335,1.335,0,0,1,.279-.089c-.047-.459-.47-.638-1-.366,0,0,0-.228,0-.228,0-.04-.029-.057-.064-.037a.141.141,0,0,0-.064.11v.227a2.3,2.3,0,0,0-1,1.518,2.571,2.571,0,0,1,.279-.233.637.637,0,0,1,.369-.07",
    transform: "translate(-987.74 -805.911)",
    fill: "#89560a"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1820",
    "data-name": "Caminho 1820",
    d: "M1291.038,1058.646l-14.549-8.4,16.321-9.473,14.549,8.4Z",
    transform: "translate(-918.235 -748.675)",
    fill: "#f0d9ac"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1821",
    "data-name": "Caminho 1821",
    d: "M1300.332,1064.012l-2.658-1.535,16.321-9.473,2.658,1.535Z",
    transform: "translate(-933.474 -757.474)",
    fill: "#bd8b5a"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1822",
    "data-name": "Caminho 1822",
    d: "M1276.489,1091.327l14.287,8.249.262.151v-16.8l-14.549-8.4Z",
    transform: "translate(-918.235 -772.956)",
    fill: "#deb781"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1823",
    "data-name": "Caminho 1823",
    d: "M1297.983,1140.607l2.658,1.535V1139.8l-2.658-1.535Z",
    transform: "translate(-933.696 -818.804)",
    fill: "#89560a"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1824",
    "data-name": "Caminho 1824",
    d: "M1297.983,1089.1l2.658,1.535v-2.345l-2.658-1.534Z",
    transform: "translate(-933.696 -781.755)",
    fill: "#89560a"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1825",
    "data-name": "Caminho 1825",
    d: "M1457.875,1083.968l-16.13,9.362-.191.111v-16.8l16.321-9.473Z",
    transform: "translate(-1036.973 -767.663)",
    fill: "#bd8b5a"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1826",
    "data-name": "Caminho 1826",
    d: "M1460.99,1127.937v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1050.955 -810.179)",
    fill: "#89560a"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1827",
    "data-name": "Caminho 1827",
    d: "M1463.134,1134.08l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1052.346 -814.248)",
    fill: "#89560a"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1828",
    "data-name": "Caminho 1828",
    d: "M1466.724,1132.007l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1054.929 -812.757)",
    fill: "#89560a"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1829",
    "data-name": "Caminho 1829",
    d: "M1464.483,1136.592l-2.1,1.213v.275l2.1-1.213Z",
    transform: "translate(-1051.956 -817.602)",
    fill: "#89560a"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1830",
    "data-name": "Caminho 1830",
    d: "M1472.958,1121.027v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509V1121.1l2.614-1.509Z",
    transform: "translate(-1059.564 -805.209)",
    fill: "#89560a"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1831",
    "data-name": "Caminho 1831",
    d: "M1476.265,1124.8v.662l-.305.176a.209.209,0,0,0-.095.164v.081l1-.577v-.081c0-.061-.042-.085-.095-.055l-.305.176v-.662a1.511,1.511,0,0,0,.576-1.1v-.69l-.377.218-.136.426.316-.182-.569,1.1.185-.669-.293.169.2-.665-.671.387v.69c0,.391.25.57.576.438",
    transform: "translate(-1061.528 -807.752)",
    fill: "#89560a"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1832",
    "data-name": "Caminho 1832",
    d: "M1484.976,1114.089v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1068.209 -800.218)",
    fill: "#89560a"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1833",
    "data-name": "Caminho 1833",
    d: "M1486.984,1118.365a2.318,2.318,0,0,1,.353-.344.118.118,0,0,0-.005.033v.94a.315.315,0,0,1-.141.246c-.078.045-.142.008-.142-.082,0-.041-.029-.057-.064-.037a.141.141,0,0,0-.063.11c0,.171.12.241.269.155a.6.6,0,0,0,.269-.466v-.94a.061.061,0,0,0-.006-.027.9.9,0,0,1,.354-.065,1.617,1.617,0,0,1,.369-.356,1.36,1.36,0,0,1,.279-.088c-.048-.459-.47-.638-1-.367,0,0,0-.228,0-.228,0-.04-.029-.057-.064-.037a.141.141,0,0,0-.064.111v.227a2.3,2.3,0,0,0-1,1.518,2.556,2.556,0,0,1,.278-.234.638.638,0,0,1,.369-.07",
    transform: "translate(-1069.188 -803.368)",
    fill: "#89560a"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1834",
    "data-name": "Caminho 1834",
    d: "M1404.262,1055.111l-14.55-8.4,16.321-9.473,14.549,8.4Z",
    transform: "translate(-999.682 -746.132)",
    fill: "#f0d9ac"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1835",
    "data-name": "Caminho 1835",
    d: "M1413.556,1060.477l-2.658-1.535,16.321-9.473,2.658,1.535Z",
    transform: "translate(-1014.921 -754.931)",
    fill: "#bd8b5a"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1836",
    "data-name": "Caminho 1836",
    d: "M1389.713,1087.792l14.549,8.4v-16.8l-14.549-8.4Z",
    transform: "translate(-999.682 -770.413)",
    fill: "#deb781"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1837",
    "data-name": "Caminho 1837",
    d: "M1411.207,1137.072l2.658,1.535v-2.345l-2.658-1.535Z",
    transform: "translate(-1015.144 -816.261)",
    fill: "#89560a"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1838",
    "data-name": "Caminho 1838",
    d: "M1411.207,1085.567l2.658,1.535v-2.345l-2.658-1.535Z",
    transform: "translate(-1015.144 -779.211)",
    fill: "#89560a"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1839",
    "data-name": "Caminho 1839",
    d: "M1398.359,1118.512l-16.321,9.473v-16.8l16.321-9.473Z",
    transform: "translate(-994.161 -792.512)",
    fill: "#bd8b5a"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1840",
    "data-name": "Caminho 1840",
    d: "M1401.475,1162.481v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1008.143 -835.029)",
    fill: "#89560a"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1841",
    "data-name": "Caminho 1841",
    d: "M1403.619,1168.624l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1009.534 -839.097)",
    fill: "#89560a"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1842",
    "data-name": "Caminho 1842",
    d: "M1407.209,1166.551l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1012.117 -837.606)",
    fill: "#89560a"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1843",
    "data-name": "Caminho 1843",
    d: "M1404.968,1171.136l-2.1,1.213v.274l2.1-1.213Z",
    transform: "translate(-1009.144 -842.451)",
    fill: "#89560a"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1844",
    "data-name": "Caminho 1844",
    d: "M1413.443,1155.571v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1016.752 -830.058)",
    fill: "#89560a"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1845",
    "data-name": "Caminho 1845",
    d: "M1416.75,1159.348v.662l-.305.176a.211.211,0,0,0-.094.165v.081l1-.576v-.081c0-.061-.042-.085-.095-.055l-.305.176v-.662a1.511,1.511,0,0,0,.576-1.1v-.69l-.377.218-.136.426.316-.183-.569,1.1.185-.669-.293.169.2-.665-.671.387v.69c0,.391.25.57.576.438",
    transform: "translate(-1018.717 -832.601)",
    fill: "#89560a"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1846",
    "data-name": "Caminho 1846",
    d: "M1425.46,1148.633v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1025.396 -825.067)",
    fill: "#89560a"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1847",
    "data-name": "Caminho 1847",
    d: "M1427.469,1152.909a2.315,2.315,0,0,1,.354-.344.114.114,0,0,0-.005.033v.941a.314.314,0,0,1-.142.245c-.078.045-.142.008-.142-.082,0-.041-.028-.057-.064-.037a.141.141,0,0,0-.064.11c0,.171.121.241.269.156a.6.6,0,0,0,.269-.466v-.94a.061.061,0,0,0-.006-.027.893.893,0,0,1,.354-.065,1.611,1.611,0,0,1,.369-.356,1.364,1.364,0,0,1,.279-.089c-.048-.459-.47-.638-1-.366,0,0,0-.229,0-.229,0-.04-.029-.057-.064-.037a.141.141,0,0,0-.064.11v.227a2.3,2.3,0,0,0-1,1.518,2.556,2.556,0,0,1,.279-.233.638.638,0,0,1,.369-.07",
    transform: "translate(-1026.376 -828.217)",
    fill: "#89560a"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1848",
    "data-name": "Caminho 1848",
    d: "M1344.747,1089.655l-14.549-8.4,16.321-9.473,14.55,8.4Z",
    transform: "translate(-956.87 -770.981)",
    fill: "#f0d9ac"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1849",
    "data-name": "Caminho 1849",
    d: "M1354.04,1095.021l-2.658-1.535,16.321-9.473,2.658,1.535Z",
    transform: "translate(-972.109 -779.78)",
    fill: "#bd8b5a"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1850",
    "data-name": "Caminho 1850",
    d: "M1330.2,1122.335l14.549,8.4v-16.8l-14.549-8.4Z",
    transform: "translate(-956.87 -795.262)",
    fill: "#deb781"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1851",
    "data-name": "Caminho 1851",
    d: "M1351.691,1171.616l2.658,1.535v-2.345l-2.658-1.535Z",
    transform: "translate(-972.331 -841.109)",
    fill: "#89560a"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1852",
    "data-name": "Caminho 1852",
    d: "M1351.691,1120.111l2.658,1.535V1119.3l-2.658-1.535Z",
    transform: "translate(-972.331 -804.06)",
    fill: "#89560a"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1853",
    "data-name": "Caminho 1853",
    d: "M1404.166,991.823l-16.13,9.362-.191.111V984.5l16.321-9.473Z",
    transform: "translate(-998.338 -701.378)",
    fill: "#bd8b5a"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1854",
    "data-name": "Caminho 1854",
    d: "M1407.282,1035.791v3.328l2.882-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1012.32 -743.895)",
    fill: "#89560a"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1855",
    "data-name": "Caminho 1855",
    d: "M1409.425,1041.934l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1013.711 -747.964)",
    fill: "#89560a"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1856",
    "data-name": "Caminho 1856",
    d: "M1413.016,1039.861l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1016.294 -746.473)",
    fill: "#89560a"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1857",
    "data-name": "Caminho 1857",
    d: "M1410.775,1044.446l-2.1,1.213v.275l2.1-1.213Z",
    transform: "translate(-1013.321 -751.318)",
    fill: "#89560a"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1858",
    "data-name": "Caminho 1858",
    d: "M1419.25,1028.881v3.328l2.883-1.664v-3.328Zm2.748,1.587-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1020.929 -738.924)",
    fill: "#89560a"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1859",
    "data-name": "Caminho 1859",
    d: "M1422.557,1032.658v.662l-.305.176a.21.21,0,0,0-.095.164v.081l1-.577v-.081c0-.061-.042-.085-.095-.055l-.305.176v-.662a1.511,1.511,0,0,0,.576-1.1v-.69l-.377.218-.136.426.316-.182-.569,1.1.185-.669-.293.169.2-.665-.671.387v.69c0,.391.25.57.576.438",
    transform: "translate(-1022.894 -741.467)",
    fill: "#89560a"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1860",
    "data-name": "Caminho 1860",
    d: "M1431.267,1021.943v3.328l2.883-1.664v-3.328Zm2.748,1.587-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1029.574 -733.933)",
    fill: "#89560a"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1861",
    "data-name": "Caminho 1861",
    d: "M1433.276,1026.219a2.309,2.309,0,0,1,.354-.344.118.118,0,0,0-.005.033v.94a.314.314,0,0,1-.142.246c-.078.045-.142.008-.142-.082,0-.041-.028-.057-.064-.037a.141.141,0,0,0-.064.11c0,.172.121.241.269.156a.6.6,0,0,0,.269-.466v-.94a.062.062,0,0,0-.006-.027.9.9,0,0,1,.354-.065,1.615,1.615,0,0,1,.369-.356,1.344,1.344,0,0,1,.279-.089c-.048-.459-.47-.638-1-.367,0,0,0-.228,0-.228,0-.04-.029-.057-.064-.037a.141.141,0,0,0-.064.11V1025a2.3,2.3,0,0,0-1,1.518,2.569,2.569,0,0,1,.279-.234.638.638,0,0,1,.369-.07",
    transform: "translate(-1030.553 -737.083)",
    fill: "#89560a"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1862",
    "data-name": "Caminho 1862",
    d: "M1350.554,962.965l-14.549-8.4,16.321-9.473,14.549,8.4Z",
    transform: "translate(-961.047 -679.848)",
    fill: "#f0d9ac"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1863",
    "data-name": "Caminho 1863",
    d: "M1359.847,968.331l-2.658-1.535,16.321-9.473,2.658,1.535Z",
    transform: "translate(-976.286 -688.647)",
    fill: "#bd8b5a"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1864",
    "data-name": "Caminho 1864",
    d: "M1336,995.646l14.549,8.4v-16.8l-14.549-8.4Z",
    transform: "translate(-961.047 -704.128)",
    fill: "#deb781"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1865",
    "data-name": "Caminho 1865",
    d: "M1357.5,1044.926l2.658,1.535v-2.345l-2.658-1.535Z",
    transform: "translate(-976.508 -749.976)",
    fill: "#89560a"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1866",
    "data-name": "Caminho 1866",
    d: "M1357.5,993.421l2.658,1.535v-2.345l-2.658-1.535Z",
    transform: "translate(-976.508 -712.926)",
    fill: "#89560a"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1867",
    "data-name": "Caminho 1867",
    d: "M1457.875,1022.831l-16.13,9.362-.191.111v-16.8l16.321-9.473Z",
    transform: "translate(-1036.973 -723.684)",
    fill: "#bd8b5a"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1868",
    "data-name": "Caminho 1868",
    d: "M1460.99,1066.8v3.328l2.883-1.664v-3.328Zm2.748,1.587-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1050.955 -766.201)",
    fill: "#89560a"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1869",
    "data-name": "Caminho 1869",
    d: "M1463.134,1072.943l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1052.346 -770.27)",
    fill: "#89560a"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1870",
    "data-name": "Caminho 1870",
    d: "M1466.724,1070.87l.37-.213v-1.4l.21-.121-.395-.411-.395.867.21-.121Z",
    transform: "translate(-1054.929 -768.779)",
    fill: "#89560a"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1871",
    "data-name": "Caminho 1871",
    d: "M1464.483,1075.455l-2.1,1.213v.275l2.1-1.213Z",
    transform: "translate(-1051.956 -773.624)",
    fill: "#89560a"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1872",
    "data-name": "Caminho 1872",
    d: "M1472.958,1059.89v3.328l2.883-1.664v-3.328Zm2.748,1.586-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1059.564 -761.23)",
    fill: "#89560a"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1873",
    "data-name": "Caminho 1873",
    d: "M1476.265,1063.667v.662l-.305.176a.21.21,0,0,0-.095.165v.081l1-.576v-.081c0-.061-.042-.085-.095-.055l-.305.176v-.661a1.511,1.511,0,0,0,.576-1.1v-.69l-.377.218-.136.426.316-.182-.569,1.1.185-.669-.293.169.2-.665-.671.387v.69c0,.391.25.57.576.438",
    transform: "translate(-1061.528 -763.773)",
    fill: "#89560a"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1874",
    "data-name": "Caminho 1874",
    d: "M1484.976,1052.952v3.328l2.883-1.664v-3.328Zm2.748,1.587-2.614,1.509v-3.018l2.614-1.509Z",
    transform: "translate(-1068.209 -756.239)",
    fill: "#89560a"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1875",
    "data-name": "Caminho 1875",
    d: "M1486.984,1057.228a2.324,2.324,0,0,1,.353-.344.118.118,0,0,0-.005.033v.941a.314.314,0,0,1-.141.245c-.078.045-.142.008-.142-.082,0-.041-.029-.057-.064-.037a.14.14,0,0,0-.063.11c0,.172.12.241.269.156a.6.6,0,0,0,.269-.466v-.94a.061.061,0,0,0-.006-.027.9.9,0,0,1,.354-.065,1.621,1.621,0,0,1,.369-.356,1.345,1.345,0,0,1,.279-.088c-.048-.459-.47-.638-1-.367,0,0,0-.228,0-.228,0-.04-.029-.057-.064-.037a.141.141,0,0,0-.064.11v.227a2.3,2.3,0,0,0-1,1.518,2.556,2.556,0,0,1,.278-.234.639.639,0,0,1,.369-.07",
    transform: "translate(-1069.188 -759.39)",
    fill: "#89560a"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1876",
    "data-name": "Caminho 1876",
    d: "M1404.262,993.974l-14.55-8.4,16.321-9.473,14.549,8.4Z",
    transform: "translate(-999.682 -702.154)",
    fill: "#f0d9ac"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1877",
    "data-name": "Caminho 1877",
    d: "M1413.556,999.34l-2.658-1.535,16.321-9.473,2.658,1.535Z",
    transform: "translate(-1014.921 -710.953)",
    fill: "#bd8b5a"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1878",
    "data-name": "Caminho 1878",
    d: "M1389.713,1026.654l14.549,8.4v-16.8l-14.549-8.4Z",
    transform: "translate(-999.682 -726.434)",
    fill: "#deb781"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1879",
    "data-name": "Caminho 1879",
    d: "M1411.207,1075.935l2.658,1.535v-2.345l-2.658-1.534Z",
    transform: "translate(-1015.144 -772.283)",
    fill: "#89560a"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1880",
    "data-name": "Caminho 1880",
    d: "M1411.207,1024.431l2.658,1.535v-2.345l-2.658-1.534Z",
    transform: "translate(-1015.144 -735.233)",
    fill: "#89560a"
  })))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_520",
    "data-name": "Grupo 520",
    transform: "translate(369 804.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1881",
    "data-name": "Caminho 1881",
    d: "M132.266,158.63l39.477,22.789v-1.409L132.266,157.22Z",
    transform: "translate(-99.39 -118.141)",
    fill: "#e6b467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1882",
    "data-name": "Caminho 1882",
    d: "M189,177.495l-35.184-20.313-4.276,2.485,35.184,20.314Z",
    transform: "translate(-112.368 -118.112)",
    fill: "#eec178"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1883",
    "data-name": "Caminho 1883",
    d: "M153.763,141.607,149.47,144.1V138.95l4.293-2.495Z",
    transform: "translate(-112.317 -102.537)",
    fill: "#ae7a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1884",
    "data-name": "Caminho 1884",
    d: "M132.278,141.64l4.276,2.485v-5.152l-4.276-2.485Z",
    transform: "translate(-99.398 -102.562)",
    fill: "#f3ca8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1885",
    "data-name": "Caminho 1885",
    d: "M141.617,317.192l4.276,2.485v-1.409l-4.276-2.485Z",
    transform: "translate(-106.416 -237.291)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1886",
    "data-name": "Caminho 1886",
    d: "M158.82,318.268v1.409l4.276-2.485v-1.409Z",
    transform: "translate(-119.343 -237.291)",
    fill: "#c48b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1887",
    "data-name": "Caminho 1887",
    d: "M55.9,155.028,17.2,177.517v-1.409l38.7-22.489Z",
    transform: "translate(-12.927 -115.435)",
    fill: "#ae7a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1888",
    "data-name": "Caminho 1888",
    d: "M141.617,247.79l4.276,2.485,38.7-22.491-4.277-2.485Z",
    transform: "translate(-106.416 -169.298)",
    fill: "#dcaf72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1889",
    "data-name": "Caminho 1889",
    d: "M158.82,257.792V259.2l38.7-22.489V235.3Z",
    transform: "translate(-119.343 -176.815)",
    fill: "#9d6016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1890",
    "data-name": "Caminho 1890",
    d: "M0,235.507l4.276,2.485v-1.409L0,234.1Z",
    transform: "translate(0 -175.91)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1891",
    "data-name": "Caminho 1891",
    d: "M0,166.106l4.276,2.485,38.7-22.491L38.7,143.615Z",
    transform: "translate(0 -107.917)",
    fill: "#d89c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1892",
    "data-name": "Caminho 1892",
    d: "M141.616,290.8l4.276,2.485v-1.409l-4.276-2.485Z",
    transform: "translate(-106.416 -217.456)",
    fill: "#f4cc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1893",
    "data-name": "Caminho 1893",
    d: "M56.731,254.373,21.547,234.059l-4.276,2.485,35.184,20.314Z",
    transform: "translate(-12.978 -175.881)",
    fill: "#f7d194"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1894",
    "data-name": "Caminho 1894",
    d: "M141.616,300.208l4.276,2.485v-5.152l-4.276-2.485Z",
    transform: "translate(-106.416 -221.716)",
    fill: "#f3ca8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1895",
    "data-name": "Caminho 1895",
    d: "M.011,218.517,4.287,221v-5.152L.011,213.366Z",
    transform: "translate(-0.008 -160.331)",
    fill: "#f3ca8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1896",
    "data-name": "Caminho 1896",
    d: "M207.75,261.769l4.276,2.485V259.1l-4.276-2.485Z",
    transform: "translate(-156.111 -192.832)",
    fill: "#f3ca8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1897",
    "data-name": "Caminho 1897",
    d: "M273.883,223.33l4.276,2.485v-5.152l-4.276-2.485Z",
    transform: "translate(-205.806 -163.947)",
    fill: "#f3ca8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1898",
    "data-name": "Caminho 1898",
    d: "M141.617,221.395l4.276,2.485,38.7-22.491-4.277-2.485Z",
    transform: "translate(-106.416 -149.463)",
    fill: "#d29c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1899",
    "data-name": "Caminho 1899",
    d: "M158.82,231.4v1.409l38.7-22.489v-1.409Z",
    transform: "translate(-119.343 -156.981)",
    fill: "#9d6016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1900",
    "data-name": "Caminho 1900",
    d: "M0,209.112,4.276,211.6v-1.409L0,207.7Z",
    transform: "translate(0 -156.075)",
    fill: "#f4cc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1901",
    "data-name": "Caminho 1901",
    d: "M0,139.71,4.276,142.2l38.7-22.491L38.7,117.22Z",
    transform: "translate(0 -88.083)",
    fill: "#d89c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1902",
    "data-name": "Caminho 1902",
    d: "M55.9,128.633,17.2,151.122v-1.409l38.7-22.489Z",
    transform: "translate(-12.927 -95.601)",
    fill: "#b7874c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1903",
    "data-name": "Caminho 1903",
    d: "M70.814,249.951l4.276,2.485v-1.409l-4.276-2.485Z",
    transform: "translate(-53.212 -186.763)",
    fill: "#f4cc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1904",
    "data-name": "Caminho 1904",
    d: "M70.814,180.549l38.7-22.491,4.276,2.485-38.7,22.491Z",
    transform: "translate(-53.212 -118.771)",
    fill: "#d89c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1905",
    "data-name": "Caminho 1905",
    d: "M126.716,169.472l-38.7,22.489v-1.409l38.7-22.489Z",
    transform: "translate(-66.14 -126.288)",
    fill: "#a7712e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1906",
    "data-name": "Caminho 1906",
    d: "M163.1,284.226l-4.276,2.485V285.3l4.276-2.485Z",
    transform: "translate(-119.344 -212.519)",
    fill: "#c48b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1907",
    "data-name": "Caminho 1907",
    d: "M164.639,296.6l-5.819,3.382V294.83l5.819-3.382Z",
    transform: "translate(-119.343 -219.005)",
    fill: "#b5854b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1908",
    "data-name": "Caminho 1908",
    d: "M21.5,218.485,17.2,220.98v-5.152l4.293-2.495Z",
    transform: "translate(-12.927 -160.306)",
    fill: "#ae7a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1909",
    "data-name": "Caminho 1909",
    d: "M92.31,259.324l-4.293,2.495v-5.152l4.293-2.495Z",
    transform: "translate(-66.139 -190.994)",
    fill: "#b7874c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1910",
    "data-name": "Caminho 1910",
    d: "M230.772,258.161l-5.819,3.382v-5.152l5.819-3.382Z",
    transform: "translate(-169.038 -190.121)",
    fill: "#b5854b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1911",
    "data-name": "Caminho 1911",
    d: "M291.086,217.952V223.1l5.82-3.382v-5.152Z",
    transform: "translate(-218.733 -161.236)",
    fill: "#b5854b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1912",
    "data-name": "Caminho 1912",
    d: "M186.177,270.813,181.9,273.3v-1.409l4.276-2.485Z",
    transform: "translate(-136.687 -202.44)",
    fill: "#bf8423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1913",
    "data-name": "Caminho 1913",
    d: "M209.258,257.4l-4.276,2.485v-1.409l4.276-2.485Z",
    transform: "translate(-154.031 -192.36)",
    fill: "#c48b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1914",
    "data-name": "Caminho 1914",
    d: "M232.339,243.986l-4.276,2.485v-1.409l4.276-2.485Z",
    transform: "translate(-171.374 -182.281)",
    fill: "#b48143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1915",
    "data-name": "Caminho 1915",
    d: "M255.42,230.573l-4.276,2.485v-1.409l4.276-2.485Z",
    transform: "translate(-188.718 -172.202)",
    fill: "#c48b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1916",
    "data-name": "Caminho 1916",
    d: "M278.5,217.16l-4.276,2.485v-1.409l4.276-2.485Z",
    transform: "translate(-206.063 -162.123)",
    fill: "#b48143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1917",
    "data-name": "Caminho 1917",
    d: "M297.306,204.823v1.409l4.276-2.485v-1.409Z",
    transform: "translate(-223.407 -152.044)",
    fill: "#a66d28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1918",
    "data-name": "Caminho 1918",
    d: "M138.486,113.138l39.474,22.79,4.278-2.486-39.474-22.791Z",
    transform: "translate(-104.063 -83.148)",
    fill: "#f9d59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1919",
    "data-name": "Caminho 1919",
    d: "M159.161,146.856l-39.474-22.79-4.276,2.485,39.474,22.791Z",
    transform: "translate(-86.724 -93.228)",
    fill: "#f9d59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1920",
    "data-name": "Caminho 1920",
    d: "M136.08,160.269l-39.474-22.79-4.276,2.485L131.8,162.755Z",
    transform: "translate(-69.38 -103.307)",
    fill: "#f6d093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1921",
    "data-name": "Caminho 1921",
    d: "M113,173.679l-39.474-22.79-4.278,2.486,39.474,22.79Z",
    transform: "translate(-52.036 -113.384)",
    fill: "#fedeac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1922",
    "data-name": "Caminho 1922",
    d: "M89.924,187.092,50.45,164.3l-4.276,2.485,39.474,22.791Z",
    transform: "translate(-34.697 -123.463)",
    fill: "#f9d69e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1923",
    "data-name": "Caminho 1923",
    d: "M66.843,200.506l-39.474-22.79L23.093,180.2l39.474,22.791Z",
    transform: "translate(-17.353 -133.542)",
    fill: "#f9d69e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1924",
    "data-name": "Caminho 1924",
    d: "M.011,193.613,39.485,216.4l4.276-2.485L4.287,191.128Z",
    transform: "translate(-0.008 -143.621)",
    fill: "#f9d69e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1925",
    "data-name": "Caminho 1925",
    d: "M138.486,122.063l39.477,22.789v-1.409l-39.477-22.789Z",
    transform: "translate(-104.063 -90.663)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1926",
    "data-name": "Caminho 1926",
    d: "M115.4,135.476l39.477,22.789v-1.409L115.4,134.067Z",
    transform: "translate(-86.72 -100.743)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1927",
    "data-name": "Caminho 1927",
    d: "M92.324,148.889,131.8,171.678v-1.409L92.324,147.48Z",
    transform: "translate(-69.376 -110.822)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1928",
    "data-name": "Caminho 1928",
    d: "M69.243,162.3l39.477,22.789v-1.409L69.243,160.893Z",
    transform: "translate(-52.032 -120.901)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1929",
    "data-name": "Caminho 1929",
    d: "M46.162,175.715,85.639,198.5V197.1L46.162,174.306Z",
    transform: "translate(-34.688 -130.98)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1930",
    "data-name": "Caminho 1930",
    d: "M23.081,189.129l39.477,22.789v-1.409L23.081,187.719Z",
    transform: "translate(-17.344 -141.059)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1931",
    "data-name": "Caminho 1931",
    d: "M0,202.542,39.477,225.33v-1.409L0,201.133Z",
    transform: "translate(0 -151.138)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1932",
    "data-name": "Caminho 1932",
    d: "M141.616,300.208l4.276,2.485v-5.152l-4.276-2.485Z",
    transform: "translate(-106.416 -221.716)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1933",
    "data-name": "Caminho 1933",
    d: "M70.814,259.363l4.276,2.485V256.7l-4.276-2.485Z",
    transform: "translate(-53.212 -191.023)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1934",
    "data-name": "Caminho 1934",
    d: "M.011,218.517,4.287,221v-5.152L.011,213.366Z",
    transform: "translate(-0.008 -160.331)",
    fill: "#e9ba71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1935",
    "data-name": "Caminho 1935",
    d: "M0,235.507,39.477,258.3v-1.409L0,234.1Z",
    transform: "translate(0 -175.91)",
    fill: "#e6b467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1936",
    "data-name": "Caminho 1936",
    d: "M174.938,118.056,159.019,127.3l-.189.109v-16.58l16.107-9.349Z",
    transform: "translate(-119.351 -76.253)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1937",
    "data-name": "Caminho 1937",
    d: "M180.489,168.979v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-135.626 -125.742)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1938",
    "data-name": "Caminho 1938",
    d: "M182.852,175.762l.365-.211v-1.386l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-137.246 -130.479)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1939",
    "data-name": "Caminho 1939",
    d: "M186.852,173.452l.365-.211v-1.386l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-140.252 -128.743)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1940",
    "data-name": "Caminho 1940",
    d: "M184.113,178.835l-2.074,1.2v.271l2.074-1.2Z",
    transform: "translate(-136.791 -134.383)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1941",
    "data-name": "Caminho 1941",
    d: "M193.825,161.279v3.285l2.845-1.643v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-145.647 -119.957)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_519",
    "data-name": "Grupo 519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_518",
    "data-name": "Grupo 518",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1942",
    "data-name": "Caminho 1942",
    d: "M197.436,165.457v.653l-.3.174a.207.207,0,0,0-.093.162v.081l.985-.569v-.081c0-.06-.042-.084-.093-.054l-.3.174v-.653a1.491,1.491,0,0,0,.568-1.087v-.681l-.372.215-.134.421.312-.18-.561,1.081.183-.66-.289.167.193-.657-.662.382v.681c0,.386.247.563.568.432",
    transform: "translate(-147.934 -122.917)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1943",
    "data-name": "Caminho 1943",
    d: "M207.216,153.549v3.285l2.845-1.643v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-155.71 -114.148)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1944",
    "data-name": "Caminho 1944",
    d: "M209.371,158.326a2.274,2.274,0,0,1,.349-.339.11.11,0,0,0-.006.033v.928a.309.309,0,0,1-.14.242c-.077.044-.14.008-.14-.081,0-.04-.028-.056-.063-.036a.139.139,0,0,0-.063.109c0,.169.119.238.265.153a.588.588,0,0,0,.265-.46v-.928a.06.06,0,0,0-.005-.026.887.887,0,0,1,.349-.064,1.584,1.584,0,0,1,.364-.351,1.306,1.306,0,0,1,.275-.087c-.047-.454-.464-.63-.983-.362v-.225c0-.04-.028-.056-.063-.036a.14.14,0,0,0-.063.109v.224a2.268,2.268,0,0,0-.983,1.5,2.549,2.549,0,0,1,.275-.23.628.628,0,0,1,.364-.069",
    transform: "translate(-156.849 -117.815)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1945",
    "data-name": "Caminho 1945",
    d: "M115.423,85.763l-14.359-8.29,16.107-9.349,14.359,8.29Z",
    transform: "translate(-75.944 -51.191)",
    fill: "#f0d9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1946",
    "data-name": "Caminho 1946",
    d: "M127.294,92.618,124.671,91.1l16.107-9.349,2.623,1.514Z",
    transform: "translate(-93.683 -61.433)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1947",
    "data-name": "Caminho 1947",
    d: "M101.065,122.316l14.359,8.29v-16.58l-14.359-8.29Z",
    transform: "translate(-75.944 -79.454)",
    fill: "#deb781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1948",
    "data-name": "Caminho 1948",
    d: "M125.015,179.071l2.623,1.514v-2.314l-2.623-1.514Z",
    transform: "translate(-93.941 -132.821)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1949",
    "data-name": "Caminho 1949",
    d: "M125.015,121.679l2.623,1.514v-2.314l-2.623-1.514Z",
    transform: "translate(-93.941 -89.695)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1950",
    "data-name": "Caminho 1950",
    d: "M108.62,156.548,92.513,165.9v-16.58l16.107-9.349Z",
    transform: "translate(-69.517 -105.177)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1951",
    "data-name": "Caminho 1951",
    d: "M114.171,207.471v3.284l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-85.792 -154.667)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1952",
    "data-name": "Caminho 1952",
    d: "M116.534,214.254l.365-.211v-1.386l.207-.12-.39-.406-.389.856.207-.12Z",
    transform: "translate(-87.412 -159.403)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1953",
    "data-name": "Caminho 1953",
    d: "M120.534,211.944l.365-.211v-1.386l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-90.418 -157.667)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1954",
    "data-name": "Caminho 1954",
    d: "M117.8,217.327l-2.074,1.2v.271l2.074-1.2Z",
    transform: "translate(-86.957 -163.307)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1955",
    "data-name": "Caminho 1955",
    d: "M127.507,199.771v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-95.813 -148.881)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1956",
    "data-name": "Caminho 1956",
    d: "M131.118,203.949v.653l-.3.174a.207.207,0,0,0-.093.162v.08l.985-.569v-.081c0-.06-.042-.084-.093-.054l-.3.174v-.653a1.49,1.49,0,0,0,.568-1.087v-.681l-.372.215-.134.421.311-.18-.561,1.081.183-.66-.289.167.193-.656-.662.382v.681c0,.386.247.563.568.432",
    transform: "translate(-98.1 -151.841)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1957",
    "data-name": "Caminho 1957",
    d: "M140.9,192.04v3.285l2.845-1.642V190.4Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-105.876 -143.072)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1958",
    "data-name": "Caminho 1958",
    d: "M143.053,196.818a2.284,2.284,0,0,1,.349-.339.11.11,0,0,0-.006.033v.928a.309.309,0,0,1-.14.242c-.077.044-.14.008-.14-.081,0-.04-.028-.056-.063-.036a.139.139,0,0,0-.063.109c0,.169.119.238.265.153a.588.588,0,0,0,.265-.46v-.928a.06.06,0,0,0-.005-.026.888.888,0,0,1,.349-.064,1.584,1.584,0,0,1,.364-.351,1.306,1.306,0,0,1,.275-.087c-.047-.454-.464-.63-.983-.362v-.225c0-.04-.028-.056-.063-.036a.14.14,0,0,0-.063.109v.224a2.268,2.268,0,0,0-.983,1.5,2.547,2.547,0,0,1,.275-.23.628.628,0,0,1,.364-.069",
    transform: "translate(-107.015 -146.739)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1959",
    "data-name": "Caminho 1959",
    d: "M49.105,124.255l-14.359-8.29,16.107-9.349,14.359,8.29Z",
    transform: "translate(-26.11 -80.116)",
    fill: "#f0d9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1960",
    "data-name": "Caminho 1960",
    d: "M60.976,131.11,58.353,129.6l16.107-9.349,2.623,1.514Z",
    transform: "translate(-43.849 -90.357)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1961",
    "data-name": "Caminho 1961",
    d: "M34.747,160.808l14.1,8.141.259.149v-16.58l-14.359-8.29Z",
    transform: "translate(-26.11 -108.379)",
    fill: "#deb781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1962",
    "data-name": "Caminho 1962",
    d: "M58.7,217.563l2.623,1.515v-2.314L58.7,215.249Z",
    transform: "translate(-44.107 -161.746)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1963",
    "data-name": "Caminho 1963",
    d: "M58.7,160.171l2.623,1.515v-2.314L58.7,157.857Z",
    transform: "translate(-44.107 -118.619)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1964",
    "data-name": "Caminho 1964",
    d: "M234.785,152.609l-15.919,9.239-.189.109v-16.58l16.107-9.349Z",
    transform: "translate(-164.323 -102.217)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1965",
    "data-name": "Caminho 1965",
    d: "M240.337,203.532v3.285l2.845-1.643v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-180.598 -151.707)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1966",
    "data-name": "Caminho 1966",
    d: "M242.7,210.314l.365-.211v-1.386l.207-.12-.39-.406-.389.856.207-.12Z",
    transform: "translate(-182.217 -156.443)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1967",
    "data-name": "Caminho 1967",
    d: "M246.7,208l.365-.211v-1.386l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-185.224 -154.707)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1968",
    "data-name": "Caminho 1968",
    d: "M243.961,213.388l-2.074,1.2v.271l2.074-1.2Z",
    transform: "translate(-181.762 -160.347)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1969",
    "data-name": "Caminho 1969",
    d: "M253.673,195.833v3.285l2.845-1.642V194.19Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-190.619 -145.921)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1970",
    "data-name": "Caminho 1970",
    d: "M257.284,200.01v.653l-.3.174a.207.207,0,0,0-.093.162v.08l.985-.569v-.081c0-.06-.042-.084-.094-.054l-.3.174V199.9a1.49,1.49,0,0,0,.568-1.087v-.681l-.372.215-.134.421.311-.18-.561,1.081.183-.66-.289.167.193-.656-.662.382v.681c0,.386.247.563.568.432",
    transform: "translate(-192.906 -148.881)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1971",
    "data-name": "Caminho 1971",
    d: "M267.063,188.1v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-200.681 -140.112)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1972",
    "data-name": "Caminho 1972",
    d: "M269.218,192.879a2.271,2.271,0,0,1,.349-.339.11.11,0,0,0-.006.033v.928a.309.309,0,0,1-.14.242c-.077.044-.14.008-.14-.081,0-.04-.028-.056-.063-.036a.139.139,0,0,0-.063.109c0,.169.119.238.265.153a.588.588,0,0,0,.265-.46V192.5a.058.058,0,0,0-.005-.026.884.884,0,0,1,.349-.064,1.585,1.585,0,0,1,.364-.351,1.3,1.3,0,0,1,.275-.087c-.047-.454-.464-.63-.983-.362v-.225c0-.04-.028-.056-.063-.036a.14.14,0,0,0-.063.109v.224a2.268,2.268,0,0,0-.983,1.5,2.555,2.555,0,0,1,.275-.23.629.629,0,0,1,.364-.069",
    transform: "translate(-201.82 -143.779)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1973",
    "data-name": "Caminho 1973",
    d: "M175.271,120.316l-14.359-8.29,16.107-9.349,14.359,8.29Z",
    transform: "translate(-120.915 -77.156)",
    fill: "#f0d9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1974",
    "data-name": "Caminho 1974",
    d: "M187.142,127.17l-2.623-1.514,16.107-9.349,2.623,1.514Z",
    transform: "translate(-138.654 -87.397)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1975",
    "data-name": "Caminho 1975",
    d: "M160.912,156.869l14.359,8.29v-16.58l-14.359-8.29Z",
    transform: "translate(-120.915 -105.419)",
    fill: "#deb781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1976",
    "data-name": "Caminho 1976",
    d: "M184.863,213.624l2.623,1.514v-2.314l-2.623-1.514Z",
    transform: "translate(-138.913 -158.786)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1977",
    "data-name": "Caminho 1977",
    d: "M184.863,156.232l2.623,1.515v-2.314l-2.623-1.514Z",
    transform: "translate(-138.913 -115.659)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1978",
    "data-name": "Caminho 1978",
    d: "M168.467,191.1,152.36,200.45V183.87l16.107-9.349Z",
    transform: "translate(-114.489 -131.142)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1979",
    "data-name": "Caminho 1979",
    d: "M174.019,242.023v3.285l2.845-1.643v-3.285Zm2.712,1.566-2.58,1.489V242.1l2.58-1.489Z",
    transform: "translate(-130.764 -180.631)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1980",
    "data-name": "Caminho 1980",
    d: "M176.381,248.806l.365-.211V247.21l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-132.383 -185.368)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1981",
    "data-name": "Caminho 1981",
    d: "M180.381,246.5l.365-.211V244.9l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-135.389 -183.632)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1982",
    "data-name": "Caminho 1982",
    d: "M177.643,251.88l-2.074,1.2v.271l2.074-1.2Z",
    transform: "translate(-131.929 -189.272)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1983",
    "data-name": "Caminho 1983",
    d: "M187.355,234.325v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489V234.4l2.58-1.489Z",
    transform: "translate(-140.785 -174.846)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1984",
    "data-name": "Caminho 1984",
    d: "M190.966,238.5v.653l-.3.174a.207.207,0,0,0-.093.162v.08l.985-.569v-.081c0-.06-.042-.084-.093-.054l-.3.174v-.653a1.49,1.49,0,0,0,.568-1.087v-.681l-.372.215-.134.421.312-.18-.561,1.081.183-.66-.289.167.193-.656-.662.382v.681c0,.386.247.563.568.432",
    transform: "translate(-143.072 -177.806)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1985",
    "data-name": "Caminho 1985",
    d: "M200.745,226.593v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489V226.67l2.58-1.489Z",
    transform: "translate(-150.847 -169.036)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1986",
    "data-name": "Caminho 1986",
    d: "M202.9,231.371a2.273,2.273,0,0,1,.349-.339.109.109,0,0,0-.006.033v.928a.309.309,0,0,1-.14.242c-.077.044-.14.008-.14-.081,0-.04-.028-.056-.063-.036a.139.139,0,0,0-.063.109c0,.169.119.238.265.153a.588.588,0,0,0,.265-.46v-.928a.06.06,0,0,0-.005-.026.888.888,0,0,1,.349-.064,1.584,1.584,0,0,1,.364-.351,1.3,1.3,0,0,1,.275-.087c-.047-.454-.464-.63-.983-.362v-.225c0-.04-.028-.056-.063-.036a.14.14,0,0,0-.063.109v.224a2.268,2.268,0,0,0-.983,1.5,2.521,2.521,0,0,1,.275-.23.628.628,0,0,1,.364-.069",
    transform: "translate(-151.986 -172.703)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1987",
    "data-name": "Caminho 1987",
    d: "M108.953,158.808l-14.359-8.29,16.107-9.349,14.359,8.29Z",
    transform: "translate(-71.082 -106.08)",
    fill: "#f0d9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1988",
    "data-name": "Caminho 1988",
    d: "M120.824,165.662l-2.623-1.514,16.107-9.349,2.623,1.514Z",
    transform: "translate(-88.82 -116.322)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1989",
    "data-name": "Caminho 1989",
    d: "M94.594,195.361l14.359,8.29v-16.58l-14.359-8.29Z",
    transform: "translate(-71.081 -134.343)",
    fill: "#deb781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1990",
    "data-name": "Caminho 1990",
    d: "M118.545,252.116l2.623,1.514v-2.314l-2.623-1.514Z",
    transform: "translate(-89.079 -187.71)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1991",
    "data-name": "Caminho 1991",
    d: "M118.545,194.724l2.623,1.514v-2.314l-2.623-1.514Z",
    transform: "translate(-89.079 -144.584)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1992",
    "data-name": "Caminho 1992",
    d: "M174.938,49.931,159.019,59.17l-.189.109V42.7l16.107-9.349Z",
    transform: "translate(-119.351 -25.061)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1993",
    "data-name": "Caminho 1993",
    d: "M180.489,100.854v3.285l2.845-1.643V99.211Zm2.712,1.566-2.58,1.489V100.93l2.58-1.489Z",
    transform: "translate(-135.626 -74.551)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1994",
    "data-name": "Caminho 1994",
    d: "M182.852,107.636l.365-.211v-1.386l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-137.246 -79.287)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1995",
    "data-name": "Caminho 1995",
    d: "M186.852,105.326l.365-.211V103.73l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-140.252 -77.551)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1996",
    "data-name": "Caminho 1996",
    d: "M184.113,110.71l-2.074,1.2v.271l2.074-1.2Z",
    transform: "translate(-136.791 -83.191)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1997",
    "data-name": "Caminho 1997",
    d: "M193.825,93.155v3.285L196.67,94.8V91.512Zm2.712,1.566-2.58,1.489V93.231l2.58-1.489Z",
    transform: "translate(-145.647 -68.765)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1998",
    "data-name": "Caminho 1998",
    d: "M197.436,97.332v.653l-.3.174a.207.207,0,0,0-.093.162v.08l.985-.569v-.081c0-.06-.042-.084-.093-.054l-.3.174v-.653a1.491,1.491,0,0,0,.568-1.087v-.681l-.372.215-.134.421.312-.18-.561,1.081.183-.66-.289.167.193-.656-.662.382V96.9c0,.386.247.563.568.432",
    transform: "translate(-147.934 -71.725)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1999",
    "data-name": "Caminho 1999",
    d: "M207.216,85.423v3.285l2.845-1.642V83.78Zm2.712,1.566-2.58,1.489V85.5l2.58-1.489Z",
    transform: "translate(-155.71 -62.955)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2000",
    "data-name": "Caminho 2000",
    d: "M209.371,90.2a2.273,2.273,0,0,1,.349-.339.11.11,0,0,0-.006.033v.928a.309.309,0,0,1-.14.242c-.077.044-.14.008-.14-.081,0-.04-.028-.056-.063-.036a.139.139,0,0,0-.063.109c0,.169.119.238.265.153a.588.588,0,0,0,.265-.46v-.928a.06.06,0,0,0-.005-.026.888.888,0,0,1,.349-.064,1.584,1.584,0,0,1,.364-.351,1.305,1.305,0,0,1,.275-.087c-.047-.454-.464-.63-.983-.362V88.7c0-.04-.028-.056-.063-.036a.14.14,0,0,0-.063.109V89a2.268,2.268,0,0,0-.983,1.5,2.519,2.519,0,0,1,.275-.23.628.628,0,0,1,.364-.069",
    transform: "translate(-156.849 -66.622)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2001",
    "data-name": "Caminho 2001",
    d: "M115.423,17.638l-14.359-8.29L117.172,0l14.359,8.29Z",
    transform: "translate(-75.944 0.001)",
    fill: "#f0d9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2002",
    "data-name": "Caminho 2002",
    d: "M127.294,24.492l-2.623-1.514,16.107-9.349,2.623,1.514Z",
    transform: "translate(-93.683 -10.241)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2003",
    "data-name": "Caminho 2003",
    d: "M101.065,54.191l14.359,8.29V45.9l-14.359-8.29Z",
    transform: "translate(-75.944 -28.262)",
    fill: "#deb781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2004",
    "data-name": "Caminho 2004",
    d: "M125.015,110.946l2.623,1.515v-2.314l-2.623-1.514Z",
    transform: "translate(-93.941 -81.63)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2005",
    "data-name": "Caminho 2005",
    d: "M125.015,53.555l2.623,1.514V52.755l-2.623-1.514Z",
    transform: "translate(-93.941 -38.504)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2006",
    "data-name": "Caminho 2006",
    d: "M234.785,84.484l-15.919,9.239-.189.109V77.253L234.785,67.9Z",
    transform: "translate(-164.323 -51.026)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2007",
    "data-name": "Caminho 2007",
    d: "M240.337,135.407v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-180.598 -100.515)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2008",
    "data-name": "Caminho 2008",
    d: "M242.7,142.189l.365-.211v-1.386l.207-.12-.39-.406-.389.856.207-.12Z",
    transform: "translate(-182.217 -105.251)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2009",
    "data-name": "Caminho 2009",
    d: "M246.7,139.879l.365-.211v-1.386l.207-.12-.389-.406-.389.856.207-.12Z",
    transform: "translate(-185.224 -103.516)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2010",
    "data-name": "Caminho 2010",
    d: "M243.961,145.263l-2.074,1.2v.271l2.074-1.2Z",
    transform: "translate(-181.762 -109.156)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2011",
    "data-name": "Caminho 2011",
    d: "M253.673,127.708v3.285l2.845-1.642v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-190.619 -94.73)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2012",
    "data-name": "Caminho 2012",
    d: "M257.284,131.885v.653l-.3.174a.207.207,0,0,0-.093.162v.08l.985-.569v-.081c0-.06-.042-.084-.094-.054l-.3.174v-.653a1.49,1.49,0,0,0,.568-1.087V130l-.372.215-.134.421.311-.18-.561,1.081.183-.66-.289.167.193-.656-.662.382v.681c0,.386.247.563.568.432",
    transform: "translate(-192.906 -97.69)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2013",
    "data-name": "Caminho 2013",
    d: "M267.063,119.976v3.285l2.845-1.643v-3.285Zm2.712,1.566-2.58,1.489v-2.979l2.58-1.489Z",
    transform: "translate(-200.681 -88.92)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2014",
    "data-name": "Caminho 2014",
    d: "M269.218,124.753a2.273,2.273,0,0,1,.349-.339.111.111,0,0,0-.006.033v.928a.309.309,0,0,1-.14.242c-.077.044-.14.008-.14-.081,0-.04-.028-.056-.063-.036a.139.139,0,0,0-.063.109c0,.169.119.238.265.153a.588.588,0,0,0,.265-.46v-.928a.06.06,0,0,0-.005-.026.888.888,0,0,1,.349-.064,1.585,1.585,0,0,1,.364-.351,1.3,1.3,0,0,1,.275-.087c-.047-.454-.464-.63-.983-.362v-.225c0-.04-.028-.056-.063-.036a.14.14,0,0,0-.063.109v.224a2.268,2.268,0,0,0-.983,1.5,2.524,2.524,0,0,1,.275-.23.629.629,0,0,1,.364-.069",
    transform: "translate(-201.82 -92.587)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2015",
    "data-name": "Caminho 2015",
    d: "M175.271,52.191,160.912,43.9l16.107-9.349,14.359,8.29Z",
    transform: "translate(-120.915 -25.964)",
    fill: "#f0d9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2016",
    "data-name": "Caminho 2016",
    d: "M187.142,59.045l-2.623-1.514,16.107-9.349,2.623,1.514Z",
    transform: "translate(-138.654 -36.206)",
    fill: "#bd8b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2017",
    "data-name": "Caminho 2017",
    d: "M160.912,88.744l14.359,8.29V80.454l-14.359-8.29Z",
    transform: "translate(-120.915 -54.227)",
    fill: "#deb781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2018",
    "data-name": "Caminho 2018",
    d: "M184.863,145.5l2.623,1.514V144.7l-2.623-1.514Z",
    transform: "translate(-138.913 -107.594)",
    fill: "#89560a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2019",
    "data-name": "Caminho 2019",
    d: "M184.863,88.107l2.623,1.515V87.307l-2.623-1.514Z",
    transform: "translate(-138.913 -64.468)",
    fill: "#89560a"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.aa2fddbd8bffff6cb97676920a693563.svg";
export { ForwardRef as ReactComponent };